import {
  Fall_Post_Fall_Review,
  Incident_Follow_up,
  Incident_Incontinence_Associated_Dermatitis_Inputs,
  IInitialSchema,
  Infection_Covid_First_Update_To_Family_Inputs,
  Infection_Covid_Ongoing_Update_Inputs,
  Nutritional_Change_In_Appetite_Values,
  Nutritional_Change_In_Diet_Values,
  Physiotherapist_Initial_Inputs,
  Physiotherapist_Mobility_Review_Inputs,
  Physiotherapist_Post_Fall_Inputs,
  Physiotherapist_SubSections,
  Referral_To_Specialist_General_Inputs,
  Resident_Of_The_Day_Inputs,
  Resident_Of_The_Day_SubSections,
  Social_Social_Inputs,
  Social_SubSections,
  SubSections,
  UpdatePriorities,
  Wound_Care_Healing_Inputs,
  Wound_Care_Review_Inputs,
  Wound_Care_SubSections,
  Vaccination_SubSections,
  Vaccination_Vaccination_Inputs,
  Nurse_Practitioner_SubSections,
  Nurse_Practitioner_GeneralReview_Inputs,
  Nurse_Practitioner_Deterioration_Inputs,
  Nurse_Practitioner_MedicationReview_Inputs, Nurse_Practitioner_ReviewPost_Inputs, Nurse_Practitioner_Other_Inputs
} from './updateFormModels';
import {deepClone, formatDate} from "@source/utils/utils";
import {
  Change_To_Condition_SubSections,
  ChangeToCondition_ChangeToAppetite_Inputs,
  ChangeToCondition_ChangeToBehaviourMood_Inputs,
  ChangeToCondition_ChangeToCognition_Inputs,
  ChangeToCondition_ChangeToMobility_Inputs,
  ChangeToCondition_OtherGeneralUpdate_Inputs,
  ChangeToCondition_WeightChangeUpdate_Inputs,
  Fall_Fall_Inputs,
  Fall_SubSections,
  GP_Review_Medication_Change_SubSections,
  GPReview_Deterioration_Inputs,
  GPReview_GeneralReview_Inputs,
  GPReview_MedicationReview_Inputs,
  GPReview_Other_Inputs,
  GPReview_ReviewPost_Inputs,
  Incident_Absconding_Inputs,
  Incident_Behavior_Inputs,
  Incident_Bruise_Inputs,
  Incident_Choking_Inputs,
  Incident_Other_Inputs,
  Incident_PressureInjury_Inputs,
  Incident_SkinTear_Inputs,
  Incident_SubSections,
  Incident_Ulcer_Inputs,
  Infection_Cellulitis_Inputs,
  Infection_EarNoseThroatENT_Inputs,
  Infection_Eye_Inputs,
  Infection_Other_Inputs,
  Infection_Respiratory_Inputs,
  Infection_Skin_Inputs,
  Infection_SubSections,
  Infection_Urinary_Inputs,
  Infection_Wound_Inputs,
  InputsName,
  IUpdateSchema,
  Medication_Incidents_SubSections,
  MedicationIncidents_MedicationIncidents_Inputs,
  Nutritional_Nutritional_Inputs,
  Nutritional_SubSections,
  Other_Other_Inputs,
  Other_SubSections,
  Pain_Pain_Inputs,
  Pain_SubSections,
  RadioBoolean,
  Referral_To_Allied_Health_Professiona_Inputs,
  Referral_To_Specialist_Inputs,
  Request_For_Items_Clothing_Footwear_Inputs,
  Request_For_Items_Food_Items_Inputs,
  Request_For_Items_Other_Inputs,
  Request_For_Items_Personal_Care_Items_Inputs,
  Request_For_Items_SubSections,
  Return_From_Hospital_Inputs,
  Return_From_Hospital_SubSections,
  Sections,
  Monthly_Care_Statement_SubSections,
  Specialist_Appointment_SubSections,
  UpdateInputsTypes,
  UpdateMessageSymbols
} from "@source/pages/HomePage/homeRouter/updateTab/updateSchema/updateFormModels";
import * as Yup from "yup";
import {IMainUpdateForm} from "@source/pages/HomePage/homeRouter/updateTab/updateTab";
import styles from "./updateForm.module.scss";
import {
  formatSummaryMessage,
  formattedFloat,
  getWeightGainOrLoss,
  getWeightPercentageChange,
  isImageFile
} from "@source/pages/HomePage/homeRouter/updateTab/updateSchema/updateFormUtils";
import moment from 'moment';
import nursingStore from "@source/store/nursingHomeStore";
import residentsStore from '@store/residentsStore';
import {PhoneCall, PhoneCallNames} from '../steps/mainStep.utils';
import {Gender} from "@source/api/models/residentModel";

const genderMapping = {
  [Gender.MALE]: 'his',
  [Gender.FEMALE]: 'her',
  [Gender.NONE]: 'their'
}

const genderMapping2 = {
  [Gender.MALE]: 'he',
  [Gender.FEMALE]: 'she',
  [Gender.NONE]: 'they'
}

const UpdateSchema:IUpdateSchema = {
  [Sections.Fall]: {
    [Fall_SubSections.General]: {
      message: (mainValues: IMainUpdateForm, inputsValues:any) => formatSummaryMessage(
        `Outline of ${mainValues.firstName}'s Fall: 
          ${inputsValues[Fall_Fall_Inputs.Describe_How_The_Resident_Fell]}. 
          ${UpdateMessageSymbols.Paragraph_Break}
          The fall was ${inputsValues[Fall_Fall_Inputs.Did_Anyone_See_The_Fall] === RadioBoolean.Yes ? 'witnessed' : 'unwitnessed'}.
          ${mainValues.firstName} 
            ${inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember 
            ? 'is unable to recall if ' + genderMapping2[mainValues.gender] + ' hit ' + genderMapping[mainValues.gender] + ' head.' : ''} 

            ${inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes 
            ? 'hit ' + genderMapping[mainValues.gender] + ' head when ' + genderMapping2[mainValues.gender] + ' fell.' : ''}

            ${inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_No 
              ? 'didn’t hit ' + genderMapping[mainValues.gender] + ' head.' : ''}
            
          ${(inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes || inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember)  && 
            inputsValues[Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed] === Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_Yes
            ? `Neuro observations have been completed. `
            : ``}
            
          ${(inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes || inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember) &&
            inputsValues[Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed] === Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No
            ? `${UpdateMessageSymbols.Line_Break}Neuro observations have not been completed. `
            : ``}
            
            ${(inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes || inputsValues[Fall_Fall_Inputs.Did_Resident_Hit_Their_Head] === Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember) &&
            inputsValues[Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed] === Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No 
            ? ` Reason: ${inputsValues[Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No_Reason]}${UpdateMessageSymbols.Line_Break}`
            : ''
            }

          ${inputsValues[Fall_Fall_Inputs.Resident_Takes_Blood_Thinners] === RadioBoolean.Yes 
            ? `${mainValues.firstName} takes blood thinning medication. ` 
            : ''} 

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Fall_Fall_Inputs.Was_The_Resident_Injured] === RadioBoolean.Yes
            ? `${inputsValues[Fall_Fall_Inputs.Injured_Type]?.includes(Fall_Fall_Inputs.Bruise)
                ? 
                  `Our team has observed bruising

                    ${inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise]?.front?.length || inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise]?.back?.length || inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise]?.additional
                      ? `${UpdateMessageSymbols.Line_Break}Location of the bruising:${` ${[...inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise].front, ...inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise].back].join(', ')}`}${inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise].additional ? `${ inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise]?.front?.length || inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise]?.back?.length ? ', ' : ''} ${inputsValues[Fall_Fall_Inputs.Bruise_Place_Bruise].additional}` : ''}.`
                      : ''}

                    ${UpdateMessageSymbols.Paragraph_Break}
      
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise] && inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.length
                      ? 'Our team has taken the immediate actions: '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.RN_Assessment_Of_Pain_Bruise)
                      ? `A nurse has conducted an Assessment of Pain on ${mainValues.firstName}. `
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.GP_Informed_Bruise)
                      ? 'The GP has been informed. '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.GP_Prescribed_Pain_Medication_Bruise)
                      ? 'The GP has prescribed pain medication. '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Clinical_Nurse_Specialist_Review_Of_Bruising_Bruise)
                      ? 'A clinical nurse specialist has reviewed the wound. '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Cream_Applied_Bruise)
                      ? 'Cream has been applied. '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Staff_Monitoring_Their_Condition_Bruise)
                      ? 'Our team is monitoring ' + genderMapping[mainValues.gender] + ' condition. '
                      : ''}
            
                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Nutritional_Supplements_Have_Been_Commenced_Bruise)
                      ? 'Nutritional supplements have been commenced. '
                      : ''}
                      
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Wound_Care_Chart_Commenced_Bruise)
                      ? 'Our team will continue to monitor his injury through regular review of his wound care plan. '
                      : ''}
                      
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Head_to_Toe_assessment_completed_Bruise)
                      ? 'The nurse has completed a head to toe assessment and no abnormalities were found. '
                      : ''}
                      
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Vital_Signs_assessment_completed_Bruise)
                      ? 'Vital signs were taken and no abnormalities were found. '
                      : ''}

                    ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise] && inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.length
                      ? UpdateMessageSymbols.Paragraph_Break
                      : ''}
                  `
                : ''}
              ${inputsValues[Fall_Fall_Inputs.Injured_Type]?.includes(Fall_Fall_Inputs.Skin_Tear)
                ? 
                  `Our team has observed skin tear.

                    ${inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear]?.front?.length || inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear]?.back?.length || inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear]?.additional
                      ? `${UpdateMessageSymbols.Line_Break}Location of the skin tear:${` ${[...inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear].front, ...inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear].back].join(', ')}`}${inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear].additional ? `${ inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear]?.front?.length || inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear]?.back?.length ? ', ' : ''} ${inputsValues[Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear].additional}` : ''}.`
                      : ''}
                    ${UpdateMessageSymbols.Paragraph_Break}
                
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear] && inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.length
                    ? 'Our team has taken the following actions: '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.RN_Assessment_Of_Pain_Skin_Tear)
                    ? `A nurse has conducted an Assessment of Pain on ${mainValues.firstName}. `
                    : ''}

                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Pain_Relief_Analygesic_Was_Given_Skin_Tear)
                    ? `Pain relief analgesic was given. ${inputsValues[Fall_Fall_Inputs.Pain_Relief_Was_Effective_Skin_Tear] === Fall_Fall_Inputs.Pain_Relief_Was_Effective_Yes_Skin_Tear
                          ? 'Pain relief was effective. '
                          : inputsValues[Fall_Fall_Inputs.Pain_Relief_Was_Effective_Skin_Tear] === Fall_Fall_Inputs.Pain_Relief_Was_Effective_No_Skin_Tear
                              ? `Pain relief wasn’t effective. `
                              : `${mainValues.firstName} is waiting for effect of pain relief. `}`
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.GP_Informed_Skin_Tear)
                    ? 'The GP has been informed. '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.GP_Prescribed_Pain_Medication_Skin_Tear)
                    ? 'The GP has prescribed pain medication. '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Clinical_Nurse_Specialist_Review_Of_Skin_Tear_Skin_Tear)
                    ? 'A clinical nurse specialist has reviewed the skin tear.'
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Dressing_Applied_Skin_Tear)
                    ? 'A dressing has been applied. '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Cream_Applied_Skin_Tear)
                    ? 'Cream has been applied. '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Staff_Monitoring_Their_Condition_Skin_Tear)
                    ? 'Our team is monitoring ' + genderMapping[mainValues.gender] + ' condition. '
                    : ''}
          
                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.includes(Fall_Fall_Inputs.Nutritional_Supplements_Have_Been_Commenced_Skin_Tear)
                    ? 'Nutritional supplements have been commenced. '
                    : ''}
                    
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Wound_Care_Chart_Commenced_Skin_Tear)
                      ? 'Our team will continue to monitor his injury through regular review of his wound care plan. '
                      : ''}
                      
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Head_to_Toe_assessment_completed_Skin_Tear)
                      ? 'The nurse has completed a head to toe assessment and no abnormalities were found. '
                      : ''}
                      
                      ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Bruise]?.includes(Fall_Fall_Inputs.Vital_Signs_assessment_completed_Skin_Tear)
                      ? 'Vital signs were taken and no abnormalities were found. '
                      : ''}

                  ${inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear] && inputsValues[Fall_Fall_Inputs.Actions_Taken_Skin_Tear]?.length
                    ? UpdateMessageSymbols.Paragraph_Break
                    : ''}
                    `
                : ''}

              ${inputsValues[Fall_Fall_Inputs.Injured_Type]?.includes(Fall_Fall_Inputs.Other)
                ? `Our team has observed injury: ${inputsValues[Fall_Fall_Inputs.Other_Injury_Other]}.${UpdateMessageSymbols.Paragraph_Break}`
                : ''}
                `
          : `${mainValues.firstName} was not injured. `}

          ${UpdateMessageSymbols.Paragraph_Break}

          
          ${inputsValues[Fall_Fall_Inputs.Further_Investigation] && inputsValues[Fall_Fall_Inputs.Further_Investigation]?.length
            ? `Following ${mainValues.firstName}’s fall, our team acted promptly to support them with the following steps, `
            : ''}

          ${inputsValues[Fall_Fall_Inputs.Further_Investigation]?.includes(Fall_Fall_Inputs.GP_Notified) || inputsValues[Fall_Fall_Inputs.Further_Investigation]?.includes(Fall_Fall_Inputs.Physio_Notified)
            ? `${inputsValues[Fall_Fall_Inputs.Further_Investigation]?.includes(Fall_Fall_Inputs.GP_Notified) ? `The GP, ` : ''}${inputsValues[Fall_Fall_Inputs.Further_Investigation]?.includes(Fall_Fall_Inputs.Physio_Notified) ? 'Physio' : ''} has been informed. `
            : ''}

          ${/* inputsValues[Fall_Fall_Inputs.Further_Investigation_Comments]
            ? `Further investigation comments: ${inputsValues[Fall_Fall_Inputs.Further_Investigation_Comments]}. `
            : '' */''}
          
          ${inputsValues[Fall_Fall_Inputs.Further_Investigation]?.includes(Fall_Fall_Inputs.Transfer_To_Hospital)
            ? `
             ${inputsValues[Fall_Fall_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                ? `${mainValues.firstName} has been transferred to ${inputsValues[Fall_Fall_Inputs.Hospital_Location]}.`
                : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
              }
            `
            : `We monitored ${mainValues.firstName} closely following the incident. ${mainValues.firstName} continued to receive care at ${mainValues.home} without needing a hospital transfer. `}
         
          ${inputsValues[Fall_Fall_Inputs.Further_Investigation].includes(Fall_Fall_Inputs.Family_Says_No_To_Transfer_To_Hospital) ?
            `${UpdateMessageSymbols.Paragraph_Break} I spoke with ${inputsValues[Fall_Fall_Inputs.Family_Member_Who_Said_No_To_Transfer]}, who chose for ${mainValues.firstName} not to go to hospital.
             ${UpdateMessageSymbols.Line_Break} Reason: ${inputsValues[Fall_Fall_Inputs.No_To_Transfer_Reason]}
            `
            : ``}
            
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Fall_Fall_Inputs.How_Is_The_Resident_Feeling]
            ? `How is ${mainValues.firstName}? ${inputsValues[Fall_Fall_Inputs.How_Is_The_Resident_Feeling]}. `
            : ''}
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Fall_Fall_Inputs.Other_Information]
            ? `Further information: ${inputsValues[Fall_Fall_Inputs.Other_Information]}. `
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Fall_Fall_Inputs.Other_Information]
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
           ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. ` 
            : ''
            }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Fall_Fall_Inputs.Describe_How_The_Resident_Fell,
              label: 'Describe how the resident fell',
              placeholder: 'Write how the resident fell',
              required: true,
              validationSchema: Yup.string().required('Describe how the resident fell')
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Fall_Fall_Inputs.Was_The_Resident_Injured,
              value: undefined,
              label: 'Was the resident injured?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.CheckboxInput,
                    value: undefined,
                    name: Fall_Fall_Inputs.Injured_Type,
                    label: 'Injury Type:',
                    className: styles.padding_1,
                    checkboxes: [
                      {
                        value: Fall_Fall_Inputs.Bruise, 
                        label: 'Bruise', 
                      },
                      {
                        value: Fall_Fall_Inputs.Skin_Tear, 
                        label: 'Skin tear', 
                      },
                      {
                        value: Fall_Fall_Inputs.Other, 
                        label: 'Other', 
                      },
                    ],
                    dependentInputs: {
                      [Fall_Fall_Inputs.Bruise]: [
                        {
                          type: UpdateInputsTypes.HumanInput,
                          name: Fall_Fall_Inputs.Bruise_Place_Bruise,
                          headerType: 'bruise',
                          className: `${styles.margin_1} ${styles.humanInput}`,
                        },
                        {
                          type: UpdateInputsTypes.CheckboxInput,
                          name: Fall_Fall_Inputs.Actions_Taken_Bruise,
                          label: 'Immediate Actions Taken (select all that apply):',
                          className: styles.padding_1,
                          checkboxes: [
                            {
                              value: Fall_Fall_Inputs.RN_Assessment_Of_Pain_Bruise, 
                              label: 'RN Assessment of Pain', 
                            },
                            {
                              value: Fall_Fall_Inputs.Cream_Applied_Bruise, 
                              label: 'Cream applied ', 
                            },
                            {
                              value: Fall_Fall_Inputs.Wound_Care_Chart_Commenced_Bruise,
                              label: 'Wound Care Chart Commenced ',
                            },
                            {
                              value: Fall_Fall_Inputs.Head_to_Toe_assessment_completed_Bruise,
                              label: 'Head to Toe assessment completed ',
                            },
                            {
                              value: Fall_Fall_Inputs.Vital_Signs_assessment_completed_Bruise,
                              label: 'Vital Signs assessment completed ',
                            },
                          ]
                        },
                      ],
                      [Fall_Fall_Inputs.Skin_Tear]: [
                        {
                          type: UpdateInputsTypes.HumanInput,
                          name: Fall_Fall_Inputs.Skin_Tear_Place_Skin_Tear,
                          headerType: 'skin tear',
                          className: `${styles.margin_1} ${styles.humanInput}`,
                        },
                        {
                          type: UpdateInputsTypes.CheckboxInput,
                          name: Fall_Fall_Inputs.Actions_Taken_Skin_Tear,
                          label: 'Immediate Actions Taken (select all that apply):',
                          className: styles.padding_1,
                          checkboxes: [
                            {
                              value: Fall_Fall_Inputs.RN_Assessment_Of_Pain_Skin_Tear, 
                              label: 'RN Assessment of Pain', 
                            },
                            {
                              value: Fall_Fall_Inputs.Pain_Relief_Analygesic_Was_Given_Skin_Tear, 
                              label: 'Pain relief analgesic was given', 
                            },
                            {
                              value: Fall_Fall_Inputs.Cream_Applied_Skin_Tear, 
                              label: 'Cream applied ', 
                            },
                            {
                              value: Fall_Fall_Inputs.Dressing_Applied_Skin_Tear, 
                              label: 'Dressing applied', 
                            },
                            {
                              value: Fall_Fall_Inputs.Wound_Care_Chart_Commenced_Skin_Tear,
                              label: 'Wound Care Chart Commenced ',
                            },
                            {
                              value: Fall_Fall_Inputs.Head_to_Toe_assessment_completed_Skin_Tear,
                              label: 'Head to Toe assessment completed ',
                            },
                            {
                              value: Fall_Fall_Inputs.Vital_Signs_assessment_completed_Skin_Tear,
                              label: 'Vital Signs assessment completed ',
                            },
                          ],
                          dependentInputs: {
                            [Fall_Fall_Inputs.Pain_Relief_Analygesic_Was_Given_Skin_Tear]: [
                              {
                                type: UpdateInputsTypes.RadioInput,
                                radios: [
                                  {value: Fall_Fall_Inputs.Pain_Relief_Was_Effective_Yes_Skin_Tear, label: 'Yes'},
                                  {value: Fall_Fall_Inputs.Pain_Relief_Was_Effective_No_Skin_Tear, label: 'No'},
                                  {value: Fall_Fall_Inputs.Pain_Relief_Was_Effective_Waiting_Skin_Tear, label: 'Waiting for effect '},
                                ],
                                name: Fall_Fall_Inputs.Pain_Relief_Was_Effective_Skin_Tear,
                                value: undefined,
                                label: 'Pain relief was effective',
                                className: styles.padding_1,
                                required: true,
                              },
                            ]
                          }
                        },
                      ],
                      [Fall_Fall_Inputs.Other]: [
                        {
                          type: UpdateInputsTypes.TextInput,
                          multiline: true,
                          value: undefined,
                          className: `${styles.padding_1} ${styles.fullWidth}`,
                          name: Fall_Fall_Inputs.Other_Injury_Other,
                          label: 'Other injury',
                          placeholder: 'Write Other injury',
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Fall_Fall_Inputs.Further_Investigation,
              label: 'Additional Actions Taken (select all that apply):',
              checkboxes: [
                {
                  value: Fall_Fall_Inputs.Transfer_To_Hospital, 
                  label: 'Transfer to hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Medium,
                    },
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Fall_Fall_Inputs.Resident_Says_No_To_Transfer_To_Hospital,
                  label: 'Resident said no to transfer to hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Medium,
                    },
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Fall_Fall_Inputs.Family_Says_No_To_Transfer_To_Hospital,
                  label: 'Family member said no to transfer to hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Medium,
                    },
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Fall_Fall_Inputs.GP_Notified, 
                  label: 'GP Notified', 
                },
                {
                  value: Fall_Fall_Inputs.Physio_Notified,
                  label: 'Physio notified', 
                },
                {
                  value: Fall_Fall_Inputs.Delirium_Screening_Undertaken,
                  label: 'Delirium Screening Undertaken'
                },
                {
                  value: Fall_Fall_Inputs.Care_Plan_Updated,
                  label: 'Care Plan Updated'
                }
              ],
/*               dependentInputs: {
                [Fall_Fall_Inputs.Further_Investigation_Required]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    value: undefined,
                    className: styles.padding_1,
                    name: Fall_Fall_Inputs.Further_Investigation_Comments,
                    label: 'Comments',
                    placeholder: 'Write comments',
                  },
                ],
              } */
            },
            {
              conditions: [
                {[Fall_Fall_Inputs.Further_Investigation]: Fall_Fall_Inputs.Family_Says_No_To_Transfer_To_Hospital},
              ],
              type: UpdateInputsTypes.TextInput,
              name: Fall_Fall_Inputs.Family_Member_Who_Said_No_To_Transfer,
              label: 'Name of family member who said no to transfer to hospital',
              placeholder: 'Write the name of the family member who said no to transfer to hospital',
              validationSchema: Yup.string().required('Name of family member is required'),
            },
            {
              conditions: [
                {[Fall_Fall_Inputs.Further_Investigation]: Fall_Fall_Inputs.Family_Says_No_To_Transfer_To_Hospital},
              ],
              type: UpdateInputsTypes.TextInput,
              name: Fall_Fall_Inputs.No_To_Transfer_Reason,
              label: 'Reason family member said no to transfer to hospital',
              placeholder: 'Write the reason the family member said no to transfer to hospital',
              validationSchema: Yup.string().required('Reason is required'),
            },
            {
              conditions: [
                {[Fall_Fall_Inputs.Further_Investigation]: Fall_Fall_Inputs.Transfer_To_Hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Fall_Fall_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Fall_Fall_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes, label: 'Yes'},
                {value: Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_No, label: 'No'},
                {value: Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember, label: 'Resident unable to recall'},
              ],
              name: Fall_Fall_Inputs.Did_Resident_Hit_Their_Head,
              value: undefined,
              label: 'Did resident hit their head?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Yes]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    className: styles.padding_1,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    radios: [
                      {value: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_Yes, label: 'Yes'},
                      {value: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No, label: 'No'},
                    ],
                    name: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed,
                    value: undefined,
                    label: 'Neuro observations have been completed',
                    dependentInputs: {
                      [Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No]: [
                          {
                            type: UpdateInputsTypes.TextInput,
                            name: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No_Reason,
                            label: 'Reason Neuro Observations Have Not Been Completed',
                            placeholder: 'Details why neuro observations were not completed',
                            validationSchema: Yup.string().required('Reason is required'),
                          }
                      ]
                    }
                  },
                ],
                [Fall_Fall_Inputs.Did_Resident_Hit_Their_Head_Not_Remember]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    className: styles.padding_1,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    radios: [
                      {value: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_Yes, label: 'Yes'},
                      {value: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No, label: 'No'},
                    ],
                    name: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed,
                    value: undefined,
                    label: 'Neuro observations have been completed',
                    dependentInputs: {
                      [Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No]: [
                        {
                          type: UpdateInputsTypes.TextInput,
                          name: Fall_Fall_Inputs.Neuro_Observations_Have_Been_Completed_No_Reason,
                          label: 'Reason Neuro Observations Have Not Been Completed',
                          placeholder: 'Details why neuro observations were not completed',
                          validationSchema: Yup.string().required('Reason is required'),
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Witnessed'},
                {value: RadioBoolean.No, label: 'Unwitnessed'},
              ],
              name: Fall_Fall_Inputs.Did_Anyone_See_The_Fall,
              value: undefined,
              label: 'Was fall Witnessed or Unwitnessed?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Fall_Fall_Inputs.Resident_Takes_Blood_Thinners,
              value: undefined,
              label: 'Do they take blood thinning medication?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Fall_Fall_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Fall_Fall_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Fall_SubSections.Post_Fall_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues:any) => formatSummaryMessage(
          `${inputsValues[Fall_Post_Fall_Review.How_Is_The_Resident_Feeling]
              ? `How is ${mainValues.firstName}? ${inputsValues[Fall_Post_Fall_Review.How_Is_The_Resident_Feeling]}. `
              : ''}
          ${UpdateMessageSymbols.Paragraph_Break}
          
          ${inputsValues[Fall_Fall_Inputs.Further_Investigation] && inputsValues[Fall_Fall_Inputs.Further_Investigation]?.length
              ? `Our team continue to monitor ${mainValues.firstName} post fall and the additional actions have been taken: `
              : ''}
              
          ${inputsValues[Fall_Post_Fall_Review.Further_Investigation]?.includes(Fall_Post_Fall_Review.Vital_Signs_Normal)
              ? 'Vital signs taken and within normal parameters. '
              : ''}
              
          ${inputsValues[Fall_Post_Fall_Review.Further_Investigation]?.includes(Fall_Post_Fall_Review.Vital_Signs)
              ? `Vital Signs taken and are out of normal parameters. ${inputsValues[Fall_Post_Fall_Review.Vital_Sign_Description]}. `
              : ''}

          ${inputsValues[Fall_Post_Fall_Review.Further_Investigation]?.includes(Fall_Post_Fall_Review.Injury_was_reviewed)
              ? 'Injury was reviewed. '
              : ''} 

          ${inputsValues[Fall_Post_Fall_Review.Further_Investigation]?.includes(Fall_Post_Fall_Review.Other)
              ? `${inputsValues[Fall_Post_Fall_Review.Other_Actions]}. `
              : ''}
              
          ${inputsValues[Fall_Post_Fall_Review.Further_Investigation]?.includes(Fall_Post_Fall_Review.Transfer_To_Hospital)
              ? `
             ${inputsValues[Fall_Post_Fall_Review.Hospital_Location_Is_Known] === RadioBoolean.Yes
                  ? `${mainValues.firstName} has been transferred to ${inputsValues[Fall_Post_Fall_Review.Hospital_Location]} for further investigation.`
                  : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
              }
            `
              : ``}
  
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Fall_Post_Fall_Review.Other_Information]
              ? `Further information: ${inputsValues[Fall_Post_Fall_Review.Other_Information]}. `
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Fall_Post_Fall_Review.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
           ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Fall_Post_Fall_Review.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Fall_Post_Fall_Review.Further_Investigation,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Fall_Post_Fall_Review.Transfer_To_Hospital,
                  label: 'Transfer to hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Fall_Post_Fall_Review.Vital_Signs_Normal,
                  label: 'Vital signs taken and within normal parameters',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Low,
                    },
                  ]
                },
                {
                  value: Fall_Post_Fall_Review.Vital_Signs,
                  label: 'Vital Signs taken and are out of normal parameters',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Medium,
                    },
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Fall_Post_Fall_Review.Injury_was_reviewed,
                  label: 'Injury was reviewed',
                },
                {
                  value: Fall_Post_Fall_Review.Other,
                  label: 'Other',
                },
              ],
              dependentInputs: {
                  [Fall_Post_Fall_Review.Other]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      value: undefined,
                      className: `${styles.padding_1} ${styles.fullWidth}`,
                      name: Fall_Post_Fall_Review.Other_Actions,
                      label: 'Other Actions',
                      placeholder: 'Describe the other actions taken',
                    }
                  ],
                  [Fall_Post_Fall_Review.Vital_Signs]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      value: undefined,
                      className: `${styles.padding_1} ${styles.fullWidth}`,
                      name: Fall_Post_Fall_Review.Vital_Sign_Description,
                      label: 'Describe the out of range vital signs and action taken',
                      placeholder: 'Describe the out of range vital signs and actions taken',
                    }
                  ]
              }
            },
            {
              conditions: [
                {[Fall_Post_Fall_Review.Further_Investigation]: Fall_Post_Fall_Review.Transfer_To_Hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Fall_Post_Fall_Review.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Fall_Post_Fall_Review.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Fall_Post_Fall_Review.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
  },
  [Sections.Infection]: {
    [Infection_SubSections.Urinary_Infection]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a urinary tract infection.
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken] && inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.length
            ? 'Our team has taken the following actions: '
            : ''}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.includes(Infection_Urinary_Inputs.GP_Prescribed_Antibiotics)
            ? 'The GP has ordered to commence antibiotics. '
            : ''}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.includes(Infection_Urinary_Inputs.Urine_Test_Taken_And_Sent_To_Pathology)
            ? 'Urine Test has been taken and sent to pathology. We are waiting for the results. '
            : ''}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.includes(Infection_Urinary_Inputs.GP_Informed)
            ? 'The GP has been informed. '
            : ''}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.includes(Infection_Urinary_Inputs.Fluids_Increased)
            ? 'The level of fluids is increased. '
            : ''}

          ${inputsValues[Infection_Urinary_Inputs.Actions_Taken]?.includes(Infection_Urinary_Inputs.Managing_Symptoms_With_Common_UTI_Treatment_Approaches)
            ? 'Symptoms are being managed with common urinary infection treatment approaches. '
            : ''}

          Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Infection_Urinary_Inputs.How_Is_The_Resident_Feeling]
            ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Urinary_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
            : ''}
          
          ${inputsValues[Infection_Urinary_Inputs.Other_Information]
            ? `Further information: ${inputsValues[Infection_Urinary_Inputs.Other_Information]}.`
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Urinary_Inputs.Other_Information]
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
           ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
            }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Urinary_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Urinary_Inputs.Urine_Test_Taken_And_Sent_To_Pathology, 
                  label: 'Urine Test taken and sent to pathology', 
                },
                {
                  value: Infection_Urinary_Inputs.GP_Prescribed_Antibiotics, 
                  label: 'GP Prescribed Antibiotics', 
                },
                {
                  value: Infection_Urinary_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Urinary_Inputs.Fluids_Increased, 
                  label: 'Fluids increased', 
                },
                {
                  value: Infection_Urinary_Inputs.Managing_Symptoms_With_Common_UTI_Treatment_Approaches, 
                  label: 'Managing symptoms with common urinary infection treatment approaches', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Urinary_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Urinary_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Respiratory]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a respiratory infection.
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken] && inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.length
            ? 'Our team has taken the following actions: '
            : ''}
            
          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.includes(Infection_Respiratory_Inputs.GP_Informed)
            ? 'The GP has been informed. '
            : ''}

          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.includes(Infection_Respiratory_Inputs.GP_Prescribed_Antibiotics)
            ? 'The GP has ordered to commence antibiotics. '
            : ''}

          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.includes(Infection_Respiratory_Inputs.Observations_Monitored)
            ? 'The observations are monitored. '
            : ''}

          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.includes(Infection_Respiratory_Inputs.Fluids_Increased)
            ? 'The level of fluids is increased. '
            : ''}

          ${inputsValues[Infection_Respiratory_Inputs.Actions_Taken]?.includes(Infection_Respiratory_Inputs.Managing_Symptoms_With_Common_UTI_Treatment_Approaches)
            ? 'Symptoms are being managed with common respiratory infection treatment approaches. '
            : ''}

          Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Infection_Respiratory_Inputs.How_Is_The_Resident_Feeling]
            ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Respiratory_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
            : ''}
          
          ${inputsValues[Infection_Respiratory_Inputs.Other_Information]
            ? `Further information: ${inputsValues[Infection_Respiratory_Inputs.Other_Information]}.`
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Respiratory_Inputs.Other_Information]
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Respiratory_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Respiratory_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Respiratory_Inputs.GP_Prescribed_Antibiotics, 
                  label: 'GP Prescribed Antibiotics', 
                },
                {
                  value: Infection_Respiratory_Inputs.Fluids_Increased, 
                  label: 'Fluids increased', 
                },
                {
                  value: Infection_Respiratory_Inputs.Observations_Monitored, 
                  label: 'Observations Monitored', 
                },
                {
                  value: Infection_Respiratory_Inputs.Managing_Symptoms_With_Common_UTI_Treatment_Approaches, 
                  label: 'Managing symptoms with common respiratory infection treatment approaches ', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Respiratory_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Respiratory_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Infection_SubSections.Wound]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a Wound.

        ${inputsValues[Infection_Wound_Inputs.Wound_Place]?.front?.length || inputsValues[Infection_Wound_Inputs.Wound_Place]?.back?.length || inputsValues[Infection_Wound_Inputs.Wound_Place]?.additional
        ? `${UpdateMessageSymbols.Line_Break}Location of the wound:${` ${[...inputsValues[Infection_Wound_Inputs.Wound_Place].front, ...inputsValues[Infection_Wound_Inputs.Wound_Place].back].join(', ')}`}${inputsValues[Infection_Wound_Inputs.Wound_Place].additional ? `${ inputsValues[Infection_Wound_Inputs.Wound_Place]?.front?.length || inputsValues[Infection_Wound_Inputs.Wound_Place]?.back?.length ? ', ' : ''} ${inputsValues[Infection_Wound_Inputs.Wound_Place].additional}` : ''}.`
        : ''}
        
        ${inputsValues[Infection_Wound_Inputs.The_Cause_Of_The_Wound_Is]
          ? 
        `${UpdateMessageSymbols.Line_Break}How it happened: ${inputsValues[Infection_Wound_Inputs.The_Cause_Of_The_Wound_Is]}. `
        : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken] && inputsValues[Infection_Wound_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.Swab_Of_Wound_Taken_And_Sent_To_Pathology)
          ? 'A swab of the wound has been taken and sent to pathology. We are waiting for the results. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.RN_Assessment_Of_Pain)
          ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.GP_Prescribed_Pain_Medication)
          ? 'The GP has prescribed pain medication. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.GP_Prescribed_Antibiotics)
          ? 'The GP has ordered to commence antibiotics. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.Clinical_Nurse_Specialist_Review_Of_Wound)
          ? 'A clinical nurse specialist has reviewed the wound. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.Nutritional_Supplements_Are_Being_Taken_To_Manage_Condition)
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken]?.includes(Infection_Wound_Inputs.Nutritional_Supplements_Are_Being_Taken_To_Manage_Condition)
          ? 'Nutritional supplements are being taken to manage condition. '
          : ''}

        ${inputsValues[Infection_Wound_Inputs.Actions_Taken] && inputsValues[Infection_Wound_Inputs.Actions_Taken]?.length
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}

        ${inputsValues[Infection_Wound_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Wound_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Wound_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Wound_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Wound_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Wound_Inputs.The_Cause_Of_The_Wound_Is,
              label: 'The cause of the wound is',
              placeholder: 'Write the cause of the wound',
              validationSchema: Yup.string().required('Write the cause of the wound'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Infection_Wound_Inputs.Wound_Place,
              headerType: 'wound'
            },
          ]
        },
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Wound_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Wound_Inputs.Swab_Of_Wound_Taken_And_Sent_To_Pathology, 
                  label: 'Swab of wound taken and sent to pathology', 
                },
                {
                  value: Infection_Wound_Inputs.RN_Assessment_Of_Pain, 
                  label: 'RN Assessment of Pain', 
                },
                {
                  value: Infection_Wound_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Wound_Inputs.GP_Prescribed_Pain_Medication, 
                  label: 'GP Prescribed pain medication', 
                },
                {
                  value: Infection_Wound_Inputs.GP_Prescribed_Antibiotics, 
                  label: 'GP Prescribed Antibiotics', 
                },
                {
                  value: Infection_Wound_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
                {
                  value: Infection_Wound_Inputs.Clinical_Nurse_Specialist_Review_Of_Wound, 
                  label: 'Clinical nurse specialist review of wound', 
                },
                {
                  value: Infection_Wound_Inputs.Nutritional_Supplements_Are_Being_Taken_To_Manage_Condition, 
                  label: 'Nutritional supplements are being taken to manage condition', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Wound_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Wound_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Skin_Infection]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a skin infection.
          ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Skin_Inputs.Description_Of_The_Infection]
          ? `Description of the infection: ${inputsValues[Infection_Skin_Inputs.Description_Of_The_Infection]}.`
          : ''}
          ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[Infection_Skin_Inputs.Actions_Taken] && inputsValues[Infection_Skin_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.Swab_Of_Infection_Taken_And_Sent)
          ? 'A swab of the skin has been taken and sent to pathology, we are awaiting for the results. '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.Antibiotics_Commenced)
          ? 'Antibiotics have been commenced. '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.GP_Prescribed_Medication_Or_Treatment)
          ? 'The GP has prescribed the medication/treatment (TBD). '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        ${inputsValues[Infection_Skin_Inputs.Actions_Taken]?.includes(Infection_Skin_Inputs.Referral_To_Wound_Specialist)
          ? `${mainValues.firstName} has been referred to a wound specialist. `
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Skin_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Skin_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Skin_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Skin_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Skin_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Skin_Inputs.Description_Of_The_Infection,
              label: 'Description of the infection',
              placeholder: 'Write description of the infection',
              validationSchema: Yup.string().required('Write description of the infection'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Skin_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Skin_Inputs.Swab_Of_Infection_Taken_And_Sent, 
                  label: 'Swab of infection taken and sent to pathology', 
                },
                {
                  value: Infection_Skin_Inputs.GP_Informed, 
                  label: 'GP informed', 
                },
                {
                  value: Infection_Skin_Inputs.GP_Prescribed_Medication_Or_Treatment, 
                  label: 'GP prescribed medication or treatment', 
                },
                {
                  value: Infection_Skin_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
                {
                  value: Infection_Skin_Inputs.Referral_To_Wound_Specialist, 
                  label: 'Referral to wound specialist', 
                },
                {
                  value: Infection_Skin_Inputs.Antibiotics_Commenced, 
                  label: 'Antibiotics commenced', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Skin_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Skin_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Cellulitis]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has cellulitis.
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Cellulitis_Inputs.Actions_Taken] && inputsValues[Infection_Cellulitis_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Infection_Cellulitis_Inputs.Actions_Taken]?.includes(Infection_Cellulitis_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Infection_Cellulitis_Inputs.Actions_Taken]?.includes(Infection_Cellulitis_Inputs.Antibiotics_Commenced)
          ? 'Antibiotics have been commenced. '
          : ''}

        ${inputsValues[Infection_Cellulitis_Inputs.Actions_Taken]?.includes(Infection_Cellulitis_Inputs.GP_Prescribed_Medication_Or_Treatment)
          ? 'The GP has prescribed the medication/treatment (TBD). '
          : ''}

        ${inputsValues[Infection_Cellulitis_Inputs.Actions_Taken]?.includes(Infection_Cellulitis_Inputs.Monitoring_For_Any_Spread)
          ? 'Our team is monitoring the infection for any spread. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Cellulitis_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Cellulitis_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Cellulitis_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Cellulitis_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Cellulitis_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Cellulitis_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Cellulitis_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Cellulitis_Inputs.GP_Prescribed_Medication_Or_Treatment, 
                  label: 'GP prescribed medication or treatment', 
                },
                {
                  value: Infection_Cellulitis_Inputs.Antibiotics_Commenced, 
                  label: 'Antibiotics commenced', 
                },
                {
                  value: Infection_Cellulitis_Inputs.Monitoring_For_Any_Spread, 
                  label: 'Monitoring for any spread', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Cellulitis_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Cellulitis_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Ear_Nose_Throat_ENT]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has an Ear, Nose, Throat ENT infection.
          ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken] && inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.includes(Infection_EarNoseThroatENT_Inputs.RN_Assessment_Conducted)
          ? 'An RN has conducted an Assessment. '
          : ''}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.includes(Infection_EarNoseThroatENT_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.includes(Infection_EarNoseThroatENT_Inputs.Monitoring_Fluids_And_Food_Intake)
          ? 'Our team is monitoring fluids and food intake. '
          : ''}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.includes(Infection_EarNoseThroatENT_Inputs.GP_Prescribed_Medication_Or_Treatment)
          ? 'The GP has prescribed the medication/treatment (TBD). '
          : ''}

        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Actions_Taken]?.includes(Infection_EarNoseThroatENT_Inputs.Antibiotics_Commenced)
          ? 'Antibiotics have been commenced. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Infection_EarNoseThroatENT_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_EarNoseThroatENT_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_EarNoseThroatENT_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_EarNoseThroatENT_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_EarNoseThroatENT_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_EarNoseThroatENT_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_EarNoseThroatENT_Inputs.RN_Assessment_Conducted, 
                  label: 'RN assessment conducted', 
                },
                {
                  value: Infection_EarNoseThroatENT_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_EarNoseThroatENT_Inputs.GP_Prescribed_Medication_Or_Treatment, 
                  label: 'GP prescribed medication or treatment', 
                },
                {
                  value: Infection_EarNoseThroatENT_Inputs.Antibiotics_Commenced, 
                  label: 'Antibiotics commenced', 
                },
                {
                  value: Infection_EarNoseThroatENT_Inputs.Monitoring_Fluids_And_Food_Intake, 
                  label: 'Monitoring fluids and food intake', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_EarNoseThroatENT_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_EarNoseThroatENT_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Eye]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has an eye infection.
          ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken] && inputsValues[Infection_Eye_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken]?.includes(Infection_Eye_Inputs.RN_Assessment_Conducted)
          ? 'An RN has conducted an Assessment. '
          : ''}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken]?.includes(Infection_Eye_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken]?.includes(Infection_Eye_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken]?.includes(Infection_Eye_Inputs.GP_Prescribed_Medication_Or_Treatment)
          ? 'The GP has prescribed the medication/treatment (TBD). '
          : ''}

        ${inputsValues[Infection_Eye_Inputs.Actions_Taken]?.includes(Infection_Eye_Inputs.Antibiotics_Commenced)
          ? 'Antibiotics have been commenced. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Infection_Eye_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Eye_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Eye_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Eye_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Eye_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Eye_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Eye_Inputs.RN_Assessment_Conducted, 
                  label: 'RN assessment conducted', 
                },
                {
                  value: Infection_Eye_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Eye_Inputs.GP_Prescribed_Medication_Or_Treatment, 
                  label: 'GP prescribed medication or treatment', 
                },
                {
                  value: Infection_Eye_Inputs.Antibiotics_Commenced, 
                  label: 'Antibiotics commenced', 
                },
                {
                  value: Infection_Eye_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: 'howIsTheResidentFeeling',
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: 'otherInformation',
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Covid_First_Update_To_Family]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `
        Covid-19 tests have been completed today.
        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_Tests]?.length
          ? `Results: `
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_Tests]?.includes(Infection_Covid_First_Update_To_Family_Inputs.Covid_RAT_Test)
          ? `Covid-19 Rapid Antigen Test: ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_RAT_Test_Result] === RadioBoolean.Yes ? 'positive' : 'negative'}, `
          : ''
        }

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_Tests]?.includes(Infection_Covid_First_Update_To_Family_Inputs.Covid_PCR_Test)
          ? `Covid-19 PCR test: ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_PCR_Test_Result] === RadioBoolean.Yes ? 'positive' : 'negative'}. `
          : ''
        } 

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken] && inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.length
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken] && inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following action: '
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.includes(Infection_Covid_First_Update_To_Family_Inputs.Increased_Fluids_Encouraged)
          ? `We have encouraged an increase in fluids. `
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.includes(Infection_Covid_First_Update_To_Family_Inputs.Observations_Being_Monitored_Regularly)
          ? `Observations are being monitored at regular intervals. `
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.includes(Infection_Covid_First_Update_To_Family_Inputs.GP_Informed)
          ? `The GP has been informed. `
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.includes(Infection_Covid_First_Update_To_Family_Inputs.GP_Prescribed_Antiviral_Medication)
          ? `The GP has prescribed the Antiviral medication: 
            ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Antiviral]?.join(', ')
            } `
          : ''}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken] && inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken]?.length
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Isolation_Rules_As_Per_Isolation_Protocol_Apply] === RadioBoolean.Yes
          ? 'Isolation rules as per isolation protocol apply. '
          : ''}

        Isolation to finish on ${moment(inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Isolation_To_Finish_On]).format("DD MMM YYYY")}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Covid_Visitation_Rules_Apply] === RadioBoolean.Yes
          ? `Our current Covid visitation rules apply: ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Visitation_Rules]}. `
          : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Covid_First_Update_To_Family_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              checkboxes: [
                {value: Infection_Covid_First_Update_To_Family_Inputs.Covid_RAT_Test, label: 'Covid-19 RAT Test'},
                {value: Infection_Covid_First_Update_To_Family_Inputs.Covid_PCR_Test, label: 'Covid-19 PCR Test'},
              ],
              name: Infection_Covid_First_Update_To_Family_Inputs.Covid_Tests,
              value: undefined,
              label: 'Covid-19 tests completed',
              dependentInputs: {
                [Infection_Covid_First_Update_To_Family_Inputs.Covid_RAT_Test]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: RadioBoolean.Yes, label: 'positive'},
                      {value: RadioBoolean.No, label: 'negative'},
                    ],
                    name: Infection_Covid_First_Update_To_Family_Inputs.Covid_RAT_Test_Result,
                    value: undefined,
                    label: 'Result',
                    className: styles.padding_1,
                    required: true,
                    validationSchema: Yup.string().required('Please select one'),
                  }
                ],
                [Infection_Covid_First_Update_To_Family_Inputs.Covid_PCR_Test]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: RadioBoolean.Yes, label: 'positive'},
                      {value: RadioBoolean.No, label: 'negative'},
                    ],
                    name: Infection_Covid_First_Update_To_Family_Inputs.Covid_PCR_Test_Result,
                    value: undefined,
                    className: styles.padding_1,
                    label: 'Result',
                    required: true,
                    validationSchema: Yup.string().required('Please select one'),
                  }
                ],
              }
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Infection_Covid_First_Update_To_Family_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Infection_Covid_First_Update_To_Family_Inputs.Increased_Fluids_Encouraged, 
                  label: 'Increased fluids encouraged', 
                },
                {
                  value: Infection_Covid_First_Update_To_Family_Inputs.Observations_Being_Monitored_Regularly, 
                  label: 'Observations being monitored regularly', 
                },
                {
                  value: Infection_Covid_First_Update_To_Family_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Infection_Covid_First_Update_To_Family_Inputs.GP_Prescribed_Antiviral_Medication, 
                  label: 'GP Prescribed Antiviral medication', 
                },
              ],
              dependentInputs: {
                [Infection_Covid_First_Update_To_Family_Inputs.GP_Prescribed_Antiviral_Medication]: [
                  {
                    type: UpdateInputsTypes.CheckboxInput,
                    className: styles.padding_1,
                    name: Infection_Covid_First_Update_To_Family_Inputs.Antiviral,
                    label: 'Actions taken (select all that apply):',
                    checkboxes: [
                      {
                        value: Infection_Covid_First_Update_To_Family_Inputs.Lagevrio, 
                        label: 'Lagevrio® (molnupiravir)', 
                      },
                      {
                        value: Infection_Covid_First_Update_To_Family_Inputs.Paxlovid, 
                        label: 'Paxlovid® (nirmatrelvir + ritonavir)', 
                      },
                    ]
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Infection_Covid_First_Update_To_Family_Inputs.Isolation_Rules_As_Per_Isolation_Protocol_Apply,
              value: undefined,
              label: 'Isolation rules as per isolation protocol apply',
              required: true,
              validationSchema: Yup.string().required('Please select one'),

            },
            {
              type: UpdateInputsTypes.DateInput,
              name: Infection_Covid_First_Update_To_Family_Inputs.Isolation_To_Finish_On,
              label: 'Isolation to finish on',
              placeholder: 'Select date Isolation to finish on',
              minDate: new Date(),
              dateType: 'date',
              validationSchema: Yup.date().required('Date Isolation to finish on is required'),
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Infection_Covid_First_Update_To_Family_Inputs.Covid_Visitation_Rules_Apply,
              value: undefined,
              label: 'Covid visitation rules apply',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    value: undefined,
                    name: Infection_Covid_First_Update_To_Family_Inputs.Visitation_Rules,
                    label: 'Current visitation rules',
                    placeholder: 'Write Current visitation rules',
                    validationSchema: Yup.string().required('Write Current visitation rules'),
                    required: true,
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Covid_First_Update_To_Family_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Covid_First_Update_To_Family_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Infection_SubSections.Covid_Ongoing_Update]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `
          Update on the ${mainValues.firstName}${'`s'} condition: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Update_On_The_Residents_Condition]}. 

          ${UpdateMessageSymbols.Paragraph_Break}

          Covid-19 tests have been completed today.
          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_Tests_Have_Been_Completed_Today]?.length
            ? `Results: `
            : ''}

          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_Tests_Have_Been_Completed_Today]?.includes(Infection_Covid_Ongoing_Update_Inputs.Covid_RAT_Test)
            ? `Covid-19 Rapid Antigen Test: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_RAT_Test_Result] === RadioBoolean.Yes ? 'positive' : 'negative'}. `
            : ''
          }

          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_Tests_Have_Been_Completed_Today]?.includes(Infection_Covid_Ongoing_Update_Inputs.Covid_PCR_Test)
            ? `Covid-19 PCR test: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_PCR_Test_Result] === RadioBoolean.Yes ? 'positive' : 'negative'}. `
            : ''
          } 

          ${UpdateMessageSymbols.Paragraph_Break}

          Our team has taken the following action: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Actions_Taken_By_Team]}. 

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Isolation_Rules_As_Per_Isolation_Protocol_Apply] === RadioBoolean.Yes
            ? 'Isolation rules as per isolation protocol apply. '
            : ''}
  
          Isolation to finish on ${moment(inputsValues[Infection_Covid_Ongoing_Update_Inputs.Isolation_To_Finish_On]).format("DD MMM YYYY")}. 
  
          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Covid_Visitation_Rules_Apply] === RadioBoolean.Yes
            ? `Our current Covid visitation rules apply: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Outline_The_Current_Visitation_Rules]}. `
            : ''}
          
          ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Other_Information]
            ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Infection_Covid_Ongoing_Update_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
        steps: [
          {
            inputs: [
              {
                type: UpdateInputsTypes.TextInput,
                multiline: true,
                value: undefined,
                name: Infection_Covid_Ongoing_Update_Inputs.Update_On_The_Residents_Condition,
                label: 'Update on the residents condition',
                placeholder: 'Write residents condition',
                validationSchema: Yup.string().required('Write residents condition'),
                required: true,
              },
              {
                type: UpdateInputsTypes.CheckboxInput,
                checkboxes: [
                  {value: Infection_Covid_Ongoing_Update_Inputs.Covid_RAT_Test, label: 'Covid-19 RAT Test'},
                  {value: Infection_Covid_Ongoing_Update_Inputs.Covid_PCR_Test, label: 'Covid-19 PCR Test'},
                ],
                name: Infection_Covid_Ongoing_Update_Inputs.Covid_Tests_Have_Been_Completed_Today,
                value: undefined,
                label: 'Covid-19 tests have been completed today',
                dependentInputs: {
                  [Infection_Covid_Ongoing_Update_Inputs.Covid_RAT_Test]: [
                    {
                      type: UpdateInputsTypes.RadioInput,
                      radios: [
                        {value: RadioBoolean.Yes, label: 'positive'},
                        {value: RadioBoolean.No, label: 'negative'},
                      ],
                      name: Infection_Covid_Ongoing_Update_Inputs.Covid_RAT_Test_Result,
                      value: undefined,
                      label: 'Result',
                      className: styles.padding_1,
                      required: true,
                      validationSchema: Yup.string().required('Please select one'),
                    }
                  ],
                  [Infection_Covid_Ongoing_Update_Inputs.Covid_PCR_Test]: [
                    {
                      type: UpdateInputsTypes.RadioInput,
                      radios: [
                        {value: RadioBoolean.Yes, label: 'positive'},
                        {value: RadioBoolean.No, label: 'negative'},
                      ],
                      name: Infection_Covid_Ongoing_Update_Inputs.Covid_PCR_Test_Result,
                      value: undefined,
                      className: styles.padding_1,
                      label: 'Result',
                      required: true,
                      validationSchema: Yup.string().required('Please select one'),
                    }
                  ],
                }
              },
              {
                type: UpdateInputsTypes.TextInput,
                multiline: true,
                value: undefined,
                name: Infection_Covid_Ongoing_Update_Inputs.Actions_Taken_By_Team,
                label: 'Actions taken by team',
                placeholder: 'Write Actions taken by team',
                validationSchema: Yup.string().required('Write Actions taken by team'),
                required: true,
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Infection_Covid_Ongoing_Update_Inputs.Isolation_Rules_As_Per_Isolation_Protocol_Apply,
                value: undefined,
                label: 'Isolation rules as per isolation protocol apply',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
              },
              {
                type: UpdateInputsTypes.DateInput,
                name: Infection_Covid_Ongoing_Update_Inputs.Isolation_To_Finish_On,
                label: 'Isolation to finish on',
                placeholder: 'Select date Isolation to finish on',
                minDate: new Date(),
                dateType: 'date',
                validationSchema: Yup.date().required('Date Isolation to finish on is required'),
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Infection_Covid_Ongoing_Update_Inputs.Covid_Visitation_Rules_Apply,
                value: undefined,
                label: 'Covid visitation rules apply',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      className: styles.padding_1,
                      value: undefined,
                      name: Infection_Covid_Ongoing_Update_Inputs.Outline_The_Current_Visitation_Rules,
                      label: 'Current visitation rules',
                      placeholder: 'Write Current visitation rules',
                      validationSchema: Yup.string().required('Write Current visitation rules'),
                      required: true,
                    }
                  ]
                }
              },
              {
                type: UpdateInputsTypes.TextInput,
                multiline: true,
                name: Infection_Covid_Ongoing_Update_Inputs.Other_Information,
                label: 'Further information',
                placeholder: 'Please write any further information that will be helpful for the family to know ',
              },
            ]
          }
        ]
    },
    [Infection_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has infection.
          ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Other_Inputs.Description_Of_The_Infection]
          ? `Description of the infection: ${inputsValues[Infection_Other_Inputs.Description_Of_The_Infection]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}

        ${inputsValues[Infection_Other_Inputs.Description_Of_Any_Treatment]
          ? `Description of any treatment: ${inputsValues[Infection_Other_Inputs.Description_Of_Any_Treatment]}.`
          : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Infection_Other_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Infection_Other_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Infection_Other_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Infection_Other_Inputs.Other_Information]}.`
          : ''}     
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Infection_Other_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Other_Inputs.Description_Of_The_Infection,
              label: 'Description of the infection',
              placeholder: 'Write description of the infection',
              validationSchema: Yup.string().required('Write description of the infection'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Other_Inputs.Description_Of_Any_Treatment,
              label: 'Description of any treatment',
              placeholder: 'Write description of any treatment',
              validationSchema: Yup.string().required('Write description of any treatment'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Infection_Other_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Infection_Other_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.GP_Review_Medication_Change]: {
    [GP_Review_Medication_Change_SubSections.General_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was reviewed by the GP, ${inputsValues[GPReview_GeneralReview_Inputs.Name_Of_GP] || 'undefined'} on ${formatDate(mainValues.date, true)}.

        ${UpdateMessageSymbols.Paragraph_Break}
        ${inputsValues[GPReview_GeneralReview_Inputs.Description_Of_The_GP_Review]
          ? `Summary of GP Review: ${inputsValues[GPReview_GeneralReview_Inputs.Description_Of_The_GP_Review]}.`
          : ''}

        ${inputsValues[GPReview_GeneralReview_Inputs.GP_Changed_Medication] === RadioBoolean.Yes
            ? inputsValues[GPReview_GeneralReview_Inputs.Describe_Change_To_Medication]
                ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[GPReview_GeneralReview_Inputs.Describe_Change_To_Medication]}. `
                : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
            : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[GPReview_GeneralReview_Inputs.Other_Information]
          ? `Further information: ${inputsValues[GPReview_GeneralReview_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[GPReview_GeneralReview_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: GPReview_GeneralReview_Inputs.Name_Of_GP,
              label: 'Name of GP',
              placeholder: 'Write GP name',
              validationSchema: Yup.string().required('Write GP name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_GeneralReview_Inputs.Description_Of_The_GP_Review,
              label: 'Description of the GP review',
              placeholder: 'Write description of the GP review',
              validationSchema: Yup.string().required('Write description of the GP review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: GPReview_Deterioration_Inputs.GP_Changed_Medication,
              value: undefined,
              label: 'GP changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    required: true,
                    validationSchema: Yup.string().required('Write  change to medication'),
                    className: styles.padding_1,
                    name: GPReview_GeneralReview_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_GeneralReview_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [GP_Review_Medication_Change_SubSections.Deterioration_Physical_Or_Cognitive]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was reviewed by the GP, ${inputsValues[GPReview_Deterioration_Inputs.Name_Of_GP] || 'undefined'} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[GPReview_Deterioration_Inputs.Description_Of_The_GP_Review]
            ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the GP’s review: ${inputsValues[GPReview_Deterioration_Inputs.Description_Of_The_GP_Review]}.`
            : ''}
        ${inputsValues[GPReview_Deterioration_Inputs.GP_Changed_Medication] === RadioBoolean.Yes
            ? inputsValues[GPReview_Deterioration_Inputs.Describe_Change_To_Medication]
                ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[GPReview_Deterioration_Inputs.Describe_Change_To_Medication]}. `
                : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
            : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
      
        ${inputsValues[GPReview_Deterioration_Inputs.Other_Information]
          ? `Further information: ${inputsValues[GPReview_Deterioration_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[GPReview_Deterioration_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: GPReview_Deterioration_Inputs.Name_Of_GP,
              label: 'Name of GP',
              placeholder: 'Write GP name',
              validationSchema: Yup.string().required('Write GP name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_Deterioration_Inputs.Description_Of_The_GP_Review,
              label: 'Description of the GP review',
              placeholder: 'Write description of the GP review',
              validationSchema: Yup.string().required('Write description of the GP review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: GPReview_Deterioration_Inputs.GP_Changed_Medication,
              value: undefined,
              label: 'GP changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    required: true,
                    validationSchema: Yup.string().required('Write  change to medication'),
                    className: styles.padding_1,
                    name: GPReview_Deterioration_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_Deterioration_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [GP_Review_Medication_Change_SubSections.Medication_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was reviewed by the GP, ${inputsValues[GPReview_MedicationReview_Inputs.Name_Of_GP] || 'undefined'} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[GPReview_MedicationReview_Inputs.Description_Of_The_GP_Review]
            ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the GP’s review: ${inputsValues[GPReview_MedicationReview_Inputs.Description_Of_The_GP_Review]}.`
            : ''}
        ${inputsValues[GPReview_MedicationReview_Inputs.GP_Changed_Medication] === RadioBoolean.Yes
          ? inputsValues[GPReview_MedicationReview_Inputs.Describe_Change_To_Medication]
            ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[GPReview_MedicationReview_Inputs.Describe_Change_To_Medication]}. `
            : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
          : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
      
        ${inputsValues[GPReview_MedicationReview_Inputs.Other_Information]
          ? `Further information: ${inputsValues[GPReview_MedicationReview_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[GPReview_MedicationReview_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: GPReview_MedicationReview_Inputs.Name_Of_GP,
              label: 'Name of GP',
              placeholder: 'Write GP name',
              validationSchema: Yup.string().required('Write GP name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_MedicationReview_Inputs.Description_Of_The_GP_Review,
              label: 'Description of the GP review',
              placeholder: 'Write description of the GP review',
              validationSchema: Yup.string().required('Write description of the GP review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: GPReview_MedicationReview_Inputs.GP_Changed_Medication,
              value: undefined,
              label: 'GP changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    name: GPReview_MedicationReview_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_MedicationReview_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [GP_Review_Medication_Change_SubSections.Review_Post_Fall_Or_Incident]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was reviewed by the GP, ${inputsValues[GPReview_ReviewPost_Inputs.Name_Of_GP] || 'undefined'} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[GPReview_ReviewPost_Inputs.Description_Of_The_GP_Review]
            ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the GP’s review: ${inputsValues[GPReview_ReviewPost_Inputs.Description_Of_The_GP_Review]}.`
            : ''}

        ${inputsValues[GPReview_ReviewPost_Inputs.GP_Changed_Medication] === RadioBoolean.Yes
            ? inputsValues[GPReview_ReviewPost_Inputs.Describe_Change_To_Medication]
                ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[GPReview_ReviewPost_Inputs.Describe_Change_To_Medication]}. `
                : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
            : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[GPReview_MedicationReview_Inputs.Other_Information]
            ? `Further information: ${inputsValues[GPReview_MedicationReview_Inputs.Other_Information]}.`
            : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: GPReview_ReviewPost_Inputs.Name_Of_GP,
              label: 'Name of GP',
              placeholder: 'Write GP name',
              validationSchema: Yup.string().required('Write GP name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_ReviewPost_Inputs.Description_Of_The_GP_Review,
              label: 'Description of the GP review',
              placeholder: 'Write description of the GP review',
              validationSchema: Yup.string().required('Write description of the GP review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: GPReview_ReviewPost_Inputs.GP_Changed_Medication,
              value: undefined,
              label: 'GP changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: GPReview_ReviewPost_Inputs.Describe_Change_To_Medication,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_ReviewPost_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [GP_Review_Medication_Change_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was reviewed by the GP, ${inputsValues[GPReview_Other_Inputs.Name_Of_GP] || 'undefined'} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[GPReview_Other_Inputs.Description_Of_The_GP_Review]
            ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the GP’s review: ${inputsValues[GPReview_Other_Inputs.Description_Of_The_GP_Review]}.`
            : ''}

        ${inputsValues[GPReview_Other_Inputs.GP_Changed_Medication] === RadioBoolean.Yes
            ? inputsValues[GPReview_Other_Inputs.Describe_Change_To_Medication]
                ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[GPReview_Other_Inputs.Describe_Change_To_Medication]}. `
                : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
            : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[GPReview_Other_Inputs.Other_Information]
          ? `Further information: ${inputsValues[GPReview_Other_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[GPReview_Other_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: GPReview_Other_Inputs.Name_Of_GP,
              label: 'Name of GP',
              placeholder: 'Write GP name',
              validationSchema: Yup.string().required('Write GP name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_Other_Inputs.Description_Of_The_GP_Review,
              label: 'Description of the GP review',
              placeholder: 'Write description of the GP review',
              validationSchema: Yup.string().required('Write description of the GP review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: GPReview_Other_Inputs.GP_Changed_Medication,
              value: undefined,
              label: 'GP changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: GPReview_Other_Inputs.Describe_Change_To_Medication,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: GPReview_Other_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Nurse_Practitioner]: {
    [Nurse_Practitioner_SubSections.General_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} was reviewed by the Nurse Practitioner, ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Name_Of_NP]} on ${formatDate(mainValues.date, true)}.

        ${UpdateMessageSymbols.Paragraph_Break}
        ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Description_Of_The_NP_Review]
              ? `Summary of Nurse Practitioner Review: ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Description_Of_The_NP_Review]}.`
              : ''}

        ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.NP_Changed_Medication] === RadioBoolean.Yes
              ? inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Describe_Change_To_Medication]
                  ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Describe_Change_To_Medication]}. `
                  : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
              : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Nurse_Practitioner_GeneralReview_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Nurse_Practitioner_GeneralReview_Inputs.Name_Of_NP,
              label: 'Name of Nurse Practitioner',
              placeholder: 'Write Nurse Practitioner name',
              validationSchema: Yup.string().required('Write Nurse Practitioner name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_GeneralReview_Inputs.Description_Of_The_NP_Review,
              label: 'Description of the Nurse Practitioner review',
              placeholder: 'Write description of the Nurse Practitioner review',
              validationSchema: Yup.string().required('Write description of the Nurse Practitioner review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nurse_Practitioner_GeneralReview_Inputs.NP_Changed_Medication,
              value: undefined,
              label: 'Nurse Practitioner changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    className: styles.padding_1,
                    name: Nurse_Practitioner_GeneralReview_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_GeneralReview_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Nurse_Practitioner_SubSections.Deterioration_Physical_Or_Cognitive]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} was reviewed by the Nurse Practitioner, ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Name_Of_NP]} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Description_Of_The_NP_Review]
              ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the Nurse Practitioner’s review: ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Description_Of_The_NP_Review]}.`
              : ''}
        ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.NP_Changed_Medication] === RadioBoolean.Yes
              ? inputsValues[Nurse_Practitioner_Deterioration_Inputs.Describe_Change_To_Medication]
                  ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Describe_Change_To_Medication]}. `
                  : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
              : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
      
        ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Nurse_Practitioner_Deterioration_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Nurse_Practitioner_Deterioration_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Nurse_Practitioner_Deterioration_Inputs.Name_Of_NP,
              label: 'Name of Nurse Practitioner',
              placeholder: 'Write Nurse Practitioner name',
              validationSchema: Yup.string().required('Write Nurse Practitioner name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_Deterioration_Inputs.Description_Of_The_NP_Review,
              label: 'Description of the Nurse Practitioner review',
              placeholder: 'Write description of the Nurse Practitioner review',
              validationSchema: Yup.string().required('Write description of the Nurse Practitioner review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nurse_Practitioner_Deterioration_Inputs.NP_Changed_Medication,
              value: undefined,
              label: 'Nurse Practitioner changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    required: true,
                    validationSchema: Yup.string().required('Write  change to medication'),
                    className: styles.padding_1,
                    name: Nurse_Practitioner_Deterioration_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_Deterioration_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Nurse_Practitioner_SubSections.Medication_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} was reviewed by the Nurse Practitioner, ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Name_Of_NP]} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Description_Of_The_NP_Review]
              ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the Nurse Practitioner’s review: ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Description_Of_The_NP_Review]}.`
              : ''}
        ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.NP_Changed_Medication] === RadioBoolean.Yes
              ? inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Describe_Change_To_Medication]
                  ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Describe_Change_To_Medication]}. `
                  : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
              : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
      
        ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Nurse_Practitioner_MedicationReview_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Nurse_Practitioner_MedicationReview_Inputs.Name_Of_NP,
              label: 'Name of Nurse Practitioner',
              placeholder: 'Write Nurse Practitioner name',
              validationSchema: Yup.string().required('Write Nurse Practitioner name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_MedicationReview_Inputs.Description_Of_The_NP_Review,
              label: 'Description of the Nurse Practitioner review',
              placeholder: 'Write description of the Nurse Practitioner review',
              validationSchema: Yup.string().required('Write description of the Nurse Practitioner review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nurse_Practitioner_MedicationReview_Inputs.NP_Changed_Medication,
              value: undefined,
              label: 'Nurse Practitioner changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    name: Nurse_Practitioner_MedicationReview_Inputs.Describe_Change_To_Medication,
                    label: 'Describe change to medication',
                    placeholder: 'Write change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_MedicationReview_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Nurse_Practitioner_SubSections.Review_Post_Fall_Or_Incident]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} was reviewed by the Nurse Practitioner, ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Name_Of_NP]} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Description_Of_The_NP_Review]
              ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the Nurse Practitioner’s review: ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Description_Of_The_NP_Review]}.`
              : ''}

        ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.NP_Changed_Medication] === RadioBoolean.Yes
              ? inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Describe_Change_To_Medication]
                  ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Describe_Change_To_Medication]}. `
                  : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
              : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Nurse_Practitioner_ReviewPost_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Nurse_Practitioner_ReviewPost_Inputs.Name_Of_NP,
              label: 'Name of Nurse Practitioner',
              placeholder: 'Write Nurse Practitioner name',
              validationSchema: Yup.string().required('Write Nurse Practitioner name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_ReviewPost_Inputs.Description_Of_The_NP_Review,
              label: 'Description of the Nurse Practitioner review',
              placeholder: 'Write description of the Nurse Practitioner review',
              validationSchema: Yup.string().required('Write description of the Nurse Practitioner review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nurse_Practitioner_ReviewPost_Inputs.NP_Changed_Medication,
              value: undefined,
              label: 'Nurse Practitioner changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nurse_Practitioner_ReviewPost_Inputs.Describe_Change_To_Medication,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_ReviewPost_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Nurse_Practitioner_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} was reviewed by the Nurse Practitioner, ${inputsValues[Nurse_Practitioner_Other_Inputs.Name_Of_NP]} on ${formatDate(mainValues.date, true)}.
          ${inputsValues[Nurse_Practitioner_Other_Inputs.Description_Of_The_NP_Review]
              ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the Nurse Practitioner’s review: ${inputsValues[Nurse_Practitioner_Other_Inputs.Description_Of_The_NP_Review]}.`
              : ''}

        ${inputsValues[Nurse_Practitioner_Other_Inputs.NP_Changed_Medication] === RadioBoolean.Yes
              ? inputsValues[Nurse_Practitioner_Other_Inputs.Describe_Change_To_Medication]
                  ? `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication: ${inputsValues[Nurse_Practitioner_Other_Inputs.Describe_Change_To_Medication]}. `
                  : `${UpdateMessageSymbols.Paragraph_Break} Change to ${mainValues.firstName}'s medication.`
              : `${UpdateMessageSymbols.Paragraph_Break} There was no change to ${mainValues.firstName}'s medication.`}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Nurse_Practitioner_Other_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Nurse_Practitioner_Other_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Nurse_Practitioner_Other_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Nurse_Practitioner_Other_Inputs.Name_Of_NP,
              label: 'Name of Nurse Practitioner',
              placeholder: 'Write Nurse Practitioner name',
              validationSchema: Yup.string().required('Write Nurse Practitioner name'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_Other_Inputs.Description_Of_The_NP_Review,
              label: 'Description of the Nurse Practitioner review',
              placeholder: 'Write description of the Nurse Practitioner review',
              validationSchema: Yup.string().required('Write description of the Nurse Practitioner review'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nurse_Practitioner_Other_Inputs.NP_Changed_Medication,
              value: undefined,
              label: 'Nurse Practitioner changed medication',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nurse_Practitioner_Other_Inputs.Describe_Change_To_Medication,
                    required: true,
                    validationSchema: Yup.string().required('Write change to medication'),
                    label: 'Describe change to medication',
                    placeholder: 'Write describe change to medication',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nurse_Practitioner_Other_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Incident]: {
    [Incident_SubSections.Bruising]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has Bruising.

          ${inputsValues[Incident_Bruise_Inputs.Bruise_Place]?.front?.length || inputsValues[Incident_Bruise_Inputs.Bruise_Place]?.back?.length || inputsValues[Incident_Bruise_Inputs.Bruise_Place]?.additional
            ? `${UpdateMessageSymbols.Line_Break}Location of the bruising:${` ${[...inputsValues[Incident_Bruise_Inputs.Bruise_Place].front, ...inputsValues[Incident_Bruise_Inputs.Bruise_Place].back].join(', ')}`}${inputsValues[Incident_Bruise_Inputs.Bruise_Place].additional ? `${ inputsValues[Incident_Bruise_Inputs.Bruise_Place]?.front?.length || inputsValues[Incident_Bruise_Inputs.Bruise_Place]?.back?.length ? ', ' : ''} ${inputsValues[Incident_Bruise_Inputs.Bruise_Place].additional}` : ''}.`
            : ''}

          ${inputsValues[Incident_Bruise_Inputs.How_Did_The_Bruise_Happen]
          ? 
          `${UpdateMessageSymbols.Line_Break}How it happened: ${inputsValues[Incident_Bruise_Inputs.How_Did_The_Bruise_Happen]}. `
          : ''}
          ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken] && inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.RN_Assessment_Of_Pain)
          ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.GP_Prescribed_Pain_Medication)
          ? 'The GP has prescribed pain medication. '
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.Clinical_Nurse_Specialist_Review_Of_Bruising)
          ? 'A clinical nurse specialist has reviewed the wound. '
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.Cream_Applied)
          ? 'Cream has been applied. '
          : ''}

        ${inputsValues[Incident_Bruise_Inputs.Actions_Taken]?.includes(Incident_Bruise_Inputs.Nutritional_Supplements_Have_Been_Commenced)
          ? 'Nutritional supplements have been commenced. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Incident_Bruise_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Bruise_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Bruise_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Bruise_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Bruise_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Bruise_Inputs.How_Did_The_Bruise_Happen,
              label: 'How did the bruise happen?',
              placeholder: 'Write the cause of the bruise',
              validationSchema: Yup.string().required('Write the cause of the bruise'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Incident_Bruise_Inputs.Bruise_Place,
              headerType: 'bruise'
            },
          ]
        },
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Bruise_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Bruise_Inputs.RN_Assessment_Of_Pain, 
                  label: 'RN Assessment of Pain', 
                },
                {
                  value: Incident_Bruise_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_Bruise_Inputs.GP_Prescribed_Pain_Medication, 
                  label: 'GP Prescribed pain medication ', 
                },
                {
                  value: Incident_Bruise_Inputs.Clinical_Nurse_Specialist_Review_Of_Bruising, 
                  label: 'Clinical nurse specialist review of bruising', 
                },
                {
                  value: Incident_Bruise_Inputs.Cream_Applied, 
                  label: 'Cream applied ', 
                },
                {
                  value: Incident_Bruise_Inputs.Nutritional_Supplements_Have_Been_Commenced, 
                  label: 'Nutritional supplements have been commenced', 
                },

              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Bruise_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Bruise_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Incident_SubSections.Skin_Tear]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a skin tear.

         ${inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place]?.front?.length || inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place]?.back?.length || inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place]?.additional
           ? `${UpdateMessageSymbols.Line_Break}Location of the skin tear:${` ${[...inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place].front, ...inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place].back].join(', ')}`}${inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place].additional ? `${ inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place]?.front?.length || inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place]?.back?.length ? ', ' : ''} ${inputsValues[Incident_SkinTear_Inputs.Skin_Tear_Place].additional}` : ''}.`
           : ''} 

        ${inputsValues[Incident_SkinTear_Inputs.Cause_Of_The_Skin_Tear]
        ? 
        `${UpdateMessageSymbols.Line_Break}How it happened: ${inputsValues[Incident_SkinTear_Inputs.Cause_Of_The_Skin_Tear]}. `
        : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken] && inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.RN_Assessment_Of_Pain)
          ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.Pain_Relief_Analygesic_Was_Given)
          ? `Pain relief analgesic was given. ${inputsValues[Incident_SkinTear_Inputs.Pain_Relief_Was_Effective] === Incident_SkinTear_Inputs.Pain_Relief_Was_Effective_Yes
                ? 'Pain relief was effective. '
                : inputsValues[Incident_SkinTear_Inputs.Pain_Relief_Was_Effective] === Incident_SkinTear_Inputs.Pain_Relief_Was_Effective_No
                    ? `Pain relief wasn’t effective. `
                    : `${mainValues.firstName} is waiting for effect of pain relief. `}`
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.GP_Prescribed_Pain_Medication)
          ? 'The GP has prescribed pain medication. '
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.Clinical_Nurse_Specialist_Review_Of_Skin_Tear)
          ? 'A clinical nurse specialist has reviewed the skin tear.'
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.Cream_Applied)
          ? 'Cream has been applied. '
          : ''}

        ${inputsValues[Incident_SkinTear_Inputs.Actions_Taken]?.includes(Incident_SkinTear_Inputs.Nutritional_Supplements_Have_Been_Commenced)
          ? 'Nutritional supplements have been commenced. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_SkinTear_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_SkinTear_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_SkinTear_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_SkinTear_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_SkinTear_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_SkinTear_Inputs.Cause_Of_The_Skin_Tear,
              label: 'Cause of the skin tear',
              placeholder: 'Write the cause of the skin tear',
              validationSchema: Yup.string().required('Write the cause of the skin tear'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Incident_SkinTear_Inputs.Skin_Tear_Place,
              headerType: 'skin tear'
            },
          ]
        },
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_SkinTear_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_SkinTear_Inputs.RN_Assessment_Of_Pain, 
                  label: 'RN Assessment of Pain', 
                },
                {
                  value: Incident_SkinTear_Inputs.Pain_Relief_Analygesic_Was_Given, 
                  label: 'Pain relief analgesic was given', 
                },
                {
                  value: Incident_SkinTear_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_SkinTear_Inputs.GP_Prescribed_Pain_Medication, 
                  label: 'GP Prescribed pain medication', 
                },
                {
                  value: Incident_SkinTear_Inputs.Clinical_Nurse_Specialist_Review_Of_Skin_Tear, 
                  label: 'Clinical nurse specialist review of skin tear', 
                },
                {
                  value: Incident_SkinTear_Inputs.Cream_Applied, 
                  label: 'Cream applied', 
                },
                {
                  value: Incident_SkinTear_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
                {
                  value: Incident_SkinTear_Inputs.Nutritional_Supplements_Have_Been_Commenced, 
                  label: 'Nutritional supplements have been commenced', 
                },
              ],
              dependentInputs: {
                [Incident_SkinTear_Inputs.Pain_Relief_Analygesic_Was_Given]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: Incident_SkinTear_Inputs.Pain_Relief_Was_Effective_Yes, label: 'Yes'},
                      {value: Incident_SkinTear_Inputs.Pain_Relief_Was_Effective_No, label: 'No'},
                      {value: Incident_SkinTear_Inputs.Pain_Relief_Was_Effective_Waiting, label: 'Waiting for effect '},
                    ],
                    name: Incident_SkinTear_Inputs.Pain_Relief_Was_Effective,
                    value: undefined,
                    label: 'Pain relief was effective',
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    className: styles.padding_1,
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_SkinTear_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_SkinTear_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Incident_SubSections.Incontinence_Associated_Dermatitis]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} has a incontinence associated dermatitis.

          ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Description_Of_What_Happened]
              ? `${UpdateMessageSymbols.Paragraph_Break} Outline of the IAD (Incontinence Associated Dermatitis): ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Description_Of_What_Happened]}.`
              : ''}

        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Location_this_Happened] === Incident_Incontinence_Associated_Dermatitis_Inputs.Location_Happened_at_the_aged_care_home
              ?
              `This happened at the aged care home.`
              : 
              `This happened outside of the aged care home.`
          }
         
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Categorisation] && inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Categorisation]?.length
                ? `${UpdateMessageSymbols.Paragraph_Break} Categorisation of IAD (Incontinence Associated Dermatitis): ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Categorisation].join(', ')}`
                : ''}
      
        
        
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken] && inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.length
              ? 'Our team has taken the following actions: '
              : ''}

        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.RN_assessment_of_pain)
              ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Senior_RN_review)
              ? `Senior RN reviewed IAD (Incontinence Associated Dermatitis).`
              : ''}

        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.GP_informed)
              ? 'The GP has been informed. '
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Physio_informed)
              ? 'The Physio has been informed. '
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Continence_assessment_reviewed)
              ? `Continence assessment reviewed.`
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Skin_assessment_reviewed)
              ? `Skin assessment reviewed.`
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Wound_care_pathway_commenced)
              ? `Wound care pathway commenced.`
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Increased_peri_hygiene_interventions_commenced)
              ? `Increased peri hygiene interventions commenced.`
              : ''}

        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Dressing_applied)
              ? 'A dressing has been applied. '
              : ''}

        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Cream_applied)
              ? 'Cream has been applied. '
              : ''}
              
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.External_Wound_Specialist)
              ? 'External Wound Specialist referral sent. '
              : ''}
              
          ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]?.includes(Incident_Incontinence_Associated_Dermatitis_Inputs.Transferred_to_Hospital)
              ? `
             ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                  ? `${mainValues.firstName} has been transferred to ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Hospital_Location]}.`
                  : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
              }
            `
              : `${mainValues.priority === UpdatePriorities.High ? `We monitored ${mainValues.firstName} closely following the incident. ${mainValues.firstName} continued to receive care at ${mainValues.home} without needing a hospital transfer.` : ''}`}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.How_Is_The_Resident_Feeling]
              ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
              : ''}
        
        ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Other_Information]}.`
              : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Incontinence_Associated_Dermatitis_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Description_Of_What_Happened,
              label: 'Describe the IAD (Incontinence Associated Dermatitis)',
              placeholder: 'Write the description of IAD',
              validationSchema: Yup.string().required('Write the description of IAD'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                { value: Incident_Incontinence_Associated_Dermatitis_Inputs.Location_Happened_at_the_aged_care_home, label: 'Happened at the aged care home' },
                { value: Incident_Incontinence_Associated_Dermatitis_Inputs.Location_Happened_outside_of_the_aged_care_home, label: 'Happened outside of the aged care home' },
              ],
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Location_this_Happened,
              value: undefined,
              label: 'Location this happened',
              required: true,
              validationSchema: Yup.string().required('Select one'),
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Categorisation,
              label: 'Categorisation of IAD (Incontinence Associated Dermatitis): ',
              checkboxes: [
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Cat_1a,
                  label: 'Cat 1a - Persistent redness without clinical signs of infection',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Cat_1b,
                  label: 'Cat 1b - Persistent redness with clinical signs of infection',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Cat_2a,
                  label: 'Cat 2a - Skin loss without clinical signs of infection',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Cat_2b,
                  label: 'Cat 2b - Skin loss with clinical signs of infection',
                },
              ],
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.RN_assessment_of_pain,
                  label: 'RN Assessment of Pain',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Senior_RN_review,
                  label: 'Senior RN review of IAD (Incontinence Associated Dermatitis)',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.GP_informed,
                  label: 'GP Informed',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Physio_informed,
                  label: 'Physio informed',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Continence_assessment_reviewed,
                  label: 'Continence assessment reviewed',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Skin_assessment_reviewed,
                  label: 'Skin assessment reviewed',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Wound_care_pathway_commenced,
                  label: 'Wound care pathway commenced',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Cream_applied,
                  label: 'Cream applied',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Dressing_applied,
                  label: 'Dressing applied',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Increased_peri_hygiene_interventions_commenced,
                  label: 'Increased peri hygiene interventions commenced',
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.External_Wound_Specialist,
                  label: 'External Wound Specialist referral sent',
                  conditions: [
                    {
                      priority: UpdatePriorities.Medium,
                    },
                    {
                      priority: UpdatePriorities.High,
                    }
                  ]
                },
                {
                  value: Incident_Incontinence_Associated_Dermatitis_Inputs.Transferred_to_Hospital,
                  label: 'Transferred to Hospital',
                  conditions: [
                    {
                      priority: UpdatePriorities.High,
                    }
                  ]
                },
              ],
            },
            {
              conditions: [
                {[Incident_Incontinence_Associated_Dermatitis_Inputs.Actions_Taken]: Incident_Incontinence_Associated_Dermatitis_Inputs.Transferred_to_Hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Incident_Incontinence_Associated_Dermatitis_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Incontinence_Associated_Dermatitis_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Incident_SubSections.Pressure_Injury]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has a pressure injury.

          ${inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place]?.front?.length || inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place]?.back?.length || inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place]?.additional
            ? `${UpdateMessageSymbols.Line_Break}Location of the pressure injury:${` ${[...inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place].front, ...inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place].back].join(', ')}`}${inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place].additional ? `${ inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place]?.front?.length || inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place]?.back?.length ? ', ' : ''} ${inputsValues[Incident_PressureInjury_Inputs.Pressure_Injury_Place].additional}` : ''}.`
            : ''}

          ${inputsValues[Incident_PressureInjury_Inputs.Cause_Of_The_Pressure_Injury]
            ? 
          `${UpdateMessageSymbols.Line_Break}How it happened: ${inputsValues[Incident_PressureInjury_Inputs.Cause_Of_The_Pressure_Injury]}. `
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Happened_Outside_Of_The_Aged_Care_Home]?.includes(Incident_PressureInjury_Inputs.Happened_Outside_Of_The_Aged_Care_Home_Value)
          && inputsValues[Incident_PressureInjury_Inputs.Where_Did_The_Injury_Happen]
            ? `It happened ${inputsValues[Incident_PressureInjury_Inputs.Where_Did_The_Injury_Happen]}. `
            : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken] && inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.RN_Assessment_Of_Pain)
          ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.GP_Prescribed_Pain_Medication)
          ? 'The GP has prescribed pain medication. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Clinical_Nurse_Specialist_Review_Of_Pressure_Sore)
          ? 'A clinical nurse specialist has reviewed the pressure sore. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Cream_Applied)
          ? 'Cream has been applied. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Nutritional_Supplements_Have_Been_Commenced)
          ? 'Nutritional supplements have been commenced. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Our_Team_Are_Repositioning_Them_Regularly)
          ? 'Our team are repositioning them regularly as required to relieve pressure. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Air_Mattress_Used_To_Relieve_Pressure)
          ? 'An air mattress is being used to relieve pressure. '
          : ''}

        ${inputsValues[Incident_PressureInjury_Inputs.Actions_Taken]?.includes(Incident_PressureInjury_Inputs.Sheepskin_To_Relieve_Pressure)
          ? 'A sheepskin is being used to relieve pressure. '
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_PressureInjury_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_PressureInjury_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_PressureInjury_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_PressureInjury_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_PressureInjury_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_PressureInjury_Inputs.Cause_Of_The_Pressure_Injury,
              label: 'Cause of the pressure injury',
              placeholder: 'Write the cause of the pressure injury',
              validationSchema: Yup.string().required('Write the cause of the pressure injury'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_PressureInjury_Inputs.Happened_Outside_Of_The_Aged_Care_Home,
              label: '',
              checkboxes: [
                {
                  value: Incident_PressureInjury_Inputs.Happened_Outside_Of_The_Aged_Care_Home_Value, 
                  label: 'Happened outside of the aged care home', 
                },
              ],
              dependentInputs: {
                [Incident_PressureInjury_Inputs.Happened_Outside_Of_The_Aged_Care_Home_Value]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    value: undefined,
                    name: Incident_PressureInjury_Inputs.Where_Did_The_Injury_Happen,
                    label: 'Where did the injury happen?',
                    required: true,
                    validationSchema: Yup.string().required('Write where did the injury happen'),
                    placeholder: 'Write where did the injury happen',
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Incident_PressureInjury_Inputs.Pressure_Injury_Place,
              headerType: 'pressure injury'
            },
          ]
        },
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_PressureInjury_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_PressureInjury_Inputs.RN_Assessment_Of_Pain, 
                  label: 'RN Assessment of Pain', 
                },
                {
                  value: Incident_PressureInjury_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_PressureInjury_Inputs.GP_Prescribed_Pain_Medication, 
                  label: 'GP Prescribed pain medication', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Our_Team_Are_Repositioning_Them_Regularly, 
                  label: 'Our team are repositioning them regularly as required to relieve pressure', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Clinical_Nurse_Specialist_Review_Of_Pressure_Sore, 
                  label: 'Clinical nurse specialist review of pressure sore', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Cream_Applied, 
                  label: 'Cream applied', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Air_Mattress_Used_To_Relieve_Pressure, 
                  label: 'Air mattress used to relieve pressure', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Sheepskin_To_Relieve_Pressure, 
                  label: 'Sheepskin used to relieve the pressure area',
                },
                {
                  value: Incident_PressureInjury_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
                {
                  value: Incident_PressureInjury_Inputs.Nutritional_Supplements_Have_Been_Commenced, 
                  label: 'Nutritional supplements have been commenced', 
                },

              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_PressureInjury_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_PressureInjury_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Incident_SubSections.Ulcer]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has an ulcer.

          ${inputsValues[Incident_Ulcer_Inputs.Ulcer_Place]?.front?.length || inputsValues[Incident_Ulcer_Inputs.Ulcer_Place]?.back?.length || inputsValues[Incident_Ulcer_Inputs.Ulcer_Place]?.additional
            ? `${UpdateMessageSymbols.Line_Break}Location of the ulcer:${` ${[...inputsValues[Incident_Ulcer_Inputs.Ulcer_Place].front, ...inputsValues[Incident_Ulcer_Inputs.Ulcer_Place].back].join(', ')}`}${inputsValues[Incident_Ulcer_Inputs.Ulcer_Place].additional ? `${ inputsValues[Incident_Ulcer_Inputs.Ulcer_Place]?.front?.length || inputsValues[Incident_Ulcer_Inputs.Ulcer_Place]?.back?.length ? ', ' : ''} ${inputsValues[Incident_Ulcer_Inputs.Ulcer_Place].additional}` : ''}.`
            : ''}

          ${inputsValues[Incident_Ulcer_Inputs.Cause_Of_The_Ulcer]
            ? 
          `${UpdateMessageSymbols.Line_Break}How it happened: ${inputsValues[Incident_Ulcer_Inputs.Cause_Of_The_Ulcer]}. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken] && inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.RN_Assessment_Of_Pain)
          ? `An RN has conducted an Assessment of Pain on ${mainValues.firstName}. `
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.GP_Prescribed_Pain_Medication)
          ? 'The GP has prescribed pain medication. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.Clinical_Nurse_Review_Of_Ulcer)
          ? 'A clinical nurse specialist has reviewed the ulcer. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.Dressing_Applied)
          ? 'A dressing has been applied. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.Cream_Applied)
          ? 'Cream has been applied. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.Nutritional_Supplements_Have_Been_Commenced)
          ? 'Nutritional supplements have been commenced. '
          : ''}

        ${inputsValues[Incident_Ulcer_Inputs.Actions_Taken]?.includes(Incident_Ulcer_Inputs.Refer_To_Wound_Specialist)
          ? `${mainValues.firstName} has been referred to a wound specialist. `
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_Ulcer_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Ulcer_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Ulcer_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Ulcer_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Ulcer_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Ulcer_Inputs.Cause_Of_The_Ulcer,
              label: 'Cause of the ulcer',
              placeholder: 'Write the cause of the ulcer',
              validationSchema: Yup.string().required('Write the cause of the ulcer'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Incident_Ulcer_Inputs.Ulcer_Place,
              headerType: 'ulcer'
            },
          ]
        },
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Ulcer_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Ulcer_Inputs.RN_Assessment_Of_Pain, 
                  label: 'RN Assessment of Pain', 
                },
                {
                  value: Incident_Ulcer_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_Ulcer_Inputs.GP_Prescribed_Pain_Medication, 
                  label: 'GP Prescribed pain medication', 
                },
                {
                  value: Incident_Ulcer_Inputs.Clinical_Nurse_Review_Of_Ulcer, 
                  label: 'Clinical nurse review of ulcer', 
                },
                {
                  value: Incident_Ulcer_Inputs.Cream_Applied, 
                  label: 'Cream applied', 
                },
                {
                  value: Incident_Ulcer_Inputs.Dressing_Applied, 
                  label: 'Dressing applied', 
                },
                {
                  value: Incident_Ulcer_Inputs.Nutritional_Supplements_Have_Been_Commenced, 
                  label: 'Nutritional supplements have been commenced', 
                },
                {
                  value: Incident_Ulcer_Inputs.Refer_To_Wound_Specialist, 
                  label: 'Refer to a wound specialist', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Ulcer_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Ulcer_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Incident_SubSections.Absconding]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} had absconding behavior.

        ${inputsValues[Incident_Absconding_Inputs.Description_Of_What_Happened]
          ? ` ${inputsValues[Incident_Absconding_Inputs.Description_Of_What_Happened]}.`
          : ''}
         ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[Incident_Absconding_Inputs.Actions_Taken] && inputsValues[Incident_Absconding_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_Absconding_Inputs.Actions_Taken]?.includes(Incident_Absconding_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_Absconding_Inputs.Actions_Taken]?.includes(Incident_Absconding_Inputs.RN_Completed_Head_To_Toe_Assessment)
          ? 'An RN has completed head to toe assessment. '
          : ''}

        ${inputsValues[Incident_Absconding_Inputs.Actions_Taken]?.includes(Incident_Absconding_Inputs.Commence_Delirium_Screening)
          ? `Delirium screening has been commenced. `
          : ''}

        ${inputsValues[Incident_Absconding_Inputs.Actions_Taken]?.includes(Incident_Absconding_Inputs.Referral_To_Dementia_Support_Australia)
          ? `${mainValues.firstName} has been referred to dementia support Australia. `
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_Absconding_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Absconding_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Absconding_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Absconding_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Absconding_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Absconding_Inputs.Description_Of_What_Happened,
              label: 'Description of what happened',
              placeholder: 'Write the description of what happened',
              validationSchema: Yup.string().required('Write the description of what happened'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Absconding_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Absconding_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_Absconding_Inputs.RN_Completed_Head_To_Toe_Assessment, 
                  label: 'RN completed head to toe assessment', 
                },
                {
                  value: Incident_Absconding_Inputs.Commence_Delirium_Screening, 
                  label: 'Commence delirium screening', 
                },
                {
                  value: Incident_Absconding_Inputs.Referral_To_Dementia_Support_Australia, 
                  label: 'Referral to dementia support Australia', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Absconding_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Absconding_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Incident_SubSections.Behaviour]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `We are sharing a situation that involved ${mainValues.firstName}.

        ${inputsValues[Incident_Behavior_Inputs.Description_Of_What_Happened]
          ? ` Here's the outline of what happened: ${inputsValues[Incident_Behavior_Inputs.Description_Of_What_Happened]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[Incident_Behavior_Inputs.Actions_Taken] && inputsValues[Incident_Behavior_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_Behavior_Inputs.Actions_Taken]?.includes(Incident_Behavior_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_Behavior_Inputs.Actions_Taken]?.includes(Incident_Behavior_Inputs.Commence_Delirium_Screening)
          ? `Delirium screening has been commenced. `
          : ''}

        ${inputsValues[Incident_Behavior_Inputs.Actions_Taken]?.includes(Incident_Behavior_Inputs.Referral_To_Dementia_Support_Australia)
          ? `${mainValues.firstName} has been referred to dementia support Australia. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        Our team will continue to provide support and monitor ${mainValues.firstName}’s wellbeing.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Incident_Behavior_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Behavior_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Behavior_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Behavior_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Behavior_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Behavior_Inputs.Description_Of_What_Happened,
              label: 'Description of what happened',
              placeholder: 'Write the description of what happened',
              validationSchema: Yup.string().required('Write the description of what happened'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Behavior_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Behavior_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_Behavior_Inputs.Commence_Delirium_Screening, 
                  label: 'Commence delirium screening', 
                },
                {
                  value: Incident_Behavior_Inputs.Referral_To_Dementia_Support_Australia, 
                  label: 'Referral to dementia support Australia', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Behavior_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Behavior_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Incident_SubSections.Follow_up]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `This update is a follow-up for the following incident:
        ${inputsValues[Incident_Follow_up.Describe_Incident]
              ? ` ${inputsValues[Incident_Follow_up.Describe_Incident]}. `
              : ''}
              
        ${UpdateMessageSymbols.Paragraph_Break}
        
        Here is an outline of the actions taken to since the incident:
        ${inputsValues[Incident_Follow_up.Describe_the_actions]
              ? ` ${inputsValues[Incident_Follow_up.Describe_the_actions]}. `
              : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Incident_Follow_up.How_Is_The_Resident_Feeling]
              ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Follow_up.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
              : ''}
        
        ${inputsValues[Incident_Follow_up.Other_Information]
              ? `Further information: ${inputsValues[Incident_Follow_up.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Follow_up.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Follow_up.Describe_Incident,
              label: 'Describe the incident that occurred',
              placeholder: 'Write the description of the incident that occurred',
              validationSchema: Yup.string().required('Write the description of the incident that occurred'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Follow_up.Describe_the_actions,
              label: 'Describe the actions that have been taken since the incident',
              placeholder: 'Write the description the actions that have been taken since the incident',
              validationSchema: Yup.string().required('Write the actions that have been taken since the incident'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Follow_up.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Follow_up.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Incident_SubSections.Choking]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} was choking.

        ${inputsValues[Incident_Choking_Inputs.Description_Of_What_Happened]
          ? ` ${inputsValues[Incident_Choking_Inputs.Description_Of_What_Happened]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Incident_Choking_Inputs.Actions_Taken] && inputsValues[Incident_Choking_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[Incident_Choking_Inputs.Actions_Taken]?.includes(Incident_Choking_Inputs.GP_Informed)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[Incident_Choking_Inputs.Actions_Taken]?.includes(Incident_Choking_Inputs.First_Aid_Provided_By_RN)
          ? `An RN has provided first aid. `
          : ''}

        ${inputsValues[Incident_Choking_Inputs.Actions_Taken]?.includes(Incident_Choking_Inputs.Geriatrician_Review)
          ? `A geriatric review has been done `
          : ''}

        ${inputsValues[Incident_Choking_Inputs.Actions_Taken]?.includes(Incident_Choking_Inputs.Referral_To_Speech_Pathologist)
          ? `${mainValues.firstName} has been referred to a speech pathologist. `
          : ''}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}
    
        ${inputsValues[Incident_Choking_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Choking_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Choking_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Choking_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Choking_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Choking_Inputs.Description_Of_What_Happened,
              label: 'Description of what happened',
              placeholder: 'Wite the description of what happened',
              validationSchema: Yup.string().required('Write the description of what happened'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Incident_Choking_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Incident_Choking_Inputs.GP_Informed, 
                  label: 'GP Informed', 
                },
                {
                  value: Incident_Choking_Inputs.First_Aid_Provided_By_RN, 
                  label: 'First aid provided by RN', 
                },
                {
                  value: Incident_Choking_Inputs.Geriatrician_Review, 
                  label: 'Geriatrician review', 
                },
                {
                  value: Incident_Choking_Inputs.Referral_To_Speech_Pathologist, 
                  label: 'Referral to speech pathologist', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Choking_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Choking_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Incident_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} had an incident.

        ${inputsValues[Incident_Other_Inputs.Description_Of_What_Happened]
          ? ` ${inputsValues[Incident_Other_Inputs.Description_Of_What_Happened]}. `
          : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Incident_Other_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Incident_Other_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[Incident_Other_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Incident_Other_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Incident_Other_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Other_Inputs.Description_Of_What_Happened,
              label: 'Description of what happened',
              placeholder: 'Write the description of what happened',
              validationSchema: Yup.string().required('Write the description of what happened'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Incident_Other_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Incident_Other_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
  },
  [Sections.Wound_Care]: {
    [Wound_Care_SubSections.Wound_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Outline of Wound Care completed by our team: Our team have reviewed ${mainValues.firstName} Wound Care.
        ${UpdateMessageSymbols.Line_Break}
        How the wound is responding to treatment: ${inputsValues[Wound_Care_Review_Inputs.Describe_wound_healing]}
              
        ${inputsValues[Wound_Care_Review_Inputs.Location_of_wound]?.front?.length || inputsValues[Wound_Care_Review_Inputs.Location_of_wound]?.back?.length || inputsValues[Wound_Care_Review_Inputs.Location_of_wound]?.additional
              ? `${UpdateMessageSymbols.Line_Break}Location of the wound:${` ${[...inputsValues[Wound_Care_Review_Inputs.Location_of_wound].front, ...inputsValues[Wound_Care_Review_Inputs.Location_of_wound].back].join(', ')}`}${inputsValues[Wound_Care_Review_Inputs.Location_of_wound].additional ? `${ inputsValues[Wound_Care_Review_Inputs.Location_of_wound]?.front?.length || inputsValues[Wound_Care_Review_Inputs.Location_of_wound]?.back?.length ? ', ' : ''} ${inputsValues[Wound_Care_Review_Inputs.Location_of_wound].additional}` : ''}.`
              : ''}
        ${UpdateMessageSymbols.Line_Break}
        ${inputsValues[Wound_Care_Review_Inputs.Action_taken] && inputsValues[Wound_Care_Review_Inputs.Action_taken]?.length
              ? `The follow actions have been taken by the team: ${UpdateMessageSymbols.Line_Break} `
              : ''}

        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Nurse_Assessment_of_Pain)
              ? 'Nurse Assessment of Pain. '
              : ''}

        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Pain_Relief_Analgesic_was_given)
              ? `${inputsValues[Wound_Care_Review_Inputs.Pain_Relief_Was_Effective] === Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_Yes
                  ? 'Pain relief analgesic was effective. '
                  : inputsValues[Wound_Care_Review_Inputs.Pain_Relief_Was_Effective] === Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_No
                      ? `Pain relief analgesic wasn’t effective. ${inputsValues[Wound_Care_Review_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain] && `The following actions are being taken to relieve pain: ${inputsValues[Pain_Pain_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain]}. `}`
                      : `${mainValues.firstName} is waiting for effect of pain relief. `}`
              : ''}

        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Senior_Nurse_Review_Conducted_of_Wound)
              ? 'Senior Nurse Review Conducted of Wound. '
              : ''}

        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.No_changes_to_current_treatment_Plan)
              ? 'No changes to current treatment Plan. '
              : ''}
              
        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Treatment_Plan_has_been_changed)
              ? 'Treatment Plan has been changed. '
              : ''}
              
        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Referral_to_Wound_Specialist_Completed)
              ? 'Referral to Wound Specialist Completed. '
              : ''}
              
        ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Action_Taken_Other)
              ? `${inputsValues[Wound_Care_Review_Inputs.What_The_Action_Taken_Other] ? inputsValues[Wound_Care_Review_Inputs.What_The_Action_Taken_Other] + '. ' : ''}`
              : ''}
              
          ${inputsValues[Wound_Care_Review_Inputs.Action_taken]?.includes(Wound_Care_Review_Inputs.Transferred_to_Hospital)
              ? `
             ${inputsValues[Wound_Care_Review_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                  ? `${mainValues.firstName} has been transferred to ${inputsValues[Wound_Care_Review_Inputs.Hospital_Location]}.`
                  : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
              }
            `
              : `${mainValues.priority === UpdatePriorities.High ? `We monitored ${mainValues.firstName} closely following the incident. ${mainValues.firstName} continued to receive care at ${mainValues.home} without needing a hospital transfer.` : ''}`}
              
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Wound_Care_Review_Inputs.How_Is_The_Resident_Feeling]
              ? `How is ${mainValues.firstName}? ${inputsValues[Wound_Care_Review_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
              : ''}
        
        ${inputsValues[Wound_Care_Review_Inputs.Other_Information]
              ? `We have some further helpful information: ${inputsValues[Wound_Care_Review_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Wound_Care_Review_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Wound_Care_Review_Inputs.Describe_wound_healing,
              label: 'Describe how the wound is responding to current treatment',
              placeholder: 'Write the description how the wound is responding to current treatment',
              validationSchema: Yup.string().required('Write the description how the wound is responding to current treatment'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Wound_Care_Review_Inputs.Location_of_wound,
              headerType: 'wound'
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Wound_Care_Review_Inputs.Action_taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Wound_Care_Review_Inputs.Nurse_Assessment_of_Pain,
                  label: 'Nurse Assessment of Pain',
                },
                {
                  value: Wound_Care_Review_Inputs.Pain_Relief_Analgesic_was_given,
                  label: 'Pain Relief Analgesic was given ',
                },
                {
                  value: Wound_Care_Review_Inputs.Senior_Nurse_Review_Conducted_of_Wound,
                  label: 'Senior Nurse Review Conducted of Wound',
                },
                {
                  value: Wound_Care_Review_Inputs.Nurse_Assessment_of_Pain,
                  label: 'No changes to current treatment Plan',
                  conditions: [
                    {
                      priority: UpdatePriorities.Low,
                    }
                  ]
                },
                {
                  value: Wound_Care_Review_Inputs.Treatment_Plan_has_been_changed,
                  label: 'Treatment Plan has been changed',
                  conditions: [
                    {
                      priority: UpdatePriorities.Medium,
                    },
                    {
                      priority: UpdatePriorities.High,
                    }
                  ]
                },
                {
                  value: Wound_Care_Review_Inputs.Referral_to_Wound_Specialist_Completed,
                  label: 'Referral to Wound Specialist Completed',
                  conditions: [
                    {
                      priority: UpdatePriorities.Medium,
                    },
                    {
                      priority: UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Wound_Care_Review_Inputs.Transferred_to_Hospital,
                  label: 'Transferred to Hospital',
                  conditions: [
                    {
                      priority: UpdatePriorities.High,
                    }
                  ]
                },
                {
                  value: Wound_Care_Review_Inputs.Action_Taken_Other,
                  label: 'Other',
                },
              ],
              dependentInputs: {
                [Wound_Care_Review_Inputs.Pain_Relief_Analgesic_was_given]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_Yes, label: 'Yes'},
                      {value: Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_No, label: 'No'},
                      {value: Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_Waiting, label: 'Waiting for effect '},
                    ],
                    name: Wound_Care_Review_Inputs.Pain_Relief_Was_Effective,
                    value: undefined,
                    label: 'Pain relief was effective',
                    className: `${styles.padding_1} ${styles.fullWidth}`,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    dependentInputs: {
                      [Wound_Care_Review_Inputs.Pain_Relief_Was_Effective_No]: [
                        {
                          type: UpdateInputsTypes.TextInput,
                          multiline: true,
                          className: styles.padding_1,
                          required: true,
                          validationSchema: Yup.string().required('Write iother actions are being taken to relieve pain'),
                          name: Wound_Care_Review_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain,
                          label: 'What other actions are being taken to relieve pain?',
                          placeholder: 'Write other actions are being taken to relieve pain',
                        },
                      ]
                    },
                  },
                ],
                [Wound_Care_Review_Inputs.Action_Taken_Other]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    required: true,
                    validationSchema: Yup.string().required('Write other actions are being taken'),
                    name: Wound_Care_Review_Inputs.What_The_Action_Taken_Other,
                    label: 'What other actions are being taken?',
                    placeholder: 'Write other actions are being taken',
                  },
                ]
              }
            },
            {
              conditions: [
                {[Wound_Care_Review_Inputs.Action_taken]: Wound_Care_Review_Inputs.Transferred_to_Hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Wound_Care_Review_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Wound_Care_Review_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Wound_Care_Review_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Wound_Care_Review_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Wound_Care_SubSections.Wound_Healed]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Outline of Wound Healed completed by our team: Our team have reviewed ${mainValues.firstName} Wound Care. Their wound has healed.

        Summary of the wound healed: ${inputsValues[Wound_Care_Healing_Inputs.Describe_wound_healing]}
              
        ${inputsValues[Wound_Care_Healing_Inputs.Location_of_wound]?.front?.length || inputsValues[Wound_Care_Healing_Inputs.Location_of_wound]?.back?.length || inputsValues[Wound_Care_Healing_Inputs.Location_of_wound]?.additional
              ? `${UpdateMessageSymbols.Line_Break}Location of the wound:${` ${[...inputsValues[Wound_Care_Healing_Inputs.Location_of_wound].front, ...inputsValues[Wound_Care_Healing_Inputs.Location_of_wound].back].join(', ')}`}${inputsValues[Wound_Care_Healing_Inputs.Location_of_wound].additional ? `${ inputsValues[Wound_Care_Healing_Inputs.Location_of_wound]?.front?.length || inputsValues[Wound_Care_Healing_Inputs.Location_of_wound]?.back?.length ? ', ' : ''} ${inputsValues[Wound_Care_Healing_Inputs.Location_of_wound].additional}` : ''}.`
              : ''}
        ${UpdateMessageSymbols.Line_Break}
              
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Wound_Care_Healing_Inputs.How_Is_The_Resident_Feeling]
              ? `How is ${mainValues.firstName}? ${inputsValues[Wound_Care_Healing_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
              : ''}
        
        ${inputsValues[Wound_Care_Healing_Inputs.Other_Information]
              ? `We have some further helpful information: ${inputsValues[Wound_Care_Healing_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Wound_Care_Healing_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Wound_Care_Healing_Inputs.Describe_wound_healing,
              label: 'Summary of healed wound',
              placeholder: 'Write the summary of healed wound',
              validationSchema: Yup.string().required('Write the summary of healed wound'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Wound_Care_Healing_Inputs.Location_of_wound,
              headerType: 'wound'
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Wound_Care_Healing_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Wound_Care_Healing_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Change_To_Condition]: {
    [Change_To_Condition_SubSections.Change_To_Cognition]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `The cognition of ${mainValues.firstName} has changed. 

        ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.Description_Of_Change]
          ? ` ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.Description_Of_Change]}. `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.ReviewBy] === RadioBoolean.Yes
          ? ` ${mainValues.firstName} has been reviewed by GP.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_ChangeToCognition_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_ChangeToCognition_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToCognition_Inputs.Description_Of_Change,
              label: 'Description of the change to cognition',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: ChangeToCondition_ChangeToCognition_Inputs.ReviewBy,
              value: undefined,
              label: 'Review by GP?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_ChangeToCognition_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToCognition_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Change_To_Condition_SubSections.Change_To_Mobility]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `The mobility of ${mainValues.firstName} has changed. 

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Description_Of_Change]
          ? ` ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Description_Of_Change]}. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken] && inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToMobility_Inputs.GP_Notified)
          ? `The GP has been informed. `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToMobility_Inputs.Review_By_Physio)
          ? `${mainValues.firstName} has been reviewed by a physiotherapist: ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Physio_Recommendation]}. `
          : `${mainValues.firstName} hasn’t been reviewed by Physio. `}

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToMobility_Inputs.GP_Prescribed_Treatment)
          ? `The GP has prescribed the following treatment: ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Prescribed_Treatment]}. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_ChangeToMobility_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToMobility_Inputs.Description_Of_Change,
              label: 'Description of the change to mobility',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: ChangeToCondition_ChangeToMobility_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: ChangeToCondition_ChangeToMobility_Inputs.GP_Notified, 
                  label: 'GP Informed', 
                },
                {
                  value: ChangeToCondition_ChangeToMobility_Inputs.Review_By_Physio, 
                  label: 'Review by physio', 
                },
                {
                  value: ChangeToCondition_ChangeToMobility_Inputs.GP_Prescribed_Treatment, 
                  label: 'GP prescribed treatment', 
                },
              ],
              dependentInputs: {
                [ChangeToCondition_ChangeToMobility_Inputs.Review_By_Physio]: [{
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    value: undefined,
                    name: ChangeToCondition_ChangeToMobility_Inputs.Physio_Recommendation,
                    label: 'Physio recommendation',
                    required: true,
                    validationSchema: Yup.string().required('Write the physio recommendation'),
                    placeholder: 'Write the physio recommendation',
                }],
                [ChangeToCondition_ChangeToMobility_Inputs.GP_Prescribed_Treatment]: [{
                  type: UpdateInputsTypes.TextInput,
                  multiline: true,
                  value: undefined,
                  name: ChangeToCondition_ChangeToMobility_Inputs.Prescribed_Treatment,
                  label: 'GP prescribed treatment',
                  placeholder: 'Write the prescribed treatment',
                }]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_ChangeToMobility_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToMobility_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Change_To_Condition_SubSections.Change_To_Appetite]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `The appetite of ${mainValues.firstName} has changed. 

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Description_Of_Change]
          ? ` ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Description_Of_Change]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken] && inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.Commenced_Food_Chart)
          ? 'A food chart has been commenced. '
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.Weight_Reviewed)
          ? `The weight has been reviewed. `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.Weekly_Weight_Monitoring)
          ? `Weight will be monitored weekly. `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.Dietician_Referral)
          ? `${mainValues.firstName} has been referred to a dietician `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.GP_Notified)
          ? `The GP has been informed. `
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken]?.includes(ChangeToCondition_ChangeToAppetite_Inputs.Recommendations_For_Supplements)
          ? `Supplements have been recommended. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_ChangeToAppetite_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToAppetite_Inputs.Description_Of_Change,
              label: 'Description of the change to appetite',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: ChangeToCondition_ChangeToAppetite_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.GP_Notified, 
                  label: 'GP notified', 
                },
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.Commenced_Food_Chart, 
                  label: 'Commenced food chart', 
                },
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.Weight_Reviewed, 
                  label: 'Weight reviewed', 
                },
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.Weekly_Weight_Monitoring, 
                  label: 'Weight will be monitored weekly', 
                },
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.Dietician_Referral, 
                  label: 'Dietician referral', 
                },
                {
                  value: ChangeToCondition_ChangeToAppetite_Inputs.Recommendations_For_Supplements, 
                  label: 'Recommendations for supplements', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_ChangeToAppetite_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToAppetite_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Change_To_Condition_SubSections.Change_To_Behaviour_Mood]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `The mood and behavior of ${mainValues.firstName} has changed. 

        ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Description_Of_Change]
          ? ` Here is an outline of what happened: ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Description_Of_Change]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
          
        ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Action_Taken_To_Care_For_This]
          ? `Our team has taken the following actions: ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Action_Taken_To_Care_For_This]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}

        ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_ChangeToBehaviourMood_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToBehaviourMood_Inputs.Description_Of_Change,
              label: 'Description of the change to behavior',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToBehaviourMood_Inputs.Action_Taken_To_Care_For_This,
              label: 'Action taken to care for this',
              placeholder: 'Write the action taken to care for this',
              validationSchema: Yup.string().required('Write the action taken to care for this'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_ChangeToBehaviourMood_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_ChangeToBehaviourMood_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Change_To_Condition_SubSections.Weight_Change_Update]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `The weight of ${mainValues.firstName} has changed. 

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Description_Of_Change]
          ? ` ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Description_Of_Change]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken] && inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.Commenced_Food_Chart)
          ? 'A food chart has been commenced. '
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.Weight_Reviewed)
          ? `The weight has been reviewed. `
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.Weekly_Weight_Monitoring)
          ? `Weight will be monitored weekly. `
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.Dietician_Referral)
          ? `${mainValues.firstName} has been referred to a dietician. `
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.GP_Notified)
          ? `The GP has been informed. `
          : ''}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken]?.includes(ChangeToCondition_WeightChangeUpdate_Inputs.Recommendations_For_Supplements)
          ? `Supplements have been recommended. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_WeightChangeUpdate_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_WeightChangeUpdate_Inputs.Description_Of_Change,
              label: 'Description of the weight change',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: ChangeToCondition_WeightChangeUpdate_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.GP_Notified, 
                  label: 'GP notified', 
                },
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.Commenced_Food_Chart, 
                  label: 'Commenced food chart', 
                },
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.Weight_Reviewed, 
                  label: 'Weight reviewed', 
                },
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.Weekly_Weight_Monitoring, 
                  label: 'Weight will be monitored weekly', 
                },
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.Dietician_Referral, 
                  label: 'Dietician referral', 
                },
                {
                  value: ChangeToCondition_WeightChangeUpdate_Inputs.Recommendations_For_Supplements, 
                  label: 'Recommendations for supplements', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_WeightChangeUpdate_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_WeightChangeUpdate_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
    [Change_To_Condition_SubSections.Other_General_Update]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} had some changes in condition. 

        ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.Description_Of_Change]
          ? ` ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.Description_Of_Change]}.`
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.Other_Information]
          ? `Further information: ${inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[ChangeToCondition_OtherGeneralUpdate_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_OtherGeneralUpdate_Inputs.Description_Of_Change,
              label: 'Description of change',
              placeholder: 'Write the description of change',
              validationSchema: Yup.string().required('Write the description of change'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: ChangeToCondition_OtherGeneralUpdate_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: ChangeToCondition_OtherGeneralUpdate_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
  },
  [Sections.Physiotherapist]: {
    [Physiotherapist_SubSections.Initial_Physio_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{ [key in InputsName]: any }>) => formatSummaryMessage(
          `${mainValues.firstName} has had an Initial Physiotherapist Review
          ${inputsValues[Physiotherapist_Initial_Inputs.Description]}. 
          ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [{
        inputs: [
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Description,
            label: 'Description of the Initial Physiotherapist Review',
            placeholder: 'Write the description of the Initial Physiotherapist Review',
            validationSchema: Yup.string().required('Write the description of the Initial Physiotherapist Review'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling,
            label: 'How is the resident',
            placeholder: 'Write how is the resident',
            subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
            validationSchema: Yup.string().required('Write how is the resident'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Other_Information,
            label: 'Further information',
            placeholder: 'Please write any further information that will be helpful for the family to know ',
          },
        ]
      }]
    },
    [Physiotherapist_SubSections.Physio_Post_Fall_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{ [key in InputsName]: any }>) => formatSummaryMessage(
          `${mainValues.firstName} has had a physio post fall review
          ${UpdateMessageSymbols.Line_Break}
          ${inputsValues[Physiotherapist_Post_Fall_Inputs.Description]}. 
          ${UpdateMessageSymbols.Paragraph_Break}
          
          Date and Time when ${mainValues.firstName} was injured: ${moment(inputsValues[Physiotherapist_Post_Fall_Inputs.Date_Time_Resident_Was_Injured]).format("DD MMM YYYY")}
          at ${moment(inputsValues[Physiotherapist_Post_Fall_Inputs.Date_Time_Resident_Was_Injured]).format("hh:mm A")}.
          
          ${inputsValues[Physiotherapist_Post_Fall_Inputs.Changes_To_Mobility_Needed] === RadioBoolean.Yes ?
              `There were changes in mobility/equipment: ${inputsValues[Physiotherapist_Post_Fall_Inputs.State_Changes_Made_To_Mobility_Or_Equipment]}`
              :
              'No changes were needed to mobility/equipment'
          }
          
          ${inputsValues[Physiotherapist_Post_Fall_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Physiotherapist_Post_Fall_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Physiotherapist_Post_Fall_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Physiotherapist_Post_Fall_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [{
        inputs: [
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Post_Fall_Inputs.Description,
            label: 'Describe the outline of the Physio Post-Fall Review',
            placeholder: 'Write the description of the Physio Post-Fall Review',
            validationSchema: Yup.string().required('Write the description of the Physio Post-Fall Review'),
            required: true,
          },
          {
            type: UpdateInputsTypes.DateInput,
            name: Physiotherapist_Post_Fall_Inputs.Date_Time_Resident_Was_Injured,
            label: 'Date & Time the Resident was Injuried',
            placeholder: 'Select date & time the resident was injuried',
            maxDate: new Date(),
            dateType: 'dateTime',
            validationSchema: Yup.date().required('Date & Time the Resident was Injuried is required'),
          },

          {
            type: UpdateInputsTypes.RadioInput,
            radios: [
              {value: RadioBoolean.Yes, label: 'Yes'},
              {value: RadioBoolean.No, label: 'No'},
            ],
            name: Physiotherapist_Post_Fall_Inputs.Changes_To_Mobility_Needed,
            value: undefined,
            label: 'Were there any changes to mobility or equipment needed?',
            required: true,
            validationSchema: Yup.string().required('Please select one'),
            dependentInputs: {
              [RadioBoolean.Yes]: [
                {
                  type: UpdateInputsTypes.TextInput,
                  multiline: true,
                  value: undefined,
                  name: Physiotherapist_Post_Fall_Inputs.State_Changes_Made_To_Mobility_Or_Equipment,
                  label: 'State changes made to mobility or equipment',
                  placeholder: 'Write the state changes made to mobility or equipment',
                  validationSchema: Yup.string().required('Write the state changes made to mobility or equipment'),
                  required: true,
                },
              ]
            }
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Post_Fall_Inputs.How_Is_The_Resident_Feeling,
            label: 'How is the resident',
            placeholder: 'Write how is the resident',
            subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
            validationSchema: Yup.string().required('Write how is the resident'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Post_Fall_Inputs.Other_Information,
            label: 'Further information',
            placeholder: 'Please write any further information that will be helpful for the family to know ',
          },
        ]
      }]
    },
    [Physiotherapist_SubSections.Physio_Mobility_Equipment_Review]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{ [key in InputsName]: any }>) => formatSummaryMessage(
          `${mainValues.firstName} has had an Physio Mobility/equipment review
          ${inputsValues[Physiotherapist_Mobility_Review_Inputs.Description]}. 
          ${UpdateMessageSymbols.Paragraph_Break}
          ${inputsValues[Physiotherapist_Mobility_Review_Inputs.Changes_To_Mobility_Needed] === RadioBoolean.Yes ?
              `There were changes in mobility/equipment: ${inputsValues[Physiotherapist_Mobility_Review_Inputs.State_Changes_Made_To_Mobility_Or_Equipment]}`
              :
              ''
          }
          ${inputsValues[Physiotherapist_Mobility_Review_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Physiotherapist_Mobility_Review_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Physiotherapist_Mobility_Review_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Physiotherapist_Mobility_Review_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [{
        inputs: [
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Mobility_Review_Inputs.Description,
            label: 'Description of the Mobility & Equipment Review',
            placeholder: 'Write the description of the Mobility & Equipment Review',
            validationSchema: Yup.string().required('Write the description of the Mobility & Equipment Review'),
            required: true,
          },
          {
            type: UpdateInputsTypes.RadioInput,
            radios: [
              {value: RadioBoolean.Yes, label: 'Yes'},
              {value: RadioBoolean.No, label: 'No'},
            ],
            name: Physiotherapist_Mobility_Review_Inputs.Changes_To_Mobility_Needed,
            value: undefined,
            label: 'Were there any changes to mobility or equipment needed?',
            required: true,
            validationSchema: Yup.string().required('Please select one'),
            dependentInputs: {
              [RadioBoolean.Yes]: [
                {
                  type: UpdateInputsTypes.TextInput,
                  multiline: true,
                  value: undefined,
                  name: Physiotherapist_Mobility_Review_Inputs.State_Changes_Made_To_Mobility_Or_Equipment,
                  label: 'State changes made to mobility or equipment',
                  placeholder: 'Write the state changes made to mobility or equipment',
                  validationSchema: Yup.string().required('Write the state changes made to mobility or equipment'),
                  required: true,
                },
              ]
            }
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Mobility_Review_Inputs.How_Is_The_Resident_Feeling,
            label: 'How is the resident',
            placeholder: 'Write how is the resident',
            subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
            validationSchema: Yup.string().required('Write how is the resident'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Mobility_Review_Inputs.Other_Information,
            label: 'Further information',
            placeholder: 'Please write any further information that will be helpful for the family to know ',
          },
        ]
      }]
    },
    [Physiotherapist_SubSections.Physio_Private_Session]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{ [key in InputsName]: any }>) => formatSummaryMessage(
          `${mainValues.firstName} has had a Physiotherapist Private Session
          ${inputsValues[Physiotherapist_Initial_Inputs.Description]}. 
          ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [{
        inputs: [
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Description,
            label: 'Description of the Physio Private session Review',
            placeholder: 'Write the description of the Physio Private session Review',
            validationSchema: Yup.string().required('Write the description of the Physio Private session Review'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling,
            label: 'How is the resident',
            placeholder: 'Write how is the resident',
            subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
            validationSchema: Yup.string().required('Write how is the resident'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Other_Information,
            label: 'Further information',
            placeholder: 'Please write any further information that will be helpful for the family to know ',
          },
        ]
      }]
    },
    [Physiotherapist_SubSections.Group_Physio_Led_Exercise_Session]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{ [key in InputsName]: any }>) => formatSummaryMessage(
          `${mainValues.firstName} has had a Group Physio-Led Exercise Session
           ${UpdateMessageSymbols.Paragraph_Break}
          ${inputsValues[Physiotherapist_Initial_Inputs.Description]}. 
          ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Physiotherapist_Initial_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [{
        inputs: [
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Description,
            label: 'Description of the Group Physio Led Exercise Session Review',
            placeholder: 'Write the description of the Group Physio Led Exercise Session Review',
            validationSchema: Yup.string().required('Write the description of the Group Physio Led Exercise Session Review'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.How_Is_The_Resident_Feeling,
            label: 'How is the resident',
            placeholder: 'Write how is the resident',
            subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
            validationSchema: Yup.string().required('Write how is the resident'),
            required: true,
          },
          {
            type: UpdateInputsTypes.TextInput,
            multiline: true,
            value: undefined,
            name: Physiotherapist_Initial_Inputs.Other_Information,
            label: 'Further information',
            placeholder: 'Please write any further information that will be helpful for the family to know ',
          },
        ]
      }]
    }
  },
  [Sections.Medication_Incidents]: {
    [Medication_Incidents_SubSections.Medication_Incidents]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `There has been an incident in relation to ${mainValues.firstName}'s medication. 

        ${UpdateMessageSymbols.Paragraph_Break}

        Outline of what happened 

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Description_Of_What_Happened]}. 
        The medication this relates to is ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.What_Medication]}.

        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Possible_Side_Effects]
          ? `The possible side effects are ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Possible_Side_Effects]}. We will monitor closely to see if any of these side effects are evident and will take appropriate action if they occur. `
          : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken] && inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}

        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.GP_Notified)
          ? 'The GP has been informed. '
          : ''}

        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Inform_The_Pharmacy)
          ? `The pharmacy has been informed. `
          : ''}
          
        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Incident_report_has_been_completed)
            ? `Incident report has been completed. `
            : ''}
            
        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Vital_Signs_taken_and_within_normal_parameters)
            ? `Vital Signs taken and within normal parameters. `
            : ''}
            
        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Vital_Signs_taken_and_and_out_of_normal_parameters)
            ? `Vital Signs taken and are out of normal parameters. ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Vital_Sign_Description]}.`
            : ''}
            
            ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Transfer_to_hospital)
            ? `
             ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                ? `${mainValues.firstName} has been transferred to ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Hospital_Location]}.`
                : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
            }
            `
            : `${mainValues.priority === UpdatePriorities.High ? `${mainValues.firstName} has not required transfer to hospital. ` : ''}`}

        ${!inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]?.includes(MedicationIncidents_MedicationIncidents_Inputs.Transfer_to_hospital) ? `Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.` : ``}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}`
          : ''}
        
        ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Other_Information]
          ? `Further information: ${inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[MedicationIncidents_MedicationIncidents_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: MedicationIncidents_MedicationIncidents_Inputs.Description_Of_What_Happened,
              label: 'Description of what happened',
              placeholder: 'Describe what happened',
              validationSchema: Yup.string().required('Describe what happened'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: MedicationIncidents_MedicationIncidents_Inputs.What_Medication,
              label: 'What medication',
              placeholder: 'Medication',
              validationSchema: Yup.string().required('Describe what medication'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: MedicationIncidents_MedicationIncidents_Inputs.Possible_Side_Effects,
              label: 'Possible side effects',
              placeholder: 'Describe possible side effects',
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.GP_Notified, 
                  label: 'GP Notified',
                },
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.Inform_The_Pharmacy, 
                  label: 'Inform the pharmacy', 
                },
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.Incident_report_has_been_completed,
                  label: 'Incident report has been completed',
                },
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.Vital_Signs_taken_and_within_normal_parameters,
                  label: 'Vital Signs taken and within normal parameters',
                },
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.Vital_Signs_taken_and_and_out_of_normal_parameters,
                  label: 'Vital Signs taken and are out of normal parameters',
                  conditions: [
                    {
                      'priority': UpdatePriorities.Medium,
                    },
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: MedicationIncidents_MedicationIncidents_Inputs.Transfer_to_hospital,
                  label: 'Transferred to Hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
              ],
              dependentInputs: {
                [MedicationIncidents_MedicationIncidents_Inputs.Vital_Signs_taken_and_and_out_of_normal_parameters]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    value: undefined,
                    className: `${styles.padding_1} ${styles.fullWidth}`,
                    name: MedicationIncidents_MedicationIncidents_Inputs.Vital_Sign_Description,
                    label: 'Describe the out of range vital signs and action taken',
                    placeholder: 'Describe the out of range vital signs and actions taken',
                  }
                ]
              }
            },
            {
              conditions: [
                {[MedicationIncidents_MedicationIncidents_Inputs.Actions_Taken]: MedicationIncidents_MedicationIncidents_Inputs.Transfer_to_hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: MedicationIncidents_MedicationIncidents_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: MedicationIncidents_MedicationIncidents_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: MedicationIncidents_MedicationIncidents_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: MedicationIncidents_MedicationIncidents_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
  },
  [Sections.Vaccination]: {
    [Vaccination_SubSections.Vaccination]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `${mainValues.firstName} has had ` + genderMapping[mainValues.gender] + ` ${
              inputsValues[Vaccination_Vaccination_Inputs.Vaccination_Administered] === Vaccination_Vaccination_Inputs.Other ?
                  inputsValues[Vaccination_Vaccination_Inputs.What_The_Other_Vaccination_Administered_Is]
                  :
                  inputsValues[Vaccination_Vaccination_Inputs.Vaccination_Administered]
          } today. This was given in ` + genderMapping[mainValues.gender] + ` ${inputsValues[Vaccination_Vaccination_Inputs.Location_of_Vaccination_Given]}
          ${UpdateMessageSymbols.Paragraph_Break}
          The ${
              inputsValues[Vaccination_Vaccination_Inputs.Vaccination_Administered] === Vaccination_Vaccination_Inputs.Other ?
                  inputsValues[Vaccination_Vaccination_Inputs.What_The_Other_Vaccination_Administered_Is]
                  :
                  inputsValues[Vaccination_Vaccination_Inputs.Vaccination_Administered]
          } was administered as per the documented consent. 
          ${inputsValues[Vaccination_Vaccination_Inputs.Is_Adverse_Effect_was_noted] === RadioBoolean.Yes && inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted].length ?
              `During assessment following ` + genderMapping[mainValues.gender] + ` vaccination, it was observed ${mainValues.firstName} was experiencing the following adverse effects: ` : ''
          }
          
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.High_Blood_Pressure)
              ? 'High Blood Pressure. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Low_Blood_Pressure)
              ? 'Low Blood Pressure. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.High_Heart_Rate)
              ? 'High Heart Rate. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Low_Heart_Rate)
              ? 'Low Heart Rate. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Shortness_of_Breath)
              ? 'Shortness of Breath. '
              : ''}    
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Swelling_to_Vaccination_Site)
              ? 'Swelling to Vaccination Site. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Pain_at_Vaccination_Site)
              ? 'Pain at Vaccination Site. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Increase_in_Body_temperature)
              ? 'Increase in Body temperature. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Muscle_Ache)
              ? 'Muscle Ache. '
              : ''}    
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Headache)
              ? 'Headache. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Nausea_Vomiting)
              ? 'Nausea/Vomiting. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Given_food_and_fluid)
              ? 'Given food and fluid. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted]?.includes(Vaccination_Vaccination_Inputs.Other_Adverse_Effect)
              ? `${inputsValues[Vaccination_Vaccination_Inputs.What_The_Other_Adverse_Effect_Is]}`
              : ''}
          
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken] && inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.length ?
              `
                ${UpdateMessageSymbols.Line_Break}
                Our team has taken the following immediate steps to support ${mainValues.firstName} following ` + genderMapping[mainValues.gender] + ` adverse effects: 
              `
              :
              ''
          }
          
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Given_food_and_fluid)
              ? 'Given food and fluid. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Administered_Oxygen)
              ? 'Administered Oxygen. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Ice_Pack_provided)
              ? 'Ice Pack provided. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Pain_Relief_Administered)
              ? 'Pain Relief Administered. '
              : ''}
              
        ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Pain_Relief_Administered)
              ? `${inputsValues[Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective] === Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_Yes
                  ? 'Pain relief was effective. '
                  : inputsValues[Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective] === Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_No
                      ? `Pain relief wasn’t effective. ${inputsValues[Vaccination_Vaccination_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain] && `The following actions are being taken to relieve pain: ${inputsValues[Vaccination_Vaccination_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain]}. `}`
                      : `${mainValues.firstName} is waiting for effect of pain relief. `}`
              : ''}
               
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Heat_Pack_Provided)
              ? 'Heat Pack Provided. '
              : ''}
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Anti_sickness_medication_given)
              ? 'Anti-sickness medication given. '
              : ''}
              
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Transfer_to_hospital)
              ? `
             ${inputsValues[Vaccination_Vaccination_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                  ? `${mainValues.firstName} has been transferred to ${inputsValues[Vaccination_Vaccination_Inputs.Hospital_Location]}.`
                  : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
              }
            `
              : `${mainValues.priority === UpdatePriorities.High ? `We monitored ${mainValues.firstName} closely following the incident. ${mainValues.firstName} continued to receive care at ${mainValues.home} without needing a hospital transfer. ` : ``}`}
              
          ${inputsValues[Vaccination_Vaccination_Inputs.Immediate_action_taken]?.includes(Vaccination_Vaccination_Inputs.Other_Immediate_action)
              ? `${inputsValues[Vaccination_Vaccination_Inputs.What_The_Other_Immediate_actio_Is]}. `
              : ''}
              
          
          ${inputsValues[Vaccination_Vaccination_Inputs.How_Is_The_Resident_Feeling] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Vaccination_Vaccination_Inputs.How_Is_The_Resident_Feeling]}.
            ` : ''}

          ${inputsValues[Vaccination_Vaccination_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Vaccination_Vaccination_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          `
      ),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.Select,
              name: Vaccination_Vaccination_Inputs.Vaccination_Administered,
              label: 'Vaccination Administered',
              placeholder: 'Select',
              items: [
                {title: 'Influenza Vaccine ', value: Vaccination_Vaccination_Inputs.Influenza_Vaccine, id: Vaccination_Vaccination_Inputs.Influenza_Vaccine},
                {title: 'ADT Booster', value: Vaccination_Vaccination_Inputs.ADT_Booster, id: Vaccination_Vaccination_Inputs.ADT_Booster},
                {title: 'Boosterix/Adacel', value: Vaccination_Vaccination_Inputs.Boosterix_Adacel, id: Vaccination_Vaccination_Inputs.Boosterix_Adacel},
                {title: 'Covid-19 1st Dose', value: Vaccination_Vaccination_Inputs.Covid_19_1st_Dose, id: Vaccination_Vaccination_Inputs.Covid_19_1st_Dose},
                {title: 'Covid-19 2nd Dose', value: Vaccination_Vaccination_Inputs.Covid_19_2nd_Dose, id: Vaccination_Vaccination_Inputs.Covid_19_2nd_Dose},
                {title: 'Covid-19 3rd Dose', value: Vaccination_Vaccination_Inputs.Covid_19_3rd_Dose, id: Vaccination_Vaccination_Inputs.Covid_19_3rd_Dose},
                {title: 'Covid-19 4th Dose', value: Vaccination_Vaccination_Inputs.Covid_19_4th_Dose, id: Vaccination_Vaccination_Inputs.Covid_19_4th_Dose},
                {title: 'Covid-19 Additional Dose', value: Vaccination_Vaccination_Inputs.Covid_19_Additional_Dose, id: Vaccination_Vaccination_Inputs.Covid_19_Additional_Dose},
                {title: 'Pneumococcal Vaccine', value: Vaccination_Vaccination_Inputs.Pneumococcal_Vaccine, id: Vaccination_Vaccination_Inputs.Pneumococcal_Vaccine},
                {title: 'Tamiflu/Relenza', value: Vaccination_Vaccination_Inputs.Tamiflu_Relenza, id: Vaccination_Vaccination_Inputs.Tamiflu_Relenza},
                {title: 'Zoster (Herpes Zoster)', value: Vaccination_Vaccination_Inputs.Zoster_Herpes_Zoster, id: Vaccination_Vaccination_Inputs.Zoster_Herpes_Zoster},
                {title: 'Other', value: Vaccination_Vaccination_Inputs.Other, id: Vaccination_Vaccination_Inputs.Other},
              ],
              validationSchema: Yup.string().required('Select Vaccination Administered'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Vaccination_Vaccination_Inputs.What_The_Other_Vaccination_Administered_Is,
              label: 'What the other Vaccination Administered?',
              placeholder: 'Write what the other Vaccination Administered',
              conditions: [
                {[Vaccination_Vaccination_Inputs.Vaccination_Administered]: Vaccination_Vaccination_Inputs.Other}
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              value: undefined,
              name: Vaccination_Vaccination_Inputs.Location_of_Vaccination_Given,
              label: 'Location of Vaccination Given',
              placeholder: 'Write the location of vaccination given',
              validationSchema: Yup.string().required('Write the location of vaccination given'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Vaccination_Vaccination_Inputs.Is_Adverse_Effect_was_noted,
              value: undefined,
              label: 'Was there an adverse effect noted',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              conditions: [
                {[Vaccination_Vaccination_Inputs.Is_Adverse_Effect_was_noted]: RadioBoolean.Yes}
              ],
              className: styles.padding_1,
              type: UpdateInputsTypes.CheckboxInput,
              name: Vaccination_Vaccination_Inputs.An_Adverse_Effect_was_noted,
              label: 'An Adverse Effect was noted',
              checkboxes: [
                {label: 'High Blood Pressure', value: Vaccination_Vaccination_Inputs.High_Blood_Pressure},
                {label: 'Low Blood Pressure', value: Vaccination_Vaccination_Inputs.Low_Blood_Pressure},
                {label: 'High Heart Rate', value: Vaccination_Vaccination_Inputs.High_Heart_Rate},
                {label: 'Low Heart Rate', value: Vaccination_Vaccination_Inputs.Low_Heart_Rate},
                {label: 'Shortness of Breath', value: Vaccination_Vaccination_Inputs.Shortness_of_Breath},
                {label: 'Swelling to Vaccination Site', value: Vaccination_Vaccination_Inputs.Swelling_to_Vaccination_Site},
                {label: 'Pain at Vaccination Site', value: Vaccination_Vaccination_Inputs.Pain_at_Vaccination_Site},
                {label: 'Increase in Body temperature ', value: Vaccination_Vaccination_Inputs.Increase_in_Body_temperature},
                {label: 'Muscle Ache ', value: Vaccination_Vaccination_Inputs.Muscle_Ache},
                {label: 'Headache', value: Vaccination_Vaccination_Inputs.Headache},
                {label: 'Nausea/Vomiting', value: Vaccination_Vaccination_Inputs.Nausea_Vomiting},
                {label: 'Other', value: Vaccination_Vaccination_Inputs.Other_Adverse_Effect},
              ],
              dependentInputs: {
                [Vaccination_Vaccination_Inputs.Other_Adverse_Effect]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Vaccination_Vaccination_Inputs.What_The_Other_Adverse_Effect_Is,
                    label: 'What the other Adverse Effect?',
                    placeholder: 'Write what the other Adverse Effect',
                  },
                ]
              },
            },
            {
              conditions: [
                {[Vaccination_Vaccination_Inputs.Is_Adverse_Effect_was_noted]: RadioBoolean.Yes}
              ],
              type: UpdateInputsTypes.CheckboxInput,
              name: Vaccination_Vaccination_Inputs.Immediate_action_taken,
              label: 'Immediate action taken (select all that apply):',
              className: styles.padding_1,
              checkboxes: [
                {
                  value: Vaccination_Vaccination_Inputs.Given_food_and_fluid,
                  label: 'Given food and fluid ',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Administered_Oxygen,
                  label: 'Administered Oxygen',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Ice_Pack_provided,
                  label: 'Ice Pack provided',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Heat_Pack_Provided,
                  label: 'Heat Pack Provided',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Pain_Relief_Administered,
                  label: 'Pain Relief Administered',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Anti_sickness_medication_given,
                  label: 'Anti-sickness medication given',
                },
                {
                  value: Vaccination_Vaccination_Inputs.Transfer_to_hospital,
                  label: 'Transferred to Hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.High,
                    },
                  ]
                },
                {
                  value: Vaccination_Vaccination_Inputs.Other_Immediate_action,
                  label: 'Other',
                },
              ],
              dependentInputs: {
                [Vaccination_Vaccination_Inputs.Other_Immediate_action]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Vaccination_Vaccination_Inputs.What_The_Other_Immediate_actio_Is,
                    label: 'What the other immediate action?',
                    placeholder: 'Write what the other immediate action',
                  },
                ],
                [Vaccination_Vaccination_Inputs.Pain_Relief_Administered]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_Yes, label: 'Yes'},
                      {value: Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_No, label: 'No'},
                      {value: Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_Waiting, label: 'Waiting for effect '},
                    ],
                    name: Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective,
                    value: undefined,
                    label: 'Pain relief was effective',
                    className: `${styles.padding_1} ${styles.fullWidth}`,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    dependentInputs: {
                      [Vaccination_Vaccination_Inputs.Pain_Relief_Was_Effective_No]: [
                        {
                          type: UpdateInputsTypes.TextInput,
                          multiline: true,
                          className: styles.padding_1,
                          required: true,
                          validationSchema: Yup.string().required('Write other actions are being taken to relieve pain'),
                          name: Vaccination_Vaccination_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain,
                          label: 'What other actions are being taken to relieve pain?',
                          placeholder: 'Write other actions are being taken to relieve pain',
                        },
                      ]
                    },
                  },
                ]
              },
            },
            {
              conditions: [
                {[Vaccination_Vaccination_Inputs.Immediate_action_taken]: Vaccination_Vaccination_Inputs.Transfer_to_hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Vaccination_Vaccination_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Vaccination_Vaccination_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Vaccination_Vaccination_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Vaccination_Vaccination_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ],
        }
      ]
    },
  },
  [Sections.Pain]: {
    [Pain_SubSections.Pain]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `Overview of ${mainValues.firstName}'s current Pain.
          ${inputsValues[Pain_Pain_Inputs.Pain_Places]?.front?.length || inputsValues[Pain_Pain_Inputs.Pain_Places]?.back?.length || inputsValues[Pain_Pain_Inputs.Pain_Places]?.additional
            ? `${mainValues.firstName} has pain in the following body parts${inputsValues[Pain_Pain_Inputs.Pain_Places].front.length ? ` front: ${inputsValues[Pain_Pain_Inputs.Pain_Places].front.join(', ')}` : ''}
            ${inputsValues[Pain_Pain_Inputs.Pain_Places].back.length ? ` back: ${inputsValues[Pain_Pain_Inputs.Pain_Places].back.join(', ')}` : ''}${inputsValues[Pain_Pain_Inputs.Pain_Places].additional
              ? `${inputsValues[Pain_Pain_Inputs.Pain_Places].front.length || inputsValues[Pain_Pain_Inputs.Pain_Places].back.length
                  ? ', ' : ''}
                ${inputsValues[Pain_Pain_Inputs.Pain_Places].additional}`
              : ''}. `
            : '. '}

            ${inputsValues[Pain_Pain_Inputs.What_Is_The_Cause_Of_The_Pain]
              ? `The pain was caused by ${inputsValues[Pain_Pain_Inputs.What_Is_The_Cause_Of_The_Pain]}. `
              : ''}
            ${inputsValues[Pain_Pain_Inputs.Select_Type_Of_Pain]?.length
              ? ` The pain is ${inputsValues[Pain_Pain_Inputs.Select_Type_Of_Pain]?.join(', ')}. `
              : ''}
            ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Pain_Pain_Inputs.Actions_Taken] && inputsValues[Pain_Pain_Inputs.Actions_Taken]?.length
          ? 'Our team has taken the following actions: '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.GP_Notified)
          ? 'The GP has been informed. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Pain_Relief_Analygesic_Administered)
          ? `${inputsValues[Pain_Pain_Inputs.Pain_Relief_Was_Effective] === Pain_Pain_Inputs.Pain_Relief_Was_Effective_Yes
                ? 'Pain relief was effective. '
                : inputsValues[Pain_Pain_Inputs.Pain_Relief_Was_Effective] === Pain_Pain_Inputs.Pain_Relief_Was_Effective_No
                    ? `Pain relief wasn’t effective. ${inputsValues[Pain_Pain_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain] && `The following actions are being taken to relieve pain: ${inputsValues[Pain_Pain_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain]}. `}`
                    : `${mainValues.firstName} is waiting for effect of pain relief. `}`
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Pain_relief_offered_and_declined)
            ? 'Pain relief offered and declined. '
            : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Pain_Medication_Not_Required)
          ? 'Pain medication is not required. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.RN_Has_Conducted_An_Assessment_Of_Pain)
          ? 'RN has conducted an assessment of pain. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Heat_Pack_Used)
          ? 'A heat pack has been used. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Ice_Pack_Used)
          ? 'An ice pack has been used. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Massage_Has_Been_Given)
          ? 'A message has been given. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Repositioning_As_Required)
          ? 'Repositioning has been done as required. '
          : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Full_pain_assessment_has_been_conducted)
            ? 'Full pain assessment has been conducted. '
            : ''}
        ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Care_Plan_has_been_updated_to_reflect_the_pain_assessment_findings)
            ? 'Care Plan has been updated to reflect the pain assessment findings. '
            : ''}

          ${inputsValues[Pain_Pain_Inputs.Actions_Taken]?.includes(Pain_Pain_Inputs.Transfer_to_hospital)
            ? `
             ${inputsValues[Pain_Pain_Inputs.Hospital_Location_Is_Known] === RadioBoolean.Yes
                ? `${mainValues.firstName} has been transferred to ${inputsValues[Pain_Pain_Inputs.Hospital_Location]}.`
                : `${mainValues.firstName} has been transferred to hospital. Location is unknown at this stage.`
            }
            `
            : `${mainValues.firstName} has not required transfer to hospital. `}

        Our team is regularly monitoring ${mainValues.firstName} and reassessing care as required.
        
        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Pain_Pain_Inputs.How_Is_The_Resident_Feeling]
          ? `How is ${mainValues.firstName}? ${inputsValues[Pain_Pain_Inputs.How_Is_The_Resident_Feeling]}. ${UpdateMessageSymbols.Paragraph_Break}` 
          : ''}
        
        ${inputsValues[Pain_Pain_Inputs.Other_Information]
          ? `Further information: ${inputsValues[Pain_Pain_Inputs.Other_Information]}.`
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Pain_Pain_Inputs.Other_Information]
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      conjugateInputsBoxClasses: {
        0: [`${styles.Pain_Pain_row} ${styles.margin_top}`]
      },
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Pain_Pain_Inputs.What_Is_The_Cause_Of_The_Pain,
              label: 'What is the cause of the pain',
              placeholder: 'Write the cause of the pain',
              validationSchema: Yup.string().required('Write the cause of the pain'),
              required: true,
            },
            {
              type: UpdateInputsTypes.HumanInput,
              name: Pain_Pain_Inputs.Pain_Places,
              className: styles.Pain_Pain_human,
              headerType: 'pain',
              conjugateInputBoxId: 0,
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Pain_Pain_Inputs.Select_Type_Of_Pain,
              label: 'Select type of pain:',
              className: styles.Pain_Pain_Select_Type_Of_Pain,
              conjugateInputBoxId: 0,
              checkboxes: [
                {
                  value: Pain_Pain_Inputs.Stabbing, 
                  label: 'Stabbing', 
                },
                {
                  value: Pain_Pain_Inputs.Sharp, 
                  label: 'Sharp', 
                },
                {
                  value: Pain_Pain_Inputs.Dull, 
                  label: 'Dull', 
                },
                {
                  value: Pain_Pain_Inputs.Neuropathic, 
                  label: 'Neuropathic', 
                },
                {
                  value: Pain_Pain_Inputs.Burning, 
                  label: 'Burning', 
                },
                {
                  value: Pain_Pain_Inputs.Aching, 
                  label: 'Aching', 
                },
              ]
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Pain_Pain_Inputs.Actions_Taken,
              label: 'Actions taken (select all that apply):',
              checkboxes: [
                {
                  value: Pain_Pain_Inputs.GP_Notified, 
                  label: 'GP Notified', 
                },
                {
                  value: Pain_Pain_Inputs.Pain_Relief_Analygesic_Administered, 
                  label: 'Pain relief analgesic administered', 
                },
                {
                  value: Pain_Pain_Inputs.Pain_relief_offered_and_declined,
                  label: 'Pain relief offered and declined',
                },
                {
                  value: Pain_Pain_Inputs.Pain_Medication_Not_Required, 
                  label: 'Pain medication not required', 
                },
                {
                  value: Pain_Pain_Inputs.Heat_Pack_Used, 
                  label: 'Heat Pack Used', 
                },
                {
                  value: Pain_Pain_Inputs.Ice_Pack_Used, 
                  label: 'Ice Pack Used', 
                },
                {
                  value: Pain_Pain_Inputs.Massage_Has_Been_Given, 
                  label: 'Massage has been given ', 
                },
                {
                  value: Pain_Pain_Inputs.Repositioning_As_Required, 
                  label: 'Repositioning as required', 
                },
                {
                  value: Pain_Pain_Inputs.Full_pain_assessment_has_been_conducted,
                  label: 'Full pain assessment has been conducted',
                },
                {
                  value: Pain_Pain_Inputs.Care_Plan_has_been_updated_to_reflect_the_pain_assessment_findings,
                  label: 'Care Plan has been updated to reflect the pain assessment findings',
                },
                {
                  value: Pain_Pain_Inputs.Transfer_to_hospital,
                  label: 'Transferred to Hospital',
                  conditions: [
                    {
                      'priority': UpdatePriorities.High,
                    }
                  ]
                },
              ],
              dependentInputs: {
                [Pain_Pain_Inputs.Pain_Relief_Analygesic_Administered]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    radios: [
                      {value: Pain_Pain_Inputs.Pain_Relief_Was_Effective_Yes, label: 'Yes'},
                      {value: Pain_Pain_Inputs.Pain_Relief_Was_Effective_No, label: 'No'},
                      {value: Pain_Pain_Inputs.Pain_Relief_Was_Effective_Waiting, label: 'Waiting for effect '},
                    ],
                    name: Pain_Pain_Inputs.Pain_Relief_Was_Effective,
                    value: undefined,
                    label: 'Pain relief was effective',
                    className: `${styles.padding_1} ${styles.fullWidth}`,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    dependentInputs: {
                      [Pain_Pain_Inputs.Pain_Relief_Was_Effective_No]: [
                        {
                          type: UpdateInputsTypes.TextInput,
                          multiline: true,
                          className: styles.padding_1,
                          required: true,
                          validationSchema: Yup.string().required('Write iother actions are being taken to relieve pain'),
                          name: Pain_Pain_Inputs.What_Other_Actions_Are_Being_Taken_To_Relieve_Pain,
                          label: 'What other actions are being taken to relieve pain?',
                          placeholder: 'Write other actions are being taken to relieve pain',
                        },
                      ]
                    },
                  },
                ]
              }
            },
            {
              conditions: [
                {[Pain_Pain_Inputs.Actions_Taken]: Pain_Pain_Inputs.Transfer_to_hospital},
              ],
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Pain_Pain_Inputs.Hospital_Location_Is_Known,
              value: undefined,
              label: 'Name of the hospital is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    name: Pain_Pain_Inputs.Hospital_Location,
                    label: 'Name of the hospital',
                    placeholder: 'Write name of the hospital',
                    required: true,
                    validationSchema: Yup.string().required('Hospital name is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Pain_Pain_Inputs.How_Is_The_Resident_Feeling,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              validationSchema: Yup.string().required('Write how is the resident feeling'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Pain_Pain_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        },
      ]
    },
  },
  [Sections.Request_For_Items]: {
    [Request_For_Items_SubSections.Clothing_Footwear]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} needs the following items: 
        ${inputsValues[Request_For_Items_Clothing_Footwear_Inputs.Description_Of_Items_That_Are_Needed]}. 
        The size of items are: ${inputsValues[Request_For_Items_Clothing_Footwear_Inputs.Size_Of_Items]}. 

        ${inputsValues[Request_For_Items_Clothing_Footwear_Inputs.Other_Information]
          ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Request_For_Items_Clothing_Footwear_Inputs.Other_Information]}.`
          : ''} 

        ${mainValues.phoneCall 
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Clothing_Footwear_Inputs.Description_Of_Items_That_Are_Needed,
              label: 'Describe items needed',
              placeholder: 'Write items needed',
              validationSchema: Yup.string().required('Write items needed'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Clothing_Footwear_Inputs.Size_Of_Items,
              label: 'Describe size of item',
              placeholder: 'Write size of item',
              validationSchema: Yup.string().required('Write size of item'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Clothing_Footwear_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Request_For_Items_SubSections.Food_Items]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} needs the following items: 
        ${inputsValues[Request_For_Items_Food_Items_Inputs.Description_Of_Items_That_Are_Needed]}. 

        ${inputsValues[Request_For_Items_Food_Items_Inputs.Other_Information]
          ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Request_For_Items_Food_Items_Inputs.Other_Information]}.`
          : ''} 
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Food_Items_Inputs.Description_Of_Items_That_Are_Needed,
              label: 'Describe items needed',
              placeholder: 'Write items needed',
              validationSchema: Yup.string().required('Write items needed'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Food_Items_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Request_For_Items_SubSections.Personal_Care_Items]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} needs the following items: 
        ${inputsValues[Request_For_Items_Personal_Care_Items_Inputs.Description_Of_Items_That_Are_Needed]}. 

        ${inputsValues[Request_For_Items_Personal_Care_Items_Inputs.Other_Information]
          ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Request_For_Items_Personal_Care_Items_Inputs.Other_Information]}.`
          : ''} 
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Personal_Care_Items_Inputs.Description_Of_Items_That_Are_Needed,
              label: 'Describe items needed',
              placeholder: 'Write items needed',
              validationSchema: Yup.string().required('Write items needed'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Personal_Care_Items_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Request_For_Items_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} needs the following items: 
        ${inputsValues[Request_For_Items_Other_Inputs.Description_Of_Items_That_Are_Needed]}. 

        ${inputsValues[Request_For_Items_Other_Inputs.Other_Information]
          ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Request_For_Items_Other_Inputs.Other_Information]}.`
          : ''} 
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Other_Inputs.Description_Of_Items_That_Are_Needed,
              label: 'Describe items needed',
              placeholder: 'Write items needed',
              validationSchema: Yup.string().required('Write items needed'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Request_For_Items_Other_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Return_From_Hospital]: {
    [Return_From_Hospital_SubSections.Return_From_Hospital]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} has returned from hospital. 
        They were transferred to hospital on ${moment(inputsValues[Return_From_Hospital_Inputs.Date_Transfer_To_Hospital]).format("DD MMM YYYY")} at ${moment(inputsValues[Return_From_Hospital_Inputs.Date_Transfer_To_Hospital]).format("hh:mm A")}
        and returned on ${moment(inputsValues[Return_From_Hospital_Inputs.Date_Returned_From_Hospital]).format("DD MMM YYYY")} at ${moment(inputsValues[Return_From_Hospital_Inputs.Date_Returned_From_Hospital]).format("hh:mm A")}. 
        
        ${UpdateMessageSymbols.Paragraph_Break}

        Reason for hospitalisation: ${inputsValues[Return_From_Hospital_Inputs.Reason_For_Hospitalisation]}. 

        ${UpdateMessageSymbols.Paragraph_Break}

        Summary of the hospital visit: ${inputsValues[Return_From_Hospital_Inputs.Summary_Of_The_Hospital_Visit]}. 

        ${UpdateMessageSymbols.Paragraph_Break}

        Changes in ${mainValues.firstName}'s Health or Care Since Hospital Stay:
        ${inputsValues[Return_From_Hospital_Inputs.There_Been_A_Change_To_Medication] === RadioBoolean.No
          ? 'Medication has not been changed. '
          : `Medication has been changed: ${inputsValues[Return_From_Hospital_Inputs.Medication_Changes]}. `}

        ${inputsValues[Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Diet] === RadioBoolean.No
          ? 'There has been no change to diet. '
          : `${mainValues.firstName}  has a new diet: ${inputsValues[Return_From_Hospital_Inputs.Change_To_Diet]}. `}

        ${inputsValues[Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Mobility] === RadioBoolean.Yes
          ? `Mobility has been changed: ${inputsValues[Return_From_Hospital_Inputs.Describe_The_Change_To_Mobility]}. `
          : ''}

        ${inputsValues[Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Weight] === RadioBoolean.Yes
            ? `${UpdateMessageSymbols.Line_Break}Weight has been changed:${UpdateMessageSymbols.Line_Break}Current weight - ${inputsValues[Return_From_Hospital_Inputs.Write_current_weight]}kg${UpdateMessageSymbols.Line_Break}Previous weight - ${inputsValues[Return_From_Hospital_Inputs.Write_previous_weight]}kg${UpdateMessageSymbols.Line_Break}Weight ${getWeightGainOrLoss(inputsValues[Return_From_Hospital_Inputs.Write_current_weight], inputsValues[Return_From_Hospital_Inputs.Write_previous_weight])} - ${formattedFloat(Math.abs(inputsValues[Return_From_Hospital_Inputs.Write_previous_weight] - inputsValues[Return_From_Hospital_Inputs.Write_current_weight]),3)}kg (Percentage change - ${getWeightPercentageChange(inputsValues[Return_From_Hospital_Inputs.Write_current_weight], inputsValues[Return_From_Hospital_Inputs.Write_previous_weight])}%)${UpdateMessageSymbols.Line_Break}
               `
            : ''}

        ${inputsValues[Return_From_Hospital_Inputs.A_Skin_Integrity_Check_Has_Been_Completed_By_An_RN] === RadioBoolean.Yes
          ? 'A skin integrity check has been completed by an RN. '
          : ''}

        ${inputsValues[Return_From_Hospital_Inputs.Any_Skin_Issues_Found] === RadioBoolean.Yes
          ? `These skin issues were found: ${inputsValues[Return_From_Hospital_Inputs.Describe_The_Issues_Found]}. `
          : ''}

        ${inputsValues[Return_From_Hospital_Inputs.Followup_Appointments_Required] === RadioBoolean.Yes
          ? `Follow-up appointment(s) required: ${inputsValues[Return_From_Hospital_Inputs.Describe_The_Appointments_Required_And_When]}. `
          : ''}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Return_From_Hospital_Inputs.How_Is_The_Resident]
          ? `How is ${mainValues.firstName}? ${inputsValues[Return_From_Hospital_Inputs.How_Is_The_Resident]}. ` 
          : ''}

        ${inputsValues[Return_From_Hospital_Inputs.Other_Information]
          ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Return_From_Hospital_Inputs.Other_Information]}.`
          : ''} 
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? UpdateMessageSymbols.Paragraph_Break
          : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
          ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
          : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Return_From_Hospital_Inputs.Reason_For_Hospitalisation,
              label: 'Reason for hospitalisation',
              placeholder: 'Write reason for hospitalisation',
              multiline: true,
              validationSchema: Yup.string().required('Write reason for hospitalisation'),
              required: true,
            },
            {
              type: UpdateInputsTypes.DateInput,
              name: Return_From_Hospital_Inputs.Date_Transfer_To_Hospital,
              label: 'Date transfer to hospital',
              placeholder: 'Select date transfer to hospital',
              maxDate: new Date(),
              dateType: 'dateTime',
              validationSchema: Yup.date().required('Date transfer to hospital is required'),
            },
            {
              type: UpdateInputsTypes.DateInput,
              name: Return_From_Hospital_Inputs.Date_Returned_From_Hospital,
              label: 'Date returned from hospital',
              placeholder: 'Select date returned from hospital',
              dateType: 'dateTime',
              maxDate: new Date(),
              validationSchema: Yup.date().required('Date returned from hospital is required'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Return_From_Hospital_Inputs.Summary_Of_The_Hospital_Visit,
              label: 'Summary of the hospital visit',
              placeholder: 'Write summary of the hospital visit',
              multiline: true,
              validationSchema: Yup.string().required('Write summary of the hospital visit'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.There_Been_A_Change_To_Medication,
              value: undefined,
              label: 'Has there been a change to medication?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Medication_Changes,
                    required: true,
                    validationSchema: Yup.string().required('Write Medication changes'),
                    label: 'Medication changes',
                    placeholder: 'Write the medication changes',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Diet,
              value: undefined,
              label: 'Has there been a change to diet?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Change_To_Diet,
                    required: true,
                    validationSchema: Yup.string().required('Write the change to diet'),
                    label: 'Diet change',
                    placeholder: 'Write the change to diet',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Mobility,
              value: undefined,
              label: 'Has there been a change to mobility?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Describe_The_Change_To_Mobility,
                    required: true,
                    validationSchema: Yup.string().required('Write the change to mobility'),
                    label: 'Mobility change',
                    placeholder: 'Describe the change to mobility',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.Has_There_Been_A_Change_To_Weight,
              value: undefined,
              label: 'Has there been a change to weight?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.NumberInput,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Write_previous_weight,
                    required: true,
                    validationSchema: Yup.string().required('Write previous weight'),
                    label: 'Previous to weight',
                    placeholder: 'Write previous weight',
                  },
                  {
                    type: UpdateInputsTypes.NumberInput,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Write_current_weight,
                    required: true,
                    validationSchema: Yup.string().required('Write current weight'),
                    label: 'Current weight',
                    placeholder: 'Write current weight',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.A_Skin_Integrity_Check_Has_Been_Completed_By_An_RN,
              value: undefined,
              label: 'A skin integrity check has been completed by an RN',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.Any_Skin_Issues_Found,
              value: undefined,
              label: 'Any skin issues found?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Describe_The_Issues_Found,
                    required: true,
                    validationSchema: Yup.string().required('Write the issues found'),
                    label: 'Issues found',
                    placeholder: 'Describe the issues found',
                  },
                ]
              },
            },

            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Return_From_Hospital_Inputs.Followup_Appointments_Required,
              value: undefined,
              label: 'Follow-up appointment(s) required?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Return_From_Hospital_Inputs.Describe_The_Appointments_Required_And_When,
                    required: true,
                    validationSchema: Yup.string().required('Write the appointment(s) required and when'),
                    label: 'Appointment(s) required and when',
                    placeholder: 'Describe the appointment(s) required and when',
                  },
                ]
              },
            },

            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Return_From_Hospital_Inputs.How_Is_The_Resident,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Return_From_Hospital_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Specialist_Appointment]: {
    [Specialist_Appointment_SubSections.Referral_To_Specialist]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} requires an appointment with a
        ${inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist] !== Referral_To_Specialist_Inputs.Other
          ? inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist]
          : inputsValues[Referral_To_Specialist_Inputs.Type_Of_Specialist]}. 

        Reason for appointment: ${inputsValues[Referral_To_Specialist_Inputs.Reason_For_Appointment]}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Referral_To_Specialist_Inputs.GP_Has_Provided_Referral] === RadioBoolean.Yes && inputsValues[Referral_To_Specialist_Inputs.Referral_Has_Been_Provided_To_Specialist] !== RadioBoolean.Yes
            ? 'The GP has provided a referral letter. '
            : `${ inputsValues[Referral_To_Specialist_Inputs.Referral_Has_Been_Provided_To_Specialist] !== RadioBoolean.Yes ? 'The GP will need to provide a referral letter. ' : ''}`}

          
        ${inputsValues[Referral_To_Specialist_Inputs.Referral_Has_Been_Provided_To_Specialist] === RadioBoolean.Yes  && inputsValues[Referral_To_Specialist_Inputs.GP_Has_Provided_Referral] === RadioBoolean.Yes
          ? `Referral letter has been provided by the GP to the 
              ${inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist] !== Referral_To_Specialist_Inputs.Other
                ? inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist]
                : inputsValues[Referral_To_Specialist_Inputs.Type_Of_Specialist]}. `
          : ''}

          ${UpdateMessageSymbols.Paragraph_Break}

          Details of the appointment:

          ${UpdateMessageSymbols.Paragraph_Break}

          Location: ${inputsValues[Referral_To_Specialist_Inputs.Location_Of_The_Appointment] === Referral_To_Specialist_Inputs.At_Nursing_Home
                      ? nursingStore.activeNursingHome?.name
                      : inputsValues[Referral_To_Specialist_Inputs.Address_Of_Appointment]}. 

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Are_The_Time_And_Date_Of_The_Appointment_Known] === RadioBoolean.Yes
            ?
            `Time and Date: ${moment(inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Time_And_Date_Of_The_Appointment]).format("DD MMM YYYY")} 
          at ${moment(inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Time_And_Date_Of_The_Appointment]).format("hh:mm A")}.`
            :
            `Appointment time and date have not yet been confirmed. We will inform you once the appointment has been booked and confirmed.`}
          
          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Referral_To_Specialist_Inputs.Contact_Details_Of_The_Allied_Health_Professional] ? `Contact Phone Number of ${inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist] !== Referral_To_Specialist_Inputs.Other
            ? inputsValues[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist]
            : inputsValues[Referral_To_Specialist_Inputs.Type_Of_Specialist]}: ${inputsValues[Referral_To_Specialist_Inputs.Contact_Details_Of_The_Allied_Health_Professional]} ${UpdateMessageSymbols.Paragraph_Break}` : ''}


          ${inputsValues[Referral_To_Specialist_Inputs.Location_Of_The_Appointment] !== Referral_To_Specialist_Inputs.At_Nursing_Home && inputsValues[Referral_To_Specialist_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident] === RadioBoolean.Yes
           ? 'A family member will need to take the resident to the appointment. '
           : ''}

          ${inputsValues[Referral_To_Specialist_Inputs.Location_Of_The_Appointment] !== Referral_To_Specialist_Inputs.At_Nursing_Home && inputsValues[Referral_To_Specialist_Inputs.Transport_Is_Required] === RadioBoolean.Yes
            ? `Transport to the appointment is required: ${inputsValues[Referral_To_Specialist_Inputs.Transport_Details]}. `
            : ''}

          ${inputsValues[Referral_To_Specialist_Inputs.Payment_Is_Required] === RadioBoolean.Yes
            ? `The appointment will cost the following amount: ${inputsValues[Referral_To_Specialist_Inputs.Payment_Cost]} `
            : 'No Payment is required. '}

          ${inputsValues[Referral_To_Specialist_Inputs.Items_Need_To_Be_Taken_To_The_Appointment] === RadioBoolean.Yes
           ? `These items will be needed at the appointment: ${inputsValues[Referral_To_Specialist_Inputs.What_Items_Are_Required_To_Be_Taken]}. `
           : ''}

          ${inputsValues[Referral_To_Specialist_Inputs.An_Interpreter_Is_Require] === RadioBoolean.Yes
           ? `An interpreter is required. 
             ${inputsValues[Referral_To_Specialist_Inputs.Interpreter_Has_Been_Booked] === RadioBoolean.Yes
               ? 'An Interpreter has been booked. '
               : ''}`
           : ''}

          ${UpdateMessageSymbols.Paragraph_Break}
    
          ${inputsValues[Referral_To_Specialist_Inputs.Other_Information]
            ? `Further information: ${inputsValues[Referral_To_Specialist_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
        steps: [
          {
            inputs: [
              {
                type: UpdateInputsTypes.Select,
                name: Referral_To_Specialist_Inputs.Select_Type_Of_Specialist,
                label: 'Select type of Specialist',
                placeholder: 'Select',
                items: [
                  {title: 'Geriatrician ', value: Referral_To_Specialist_Inputs.Geriatrician, id: Referral_To_Specialist_Inputs.Geriatrician},
                  {title: 'Nurse Practitioner', value: Referral_To_Specialist_Inputs.Nurse_Practitioner, id: Referral_To_Specialist_Inputs.Nurse_Practitioner},
                  {title: 'Psychogeriatrician', value: Referral_To_Specialist_Inputs.Psychogeriatrician, id: Referral_To_Specialist_Inputs.Psychogeriatrician},
                  {title: 'Wound Consult', value: Referral_To_Specialist_Inputs.Wound_Consult, id: Referral_To_Specialist_Inputs.Wound_Consult},
                  {title: 'Cardiologist', value: Referral_To_Specialist_Inputs.Cardiologist, id: Referral_To_Specialist_Inputs.Cardiologist},
                  {title: 'Neurologist', value: Referral_To_Specialist_Inputs.Neurologist, id: Referral_To_Specialist_Inputs.Neurologist},
                  {title: 'Palliative Consultant', value: Referral_To_Specialist_Inputs.Palliative_Consultant, id: Referral_To_Specialist_Inputs.Palliative_Consultant},
                  {title: 'Other', value: Referral_To_Specialist_Inputs.Other, id: Referral_To_Specialist_Inputs.Other},
                ],
                validationSchema: Yup.string().required('Select type of Specialist'),
                required: true,
              },
              {
                type: UpdateInputsTypes.TextInput,
                name: Referral_To_Specialist_Inputs.Type_Of_Specialist,
                label: 'What the other Specialist?',
                placeholder: 'Write what the other Specialist',
                required: true,
                validationSchema: Yup.string().required('Write the other Specialist'),
                conditions: [
                  {[Referral_To_Specialist_Inputs.Select_Type_Of_Specialist]: Referral_To_Specialist_Inputs.Other}
                ]
              },
              {
                type: UpdateInputsTypes.TextInput,
                name: Referral_To_Specialist_Inputs.Reason_For_Appointment,
                label: 'Reason for appointment',
                multiline: true,
                placeholder: 'Write reason for appointment',
                validationSchema: Yup.string().required('Write reason for appointment'),
                required: true,
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.GP_Has_Provided_Referral,
                value: undefined,
                label: 'GP has provided referral',
                required: false,
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.Referral_Has_Been_Provided_To_Specialist,
                value: undefined,
                label: 'Referral has been provided to Specialist',
                required: false,
                              conditions: [
                {
                  [Referral_To_Specialist_Inputs.GP_Has_Provided_Referral]:  RadioBoolean.Yes
                }
              ],
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: Referral_To_Specialist_Inputs.At_Nursing_Home, label: 'At Aged Care Home '},
                  {value: Referral_To_Specialist_Inputs.External_Appointment, label: 'External appointment'},
                ],
                name: Referral_To_Specialist_Inputs.Location_Of_The_Appointment,
                value: undefined,
                label: 'Location of the appointment (please select one)',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                dependentInputs: {
                  [Referral_To_Specialist_Inputs.External_Appointment]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      className: styles.padding_1,
                      name: Referral_To_Specialist_Inputs.Address_Of_Appointment,
                      required: true,
                      validationSchema: Yup.string().required('Write the address of appointment'),
                      label: 'Address of appointment',
                      placeholder: 'Write address of appointment',
                    },
                  ]
                },
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.Are_The_Time_And_Date_Of_The_Appointment_Known,
                value: undefined,
                label: 'Has the appointment been booked?',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.DateInput,
                      name: Referral_To_Specialist_Inputs.Time_And_Date_Of_The_Appointment,
                      dateType: 'dateTime',
                      label: 'Time and Date of the appointment',
                      placeholder: 'Select Time and Date of the appointment',
                      minDate: new Date(),
                      validationSchema: Yup.date().required('Time and Date of the appointment is required'),
                    }
                  ]
                }
              },
              /*{
                type: UpdateInputsTypes.DateInput,
                name: Referral_To_Specialist_Inputs.Time_And_Date_Of_The_Appointment,
                dateType: 'dateTime',
                label: 'Time and Date of the appointment',
                placeholder: 'Select Time and Date of the appointment',
                validationSchema: Yup.date().required('Time and Date of the appointment is required'),
              },*/
              {
                type: UpdateInputsTypes.TextInput,
                name: Referral_To_Specialist_Inputs.Contact_Details_Of_The_Allied_Health_Professional,
                label: 'Contact details of the Specialist',
                multiline: true,
                placeholder: 'Write contact details of the Specialist',
                required: false,
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident,
                value: undefined,
                label: 'A family member will need to take the resident',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                conditions: [
                  {
                    [Referral_To_Specialist_Inputs.Location_Of_The_Appointment]: Referral_To_Specialist_Inputs.External_Appointment
                  }
                ]
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.Transport_Is_Required,
                value: undefined,
                label: 'Transport is required',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                conditions: [
                  {
                    [Referral_To_Specialist_Inputs.Location_Of_The_Appointment]: Referral_To_Specialist_Inputs.External_Appointment
                  }
                ],
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      className: styles.padding_1,
                      name: Referral_To_Specialist_Inputs.Transport_Details,
                      required: true,
                      validationSchema: Yup.string().required('Description is required'),
                      label: 'Describe whether a family member needs to take the resident or if a transport service has been booked',
                      placeholder: 'Write the description',
                    },
                  ]
                },
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.Payment_Is_Required,
                value: undefined,
                label: 'Payment is required',
                required: true,
                validationSchema: Yup.string().required('Please select one'),
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      className: styles.padding_1,
                      name: Referral_To_Allied_Health_Professiona_Inputs.Payment_Cost,
                      required: true,
                      validationSchema: Yup.string().required('Cost of the appointment is required'),
                      label: 'Write the cost of the appointment',
                      placeholder: 'Write the cost of the appointment',
                    },
                  ]
                },
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.Items_Need_To_Be_Taken_To_The_Appointment,
                value: undefined,
                label: 'Items need to be taken to the appointment?',
                required: false,
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.TextInput,
                      multiline: true,
                      className: styles.padding_1,
                      name: Referral_To_Specialist_Inputs.What_Items_Are_Required_To_Be_Taken,
                      required: true,
                      validationSchema: Yup.string().required('Write  items are required to be taken, referral, other'),
                      label: 'What items are required to be taken, referral, other',
                      placeholder: 'Describe what items are required to be taken',
                    },
                  ]
                },
              },
              {
                type: UpdateInputsTypes.RadioInput,
                radios: [
                  {value: RadioBoolean.Yes, label: 'Yes'},
                  {value: RadioBoolean.No, label: 'No'},
                ],
                name: Referral_To_Specialist_Inputs.An_Interpreter_Is_Require,
                value: undefined,
                label: 'An interpreter is required?',
                required: false,
                dependentInputs: {
                  [RadioBoolean.Yes]: [
                    {
                      type: UpdateInputsTypes.RadioInput,
                      className: styles.padding_1,
                      name: Referral_To_Specialist_Inputs.Interpreter_Has_Been_Booked,
                      value: undefined,
                      required: true,
                      validationSchema: Yup.string().required('Select one'),
                      label: 'Interpreter has been booked',
                      radios: [
                        {value: RadioBoolean.Yes, label: 'Yes'},
                        {value: RadioBoolean.No, label: 'No'},
                      ],
                    },
                  ]
                },
              },
              /*{
                type: UpdateInputsTypes.TextInput,
                multiline: true,
                value: undefined,
                name: Referral_To_Specialist_Inputs.How_Is_The_Resident,
                label: 'How is the resident?',
                subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
                placeholder: 'Write how is the resident feeling',
                required: true,
                validationSchema: Yup.string().required('Write how is the resident feeling'),
              },*/
              {
                type: UpdateInputsTypes.TextInput,
                multiline: true,
                name: Referral_To_Specialist_Inputs.Other_Information,
                label: 'Further information',
                placeholder: 'Please write any further information that will be helpful for the family to know ',
              },
            ]
          }
        ]
    },
    [Specialist_Appointment_SubSections.Referral_To_Allied_Health_Professiona]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `${mainValues.firstName} requires an appointment with a
        ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional] !== Referral_To_Allied_Health_Professiona_Inputs.Other
          ? inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional]
          : inputsValues[Referral_To_Allied_Health_Professiona_Inputs.What_The_Other_Allied_Health_Professional_Is]}. 

        Reason for appointment: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Reason_For_Appointment]}

        ${UpdateMessageSymbols.Paragraph_Break}

        ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Referral_Has_Been_Provided_To_Allied_Health_Professional] === RadioBoolean.Yes && inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Referral_Has_Been_Provided_To_Allied_Health_Professional] === RadioBoolean.Yes
          ? `Referral letter has been provided by the GP to the 
              ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional] !== Referral_To_Allied_Health_Professiona_Inputs.Other
                ? inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional]
                : inputsValues[Referral_To_Allied_Health_Professiona_Inputs.What_The_Other_Allied_Health_Professional_Is]}. `
          : ''}

                  ${
          inputsValues[Referral_To_Allied_Health_Professiona_Inputs.GP_Has_Provided_Referral] ? `
          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.GP_Has_Provided_Referral] === RadioBoolean.Yes && inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Referral_Has_Been_Provided_To_Allied_Health_Professional] !== RadioBoolean.Yes
            ? 'The GP has provided a referral letter. '
            : `${ inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Referral_Has_Been_Provided_To_Allied_Health_Professional] !== RadioBoolean.Yes && inputsValues[Referral_To_Allied_Health_Professiona_Inputs.GP_Has_Provided_Referral] !== Referral_To_Allied_Health_Professiona_Inputs.No_Referral_Required ? 'The GP will need to provide a referral letter. ' : ''}`}

          ` : ''
        }

          ${UpdateMessageSymbols.Paragraph_Break}

          Details of the appointment:

          ${UpdateMessageSymbols.Paragraph_Break}

          Location: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Location_Of_The_Appointment] === Referral_To_Allied_Health_Professiona_Inputs.At_Nursing_Home
                      ? nursingStore.activeNursingHome?.name
                      : inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Address_Of_Appointment]}. 

          ${UpdateMessageSymbols.Paragraph_Break}
          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Are_The_Time_And_Date_Of_The_Appointment_Known] === RadioBoolean.Yes 
            ? 
            `Time and Date: ${moment(inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Time_And_Date_Of_The_Appointment]).format("DD MMM YYYY")} 
          at ${moment(inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Time_And_Date_Of_The_Appointment]).format("hh:mm A")}.`
            :
            `Appointment time and date have not yet been confirmed. We will inform you once the appointment has been booked and confirmed.`}

          ${UpdateMessageSymbols.Paragraph_Break}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Contact_Details_Of_The_Allied_Health_Professional] ? `Contact phone number of ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional] !== Referral_To_Allied_Health_Professiona_Inputs.Other
            ? inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional]
            : inputsValues[Referral_To_Allied_Health_Professiona_Inputs.What_The_Other_Allied_Health_Professional_Is]}: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Contact_Details_Of_The_Allied_Health_Professional]} ${UpdateMessageSymbols.Paragraph_Break}` : ''}
        
          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Location_Of_The_Appointment] !== Referral_To_Allied_Health_Professiona_Inputs.At_Nursing_Home && inputsValues[Referral_To_Allied_Health_Professiona_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident] === RadioBoolean.Yes
           ? 'A family member will need to take the resident to the appointment. '
           : ''}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Location_Of_The_Appointment] !== Referral_To_Allied_Health_Professiona_Inputs.At_Nursing_Home && inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Transport_Is_Required] === RadioBoolean.Yes
           ? `Transport to the appointment is required: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Transport_Details]}. `
           : ''}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Payment_Is_Required] === RadioBoolean.Yes
           ? `The appointment will cost the following amount: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Payment_Cost]} `
           : 'No Payment is required. '}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Items_Need_To_Be_Taken_To_The_Appointment] === RadioBoolean.Yes
           ? `These items will be needed at the appointment: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.What_Items_Are_Required_To_Be_Taken]}. `
           : ''}

          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.An_Interpreter_Is_Require] === RadioBoolean.Yes
           ? `An interpreter is required. 
             ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Interpreter_Has_Been_Booked] === RadioBoolean.Yes
               ? 'An Interpreter has been booked. '
               : ''}`
           : ''}

          ${UpdateMessageSymbols.Paragraph_Break}
    
          ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Other_Information]
            ? `Further information: ${inputsValues[Referral_To_Allied_Health_Professiona_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.Select,
              name: Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional,
              label: 'Select type of Allied Health Professional',
              placeholder: 'Select',
              items: [
                {title: 'Dietician', value: Referral_To_Allied_Health_Professiona_Inputs.Dietician, id: Referral_To_Allied_Health_Professiona_Inputs.Dietician},
                {title: 'Speech Pathology', value: Referral_To_Allied_Health_Professiona_Inputs.Speech_Pathology, id: Referral_To_Allied_Health_Professiona_Inputs.Speech_Pathology},
                {title: 'Physiotherapist', value: Referral_To_Allied_Health_Professiona_Inputs.Physiotherapist, id: Referral_To_Allied_Health_Professiona_Inputs.Physiotherapist},
                {title: 'Podiatrist ', value: Referral_To_Allied_Health_Professiona_Inputs.Podiatrist, id: Referral_To_Allied_Health_Professiona_Inputs.Podiatrist},
                {title: 'Palliative care nurse', value: Referral_To_Allied_Health_Professiona_Inputs.Palliative_Care_Nurse, id: Referral_To_Allied_Health_Professiona_Inputs.Palliative_Care_Nurse},
                {title: 'Optometrist ', value: Referral_To_Allied_Health_Professiona_Inputs.Optometrist, id: Referral_To_Allied_Health_Professiona_Inputs.Optometrist},
                {title: 'Dementia Support Australia', value: Referral_To_Allied_Health_Professiona_Inputs.Dementia_Support_Australia, id: Referral_To_Allied_Health_Professiona_Inputs.Dementia_Support_Australia},
                {title: 'Other', value: Referral_To_Allied_Health_Professiona_Inputs.Other, id: Referral_To_Allied_Health_Professiona_Inputs.Other},
              ],
              validationSchema: Yup.string().required('Select type of Allied Health Professional'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Referral_To_Allied_Health_Professiona_Inputs.What_The_Other_Allied_Health_Professional_Is,
              label: 'What the other Allied Health Professional?',
              placeholder: 'Write what the other Allied Health Professional',
              conditions: [
                {[Referral_To_Allied_Health_Professiona_Inputs.Select_Type_Of_Allied_Health_Professional]: Referral_To_Allied_Health_Professiona_Inputs.Other}
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Referral_To_Allied_Health_Professiona_Inputs.Reason_For_Appointment,
              label: 'Reason for appointment',
              multiline: true,
              placeholder: 'Write reason for appointment',
              validationSchema: Yup.string().required('Write reason for appointment'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
                {value: Referral_To_Allied_Health_Professiona_Inputs.No_Referral_Required, label: 'No referral required'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.GP_Has_Provided_Referral,
              value: undefined,
              label: 'GP has provided referral',
              required: false,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              conditions: [
                {
                  [Referral_To_Allied_Health_Professiona_Inputs.GP_Has_Provided_Referral]:  RadioBoolean.Yes
                }
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Referral_Has_Been_Provided_To_Allied_Health_Professional,
              value: undefined,
              label: 'Referral has been provided to Allied Health Professional',
              required: false,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: Referral_To_Allied_Health_Professiona_Inputs.At_Nursing_Home, label: 'At Aged Care Home '},
                {value: Referral_To_Allied_Health_Professiona_Inputs.External_Appointment, label: 'External appointment'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Location_Of_The_Appointment,
              value: undefined,
              label: 'Location of the appointment (please select one)',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [Referral_To_Allied_Health_Professiona_Inputs.External_Appointment]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Referral_To_Allied_Health_Professiona_Inputs.Address_Of_Appointment,
                    required: true,
                    validationSchema: Yup.string().required('Write address of appointment'),
                    label: 'Address of appointment',
                    placeholder: 'Write address of appointment',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Are_The_Time_And_Date_Of_The_Appointment_Known,
              value: undefined,
              label: 'Has the appointment been booked?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.DateInput,
                    name: Referral_To_Allied_Health_Professiona_Inputs.Time_And_Date_Of_The_Appointment,
                    dateType: 'dateTime',
                    label: 'Time and Date of the appointment',
                    placeholder: 'Select Time and Date of the appointment',
                    minDate: new Date(),
                    validationSchema: Yup.date().required('Time and Date of the appointment is required'),
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Referral_To_Allied_Health_Professiona_Inputs.Contact_Details_Of_The_Allied_Health_Professional,
              label: 'Contact details of the Allied Health Professional',
              multiline: true,
              placeholder: 'Write contact details of the Allied Health Professional',
              required: false,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident,
              value: undefined,
              label: 'A family member will need to take the resident',
              required: true,
              conditions: [
                  {
                    [Referral_To_Specialist_Inputs.Location_Of_The_Appointment]: Referral_To_Specialist_Inputs.External_Appointment
                  }
              ],
              validationSchema: Yup.string().required('Please select one'),
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Transport_Is_Required,
              value: undefined,
              label: 'Transport is required',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                  {
                    [Referral_To_Specialist_Inputs.Location_Of_The_Appointment]: Referral_To_Specialist_Inputs.External_Appointment
                  }
              ],
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Referral_To_Allied_Health_Professiona_Inputs.Transport_Details,
                    required: true,
                    validationSchema: Yup.string().required('Description is required'),
                    label: 'Describe whether a family member needs to take the resident or if a transport service has been booked',
                    placeholder: 'Write the description',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Payment_Is_Required,
              value: undefined,
              label: 'Payment is required',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Referral_To_Allied_Health_Professiona_Inputs.Payment_Cost,
                    required: true,
                    validationSchema: Yup.string().required('Cost of the appointment is required'),
                    label: 'Write the cost of the appointment',
                    placeholder: 'Write the cost of the appointment',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.Items_Need_To_Be_Taken_To_The_Appointment,
              value: undefined,
              label: 'Items need to be taken to the appointment?',
              required: false,
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Referral_To_Allied_Health_Professiona_Inputs.What_Items_Are_Required_To_Be_Taken,
                    required: true,
                    validationSchema: Yup.string().required('Write items are required to be taken, referral, other'),
                    label: 'What items are required to be taken, referral, other',
                    placeholder: 'Describe what items are required to be taken',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Allied_Health_Professiona_Inputs.An_Interpreter_Is_Require,
              value: undefined,
              label: 'An interpreter is required?',
              required: false,
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    className: styles.padding_1,
                    name: Referral_To_Allied_Health_Professiona_Inputs.Interpreter_Has_Been_Booked,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    value: undefined,
                    label: 'Interpreter has been booked',
                    radios: [
                      {value: RadioBoolean.Yes, label: 'Yes'},
                      {value: RadioBoolean.No, label: 'No'},
                    ],
                  },
                ]
              },
            },
            /*{
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Referral_To_Allied_Health_Professiona_Inputs.How_Is_The_Resident,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            },*/
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Referral_To_Allied_Health_Professiona_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
    [Specialist_Appointment_SubSections.General_Appointment]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `
        The following appointment is required for ${mainValues.firstName}: ${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Title]
              ? `${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Title]}. ${UpdateMessageSymbols.Paragraph_Break}`
              : ''}
        ${ inputsValues[Referral_To_Specialist_General_Inputs.Is_Appointment_Date_Known] === RadioBoolean.Yes ?
              `Time and Date: ${moment(inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Date]).format("DD MMM YYYY")} 
          at ${moment(inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Date]).format("hh:mm A")}.`
                  :
                  `The date of the appointment is not yet known.`
        }
        ${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Location] && inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Location] !== ''
              ? `${UpdateMessageSymbols.Line_Break}Location: ${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Location]}.`
              : ''}
        ${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Details]
              ? `${UpdateMessageSymbols.Line_Break}Here are the details of the appointment: ${inputsValues[Referral_To_Specialist_General_Inputs.Appointment_Details]}.`
              : ''}
        ${UpdateMessageSymbols.Paragraph_Break}
        
        ${inputsValues[Referral_To_Specialist_General_Inputs.Other_Information]
              ? `Further information: ${inputsValues[Referral_To_Specialist_General_Inputs.Other_Information]}.`
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED && inputsValues[Referral_To_Specialist_General_Inputs.Other_Information]
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
        ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
          ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }

          ${inputsValues[Referral_To_Specialist_General_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 0 ? 
            `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.employeeName} has obtained consent from ${mainValues.firstName} to send ${inputsValues[Referral_To_Specialist_General_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 'these' : 'this'} photo${inputsValues[Referral_To_Specialist_General_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 's' : ''} in this update.`
            :
            ``
          }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.TextInput,
              name: Referral_To_Specialist_General_Inputs.Appointment_Title,
              label: 'Title of the appointment',
              placeholder: 'Write the title of the appointment',
              validationSchema: Yup.string().required('Write the title of the appointment'),
              required: true,
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Referral_To_Specialist_General_Inputs.Is_Appointment_Date_Known,
              value: undefined,
              label: 'Date of the appointment is known',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.DateInput,
                    name: Referral_To_Specialist_General_Inputs.Appointment_Date,
                    dateType: 'dateTime',
                    label: 'Time and Date of the appointment',
                    placeholder: 'Select Time and Date of the appointment',
                    minDate: new Date(),
                    validationSchema: Yup.date().required('Time and Date of the appointment is required'),
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Referral_To_Specialist_General_Inputs.Appointment_Location,
              label: 'Appointment location',
              placeholder: 'Write the location of the appointment',
              required: false,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Referral_To_Specialist_General_Inputs.Appointment_Details,
              label: 'Appointment details',
              placeholder: 'Write the details of the appointment',
              required: false,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Referral_To_Specialist_General_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
            {
              type: UpdateInputsTypes.File,
              value: undefined,
              name: Referral_To_Specialist_General_Inputs.Files,
              label: 'files',
            },
          ]
        },
      ]
    },
  },

  [Sections.Nutritional]: {
    [Nutritional_SubSections.Nutritional]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `
          ${mainValues.firstName} has nutrition and diet changes that consist of: ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.join(', ')}. 

          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Change_To_Assistance_Required)  || inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Fluid_Restrictions) ? UpdateMessageSymbols.Line_Break : ``}

          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Change_To_Assistance_Required) ? 
            `New assistance needs required for the resident: ${inputsValues[Nutritional_Nutritional_Inputs.Change_To_Assistance_Required_Input]}` : ``
          }
          
          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Change_To_Assistance_Required) && inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Fluid_Restrictions) ? UpdateMessageSymbols.Line_Break : ``}
          
          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Fluid_Restrictions) ?
            `New fluid restrictions details for the resident: ${inputsValues[Nutritional_Nutritional_Inputs.Change_To_Fluid_Restrictions_Input]}` : ``
          }
          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Diet_Change)
            ? `${UpdateMessageSymbols.Paragraph_Break} ${inputsValues[Nutritional_Nutritional_Inputs.Select_New_Diet]?.includes(Nutritional_Nutritional_Inputs.Other_Diet)
                ? `${mainValues.firstName} has a new diet: ${inputsValues[Nutritional_Nutritional_Inputs.Other_Diet_Text]}. `
                : `${mainValues.firstName} has a new diet: ${inputsValues[Nutritional_Nutritional_Inputs.Select_New_Diet]}. `}`
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Appetite_Change)
            ? `${UpdateMessageSymbols.Paragraph_Break}Appetite change: ${inputsValues[Nutritional_Nutritional_Inputs.Describe_The_Appetite_Change]}. `
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Reasons_For_Change_In_Appetite]?.length
            ? `${UpdateMessageSymbols.Paragraph_Break} The reasons for the change in appetite are: ${UpdateMessageSymbols.Line_Break}
            ${inputsValues[Nutritional_Nutritional_Inputs.Reasons_For_Change_In_Appetite]?.map(
                (reason) => {
                  if (reason === 'General change to appetite') {
                    return `There has been a ${reason.toLowerCase()}. The details of the change: ${inputsValues[Nutritional_Change_In_Appetite_Values[reason]]}`
                  }
                  if (reason === 'Swallowing difficulties') {
                    return `They have been experiencing swallowing difficulties. These have been observed as: ${inputsValues[Nutritional_Change_In_Appetite_Values[reason]]}`
                  }
                  return `There has been a ${reason.toLowerCase()}. Here are the details of the change: ${inputsValues[Nutritional_Change_In_Appetite_Values[reason]]}`
                }
            ).join(`. ${UpdateMessageSymbols.Line_Break}`)}.`
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Reasons_For_Change_To_Diet]?.length
            ? `${UpdateMessageSymbols.Paragraph_Break} The reasons for the change in diet are: ${UpdateMessageSymbols.Line_Break}
            ${inputsValues[Nutritional_Nutritional_Inputs.Reasons_For_Change_To_Diet]?.map(
                (reason) => {
                  if (reason === 'General change to appetite') {
                    return `There has been a ${reason.toLowerCase()}. The details of the change: ${inputsValues[Nutritional_Change_In_Diet_Values[reason]]}`
                  }
                  if (reason === 'Swallowing difficulties') {
                    return `They have been experiencing swallowing difficulties. These have been observed as: ${inputsValues[Nutritional_Change_In_Diet_Values[reason]]}`
                  }
                  return `There has been a ${reason.toLowerCase()}. Here are the details of the change: ${inputsValues[Nutritional_Change_In_Diet_Values[reason]]}`
                }
            ).join(`. ${UpdateMessageSymbols.Line_Break}`)}.`
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Has_There_Been_A_Weight_Change] === RadioBoolean.Yes
            ? `${UpdateMessageSymbols.Paragraph_Break} Change to weight: ${inputsValues[Nutritional_Nutritional_Inputs.The_Change_In_Weight]}. `
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Update_To_Nutrition]?.includes(Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician)
            ? `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.firstName} has been referred to ${inputsValues[Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To] === 'Other specialist' 
                ?
                inputsValues[Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To_Other] :
                inputsValues[Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To]}.
              ${UpdateMessageSymbols.Paragraph_Break}

              Details of the appointment:

              ${UpdateMessageSymbols.Paragraph_Break}

              Location: ${inputsValues[Nutritional_Nutritional_Inputs.Location_Of_The_Appointment] === Nutritional_Nutritional_Inputs.At_Nursing_Home
                ? nursingStore.activeNursingHome?.name
                : inputsValues[Nutritional_Nutritional_Inputs.Address_Of_Appointment]}. 

              ${UpdateMessageSymbols.Paragraph_Break}

              When: ${moment(inputsValues[Nutritional_Nutritional_Inputs.Time_And_Date_Of_The_Appointment]).format("DD MMM YYYY")} 
              at ${moment(inputsValues[Nutritional_Nutritional_Inputs.Time_And_Date_Of_The_Appointment]).format("hh:mm A")}. 

              ${UpdateMessageSymbols.Paragraph_Break}

              Contact phone number: ${inputsValues[Nutritional_Nutritional_Inputs.Contact_Details_Of_The_Allied_Health_Professional]}

              ${UpdateMessageSymbols.Paragraph_Break}

              ${inputsValues[Nutritional_Nutritional_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident] === RadioBoolean.Yes
                ? 'A family member will need to take the resident to the appointment. '
                : ''}

              ${inputsValues[Nutritional_Nutritional_Inputs.Transport_Is_Required] === RadioBoolean.Yes
                ? 'Transport is required. '
                : ''}

              ${inputsValues[Nutritional_Nutritional_Inputs.Payment_Is_Required] === RadioBoolean.Yes
                ? 'Payment is required. '
                : 'No Payment is required. '}

              ${inputsValues[Nutritional_Nutritional_Inputs.Items_Need_To_Be_Taken_To_The_Appointment] === RadioBoolean.Yes
                ? `These items will be needed at the appointment: ${inputsValues[Nutritional_Nutritional_Inputs.What_Items_Are_Required_To_Be_Taken]}. `
                : ''}

              ${inputsValues[Nutritional_Nutritional_Inputs.An_Interpreter_Is_Require] === RadioBoolean.Yes
                ? `An interpreter is required. 
                  ${inputsValues[Nutritional_Nutritional_Inputs.Interpreter_Has_Been_Booked] === RadioBoolean.Yes
                    ? 'An Interpreter has been booked. '
                    : ''}`
                : ''}
              `
            : ''}
          ${inputsValues[Nutritional_Nutritional_Inputs.Has_The_Resident_Commenced_A_New_Diet] === Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician
            ? `${UpdateMessageSymbols.Paragraph_Break} How is ${mainValues.firstName}? ${inputsValues[Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To]}. 
              ` 
            : ''}
      
          ${inputsValues[Nutritional_Nutritional_Inputs.Other_Information]
            ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Nutritional_Nutritional_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
            ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
            : ''
        }
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Nutritional_Nutritional_Inputs.Update_To_Nutrition,
              label: 'Update to nutrition',
              checkboxes: [
                {label: 'Diet change', value: Nutritional_Nutritional_Inputs.Diet_Change},
                {label: 'Appetite change', value: Nutritional_Nutritional_Inputs.Appetite_Change},
                {label: 'Referral to - Speech Pathologist / Dietician', value: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician},
                {label: 'Change to assistance required', value: Nutritional_Nutritional_Inputs.Change_To_Assistance_Required},
                {label: 'Fluid restrictions', value: Nutritional_Nutritional_Inputs.Fluid_Restrictions},
              ],
              dependentInputs: {
                [Nutritional_Nutritional_Inputs.Diet_Change]: [
                  {
                    type: UpdateInputsTypes.Select,
                    name: Nutritional_Nutritional_Inputs.Select_New_Diet,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    label: 'Select new diet',
                    className: styles.padding_1,
                    items: [
                      {title: 'Minced diet', id: Nutritional_Nutritional_Inputs.Minced_Diet, value: Nutritional_Nutritional_Inputs.Minced_Diet},
                      {title: 'Thickened fluids', id: Nutritional_Nutritional_Inputs.Thickened_Fluids, value: Nutritional_Nutritional_Inputs.Thickened_Fluids},
                      {title: 'Puree Diet', id: Nutritional_Nutritional_Inputs.Puree_Diet, value: Nutritional_Nutritional_Inputs.Puree_Diet},
                      {title: 'Soft Diet', id: Nutritional_Nutritional_Inputs.Soft_Diet, value: Nutritional_Nutritional_Inputs.Soft_Diet},
                      {title: 'Cut-up (food needs to be cut smaller)', id: Nutritional_Nutritional_Inputs.Cutup, value: Nutritional_Nutritional_Inputs.Cutup},
                      {title: 'Other', id: Nutritional_Nutritional_Inputs.Other_Diet, value: Nutritional_Nutritional_Inputs.Other_Diet},
                    ],
                  }
                ],
                [Nutritional_Nutritional_Inputs.Appetite_Change]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Describe_The_Appetite_Change,
                    required: true,
                    validationSchema: Yup.string().required('Write the appetite change'),
                    label: 'Appetite change',
                    placeholder: 'Describe the appetite change',
                  }
                ]
              }
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Nutritional_Nutritional_Inputs.Change_To_Fluid_Restrictions_Input,
              value: undefined,
              multiline: true,
              placeholder: 'Write new fluid restrictions details',
              label: 'Write new fluid restrictions details for the resident',
              required: true,
              validationSchema: Yup.string().required('Write new fluid restrictions details'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Fluid_Restrictions},
              ],
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Nutritional_Nutritional_Inputs.Change_To_Assistance_Required_Input,
              value: undefined,
              multiline: true,
              placeholder: 'Write new assistance needs required',
              label: 'Write new assistance needs required for the resident',
              required: true,
              validationSchema: Yup.string().required('Write new assistance needs required'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Change_To_Assistance_Required},
              ],
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              className: styles.padding_1,
              name: Nutritional_Nutritional_Inputs.Other_Diet_Text,
              validationSchema: Yup.string().required('Write the details of the type of diet the resident'),
              label: 'Details of new diet for the resident',
              placeholder: 'Write the details of the type of diet the resident now requires',
              conditions: [
                {[Nutritional_Nutritional_Inputs.Select_New_Diet]: Nutritional_Nutritional_Inputs.Other_Diet}
              ]
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Nutritional_Nutritional_Inputs.Reasons_For_Change_In_Appetite,
              label: 'Reasons for change in appetite',
              checkboxes: [
                {label: 'Change to cognition', value: Nutritional_Nutritional_Inputs.Appetite_Cognition_Change},
                {label: 'Change to mood', value: Nutritional_Nutritional_Inputs.Appetite_Mood_Change},
                {label: 'Disease progression', value: Nutritional_Nutritional_Inputs.Appetite_Disease_Progression},
                {label: 'Swallowing difficulties', value: Nutritional_Nutritional_Inputs.Appetite_Swallowing_Difficulties},
                {label: 'General change to appetite', value: Nutritional_Nutritional_Inputs.Appetite_Other_Reason},
              ],
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Appetite_Change},
              ],
              dependentInputs: {
                [Nutritional_Nutritional_Inputs.Appetite_Other_Reason]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Appetite_Other_Reason,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of the general change to appetite'),
                    label: 'Details of the general change to appetite',
                    placeholder: 'Write the details of the reason for change in appetite',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Appetite_Cognition_Change]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Appetite_Cognition_Change,
                    required: true,
                    validationSchema: Yup.string().required('Describe the cognition change'),
                    label: 'Describe the cognition change',
                    placeholder: 'Write the details of the cognition change',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Appetite_Mood_Change]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Appetite_Mood_Change,
                    required: true,
                    validationSchema: Yup.string().required('Describe the mood change'),
                    label: 'Describe the mood change',
                    placeholder: 'Write the details of the mood change',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Appetite_Disease_Progression]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Appetite_Disease_Progression,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of disease progression'),
                    label: 'Describe the disease progression',
                    placeholder: 'Write the details of the disease progression',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Appetite_Swallowing_Difficulties]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Appetite_Swallowing_Difficulties,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of swallowing difficulties'),
                    label: 'Describe the swallowing difficulties',
                    placeholder: 'Write the details of the swallowing difficulties',
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.CheckboxInput,
              name: Nutritional_Nutritional_Inputs.Reasons_For_Change_To_Diet,
              label: 'Reasons for change to diet',
              checkboxes: [
                {label: 'Change to cognition', value: Nutritional_Nutritional_Inputs.Diet_Cognition_Change},
                {label: 'Change to mood', value: Nutritional_Nutritional_Inputs.Diet_Mood_Change},
                {label: 'Disease progression', value: Nutritional_Nutritional_Inputs.Diet_Disease_Progression},
                {label: 'Swallowing difficulties', value: Nutritional_Nutritional_Inputs.Diet_Swallowing_Difficulties},
                {label: 'General change to appetite', value: Nutritional_Nutritional_Inputs.Diet_Other_Reason},
              ],
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Diet_Change},
              ],
              dependentInputs: {
                [Nutritional_Nutritional_Inputs.Diet_Other_Reason]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Diet_Other_Reason,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of the general change to diet'),
                    label: 'Details of the general change to diet',
                    placeholder: 'Write the details of the general change to diet',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Diet_Cognition_Change]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Diet_Cognition_Change,
                    required: true,
                    validationSchema: Yup.string().required('Describe the cognition change'),
                    label: 'Describe the cognition change',
                    placeholder: 'Write the details of the cognition change',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Diet_Mood_Change]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Diet_Mood_Change,
                    required: true,
                    validationSchema: Yup.string().required('Describe the mood change'),
                    label: 'Describe the mood change',
                    placeholder: 'Write the details of the mood change',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Diet_Disease_Progression]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Diet_Disease_Progression,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of disease progression'),
                    label: 'Describe the disease progression',
                    placeholder: 'Write the details of the disease progression',
                  },
                ],
                [Nutritional_Nutritional_Inputs.Diet_Swallowing_Difficulties]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Write_Diet_Swallowing_Difficulties,
                    required: true,
                    validationSchema: Yup.string().required('Write the details of swallowing difficulties'),
                    label: 'Describe the swallowing difficulties',
                    placeholder: 'Write the details of the swallowing difficulties',
                  },
                ]
              }
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.Has_There_Been_A_Weight_Change,
              value: undefined,
              label: 'Has there been a weight change?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.The_Change_In_Weight,
                    required: true,
                    validationSchema: Yup.string().required('Write what is the change in weight'),
                    label: 'What is the change in weight',
                    placeholder: 'Describe what is the change in weight',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: Nutritional_Nutritional_Inputs.Speech_Pathologist, label: 'Speech Pathologist'},
                {value: Nutritional_Nutritional_Inputs.Dietician, label: 'Dietician'},
                {value: Nutritional_Nutritional_Inputs.Other, label: 'Other'},
              ],
              name: Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To,
              value: undefined,
              label: 'Resident has been referred to',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician},
              ],
              dependentInputs: {
                [Nutritional_Nutritional_Inputs.Other]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Resident_Has_Been_Referred_To_Other,
                    required: true,
                    validationSchema: Yup.string().required('Write to whom the resident is referred'),
                    label: 'To whom the resident is referred',
                    placeholder: 'Write to whom the resident is referred',
                  }
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: Nutritional_Nutritional_Inputs.At_Nursing_Home, label: 'At Aged Care Home '},
                {value: Nutritional_Nutritional_Inputs.External_Appointment, label: 'External appointment'},
              ],
              name: Nutritional_Nutritional_Inputs.Location_Of_The_Appointment,
              value: undefined,
              label: 'Location of the appointment (please select one)',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [Nutritional_Nutritional_Inputs.External_Appointment]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Address_Of_Appointment,
                    required: true,
                    validationSchema: Yup.string().required('Write address of appointment'),
                    label: 'Address of appointment',
                    placeholder: 'Write address of appointment',
                  },
                ]
              },
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.DateInput,
              name: Nutritional_Nutritional_Inputs.Time_And_Date_Of_The_Appointment,
              dateType: 'dateTime',
              label: 'Time and Date of the appointment',
              placeholder: 'Select Time and Date of the appointment',
              minDate: new Date(),
              validationSchema: Yup.date().required('Time and Date of the appointment is required'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.TextInput,
              name: Nutritional_Nutritional_Inputs.Contact_Details_Of_The_Allied_Health_Professional,
              label: 'Contact details of the Allied Health Professional',
              multiline: true,
              placeholder: 'Write contact details of the Allied Health Professional',
              validationSchema: Yup.string().required('Write contact details of the Allied Health Professional'),
              required: true,
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.A_Family_Member_Will_Need_To_Take_The_Resident,
              value: undefined,
              label: 'A family member will need to take the resident',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.Transport_Is_Required,
              value: undefined,
              label: 'Transport is required',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.Payment_Is_Required,
              value: undefined,
              label: 'Payment is required',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ]
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.Items_Need_To_Be_Taken_To_The_Appointment,
              value: undefined,
              label: 'Items need to be taken to the appointment?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ],
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.What_Items_Are_Required_To_Be_Taken,
                    required: true,
                    validationSchema: Yup.string().required('Write items are required to be taken, referral, other'),
                    label: 'What items are required to be taken, referral, other',
                    placeholder: 'Describe what items are required to be taken',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Nutritional_Nutritional_Inputs.An_Interpreter_Is_Require,
              value: undefined,
              label: 'An interpreter is required?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              conditions: [
                {[Nutritional_Nutritional_Inputs.Update_To_Nutrition]: Nutritional_Nutritional_Inputs.Referral_To_Speech_Pathologist_Dietician}
              ],
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.RadioInput,
                    className: styles.padding_1,
                    name: Nutritional_Nutritional_Inputs.Interpreter_Has_Been_Booked,
                    required: true,
                    validationSchema: Yup.string().required('Select one'),
                    value: undefined,
                    label: 'Interpreter has been booked',
                    radios: [
                      {value: RadioBoolean.Yes, label: 'Yes'},
                      {value: RadioBoolean.No, label: 'No'},
                    ],
                  },
                ]
              },
            },
/*             {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Nutritional_Nutritional_Inputs.How_Is_The_Resident,
              label: 'How is the resident?',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              placeholder: 'Write how is the resident feeling',
              required: true,
              validationSchema: Yup.string().required('Write how is the resident feeling'),
            }, */
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              name: Nutritional_Nutritional_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },

  [Sections.Resident_Of_The_Day]: {
    [Resident_Of_The_Day_SubSections.Resident_Of_The_Day]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
        `
          ${mainValues.firstName} has been reviewed by the care team today.
          We have completed a series of checks on ${mainValues.firstName} and their room.

          
          ${UpdateMessageSymbols.Paragraph_Break}
          ${inputsValues[Resident_Of_The_Day_Inputs.Checklist] === Resident_Of_The_Day_Inputs.All_Observations_Within_Normal_Range
            ? 'All observations within normal range. No issues to report. '
            : `All observations within normal range other than the following: ${inputsValues[Resident_Of_The_Day_Inputs.Outline_Key_Findings]}.`}

          ${UpdateMessageSymbols.Paragraph_Break}
          ${inputsValues[Resident_Of_The_Day_Inputs.Has_There_Been_Change_To_Weigh] === RadioBoolean.Yes
            ? `Current weight - ${inputsValues[Resident_Of_The_Day_Inputs.Write_current_weight]}kg${UpdateMessageSymbols.Line_Break}Previous weight - ${inputsValues[Resident_Of_The_Day_Inputs.Write_previous_weight]}kg${UpdateMessageSymbols.Line_Break}Weight ${getWeightGainOrLoss(inputsValues[Resident_Of_The_Day_Inputs.Write_current_weight], inputsValues[Resident_Of_The_Day_Inputs.Write_previous_weight])} - ${formattedFloat(Math.abs(inputsValues[Resident_Of_The_Day_Inputs.Write_previous_weight] - inputsValues[Resident_Of_The_Day_Inputs.Write_current_weight]),3)}kg (Percentage change - ${getWeightPercentageChange(inputsValues[Resident_Of_The_Day_Inputs.Write_current_weight], inputsValues[Resident_Of_The_Day_Inputs.Write_previous_weight])}%)
               `
            : ''}
 
          ${UpdateMessageSymbols.Paragraph_Break}
          How is ${mainValues.firstName}? ${inputsValues[Resident_Of_The_Day_Inputs.How_Is_The_Resident]}.

          ${inputsValues[Resident_Of_The_Day_Inputs.Other_Information]
           ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Resident_Of_The_Day_Inputs.Other_Information]}.`
           : ''} 
        `),
      steps: [
        {
          inputs: [
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: Resident_Of_The_Day_Inputs.All_Observations_Within_Normal_Range, label: 'All observations within normal range. No issues to report.'},
                {value: Resident_Of_The_Day_Inputs.The_Following_Issues_Were_Found, label: 'The following issues were found.'},
              ],
              name: Resident_Of_The_Day_Inputs.Checklist,
              value: undefined,
              label: 'Please select one',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [Resident_Of_The_Day_Inputs.The_Following_Issues_Were_Found]: [
                  {
                    type: UpdateInputsTypes.TextInput,
                    multiline: true,
                    className: styles.padding_1,
                    name: Resident_Of_The_Day_Inputs.Outline_Key_Findings,
                    required: true,
                    validationSchema: Yup.string().required('Write what is outline key findings'),
                    label: 'Outline key findings',
                    placeholder: 'Describe what is outline key findings',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.RadioInput,
              radios: [
                {value: RadioBoolean.Yes, label: 'Yes'},
                {value: RadioBoolean.No, label: 'No'},
              ],
              name: Resident_Of_The_Day_Inputs.Has_There_Been_Change_To_Weigh,
              value: undefined,
              label: 'Has there been a change to weight?',
              required: true,
              validationSchema: Yup.string().required('Please select one'),
              dependentInputs: {
                [RadioBoolean.Yes]: [
                  {
                    type: UpdateInputsTypes.NumberInput,
                    className: styles.padding_1,
                    name: Resident_Of_The_Day_Inputs.Write_previous_weight,
                    required: true,
                    validationSchema: Yup.string().required('Write previous weight'),
                    label: 'Previous to weight',
                    placeholder: 'Write previous weight',
                  },
                  {
                    type: UpdateInputsTypes.NumberInput,
                    className: styles.padding_1,
                    name: Resident_Of_The_Day_Inputs.Write_current_weight,
                    required: true,
                    validationSchema: Yup.string().required('Write current weight'),
                    label: 'Current weight',
                    placeholder: 'Write current weight',
                  },
                ]
              },
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Resident_Of_The_Day_Inputs.How_Is_The_Resident,
              label: 'How is the resident',
              placeholder: 'Write how is the resident',
              subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
              validationSchema: Yup.string().required('Write how is the resident'),
              required: true,
            },
            {
              type: UpdateInputsTypes.TextInput,
              multiline: true,
              value: undefined,
              name: Resident_Of_The_Day_Inputs.Other_Information,
              label: 'Further information',
              placeholder: 'Please write any further information that will be helpful for the family to know ',
            },
          ]
        }
      ]
    },
  },
  [Sections.Other]: {
    [Other_SubSections.Other]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Sharing an update from our team about ${mainValues.firstName}:
          ${inputsValues[Other_Other_Inputs.Describe_The_Update]}. 
          ${inputsValues[Other_Other_Inputs.How_Is_The_Resident] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Other_Other_Inputs.How_Is_The_Resident]}.
            ` : ''}

          ${inputsValues[Other_Other_Inputs.Other_Information]
            ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Other_Other_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          ${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 0 ? 
            `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.employeeName} has obtained consent from ${mainValues.firstName} to send ${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 'these' : 'this'} photo${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 's' : ''} in this update.`
            :
            ``
          }
          `
        ),
        messageMultiple: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Sharing an update from our team about ${residentsStore.getMultipleUpdateSelectedResidents()?.map((selectedResident) => selectedResident.firstName).join(', ')}:
          ${inputsValues[Other_Other_Inputs.Describe_The_Update]}. 

          ${inputsValues[Other_Other_Inputs.Other_Information]
            ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Other_Other_Inputs.Other_Information]}.`
            : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? UpdateMessageSymbols.Paragraph_Break
            : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
            ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
            : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
          ${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 0 ? 
            `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.employeeName} has obtained consents from residents to send ${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 'these' : 'this'} photo${inputsValues[Other_Other_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 's' : ''} in this update.`
            :
            ``
          }
          `
          ),
      steps: getOtherSteps()
    },
  },
  [Sections.Social]: {
    [Social_SubSections.Social]: {
      message: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Sharing an update from our team about ${mainValues.firstName}:
          ${inputsValues[Social_Social_Inputs.Describe_The_Update]}. 
          ${inputsValues[Social_Social_Inputs.How_Is_The_Resident] ? `
            ${UpdateMessageSymbols.Paragraph_Break}
            How is ${mainValues.firstName}? ${inputsValues[Social_Social_Inputs.How_Is_The_Resident]}.
            ` : ''}

          ${inputsValues[Social_Social_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Social_Social_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
                    ${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 0 ? 
            `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.employeeName} has obtained consent from ${mainValues.firstName} to send ${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 'these' : 'this'} photo${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 's' : ''} in this update.`
            :
            ``
          }
          `
      ),
      messageMultiple: (mainValues: IMainUpdateForm, inputsValues: Array<{[key in InputsName]: any}>) => formatSummaryMessage(
          `Sharing an update from our team about ${residentsStore.getMultipleUpdateSelectedResidents()?.map((selectedResident) => selectedResident.firstName).join(', ')}:
          ${inputsValues[Social_Social_Inputs.Describe_The_Update]}. 

          ${inputsValues[Social_Social_Inputs.Other_Information]
              ? `${UpdateMessageSymbols.Paragraph_Break} Further information: ${inputsValues[Social_Social_Inputs.Other_Information]}.`
              : ''} 
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? UpdateMessageSymbols.Paragraph_Break
              : ''}
          ${mainValues.phoneCall && mainValues.phoneCall !== PhoneCall.NOT_REQUIRED
              ? `${`${PhoneCallNames[mainValues.phoneCall]({names: mainValues.phoneCallNames})}.`}.`
              : ''}
            ${mainValues.primaryCallBack && mainValues.phoneCall === PhoneCall.ATTEMPTED_TO_CALL
              ? `${UpdateMessageSymbols.Paragraph_Break} Can the primary contact, ${mainValues.primaryContactName !== '' ? mainValues.primaryContactName + ", " : ''}please call us back when available. `
              : ''
          }
                              ${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 0 ? 
            `${UpdateMessageSymbols.Paragraph_Break} ${mainValues.employeeName} has obtained consents from residents to send ${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 'these' : 'this'} photo${inputsValues[Social_Social_Inputs.Files]?.filter((file) => isImageFile(file) )?.length > 1 ? 's' : ''} in this update.`
            :
            ``
          }
          `
      ),
      steps: getSocialSteps()
    },
  },
  [Sections.Monthly_Care_Statement]: {
    [Monthly_Care_Statement_SubSections.Monthly_Care_Statement]: {
      message: (_mainValues: IMainUpdateForm, _inputsValues: any) => '',
      steps: [],
    },
  },
}

function getOtherSteps(): any {
  return !!residentsStore.getMultipleUpdateSelectedResidents() ? [{
    inputs: [
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Other_Other_Inputs.Describe_The_Update,
        label: 'Describe the update',
        placeholder: 'Write the update',
        validationSchema: Yup.string().required('Write the update'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Other_Other_Inputs.Other_Information,
        label: 'Further information',
        placeholder: 'Please write any further information that will be helpful for the family to know ',
      },
      {
        type: UpdateInputsTypes.File,
        value: undefined,
        name: Other_Other_Inputs.Files,
        label: 'files',
      },
    ]
  }] : [{
    inputs: [
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Other_Other_Inputs.Describe_The_Update,
        label: 'Describe the update',
        placeholder: 'Write the update',
        validationSchema: Yup.string().required('Write the update'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Other_Other_Inputs.How_Is_The_Resident,
        label: 'How is the resident',
        placeholder: 'Write how is the resident',
        subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
        validationSchema: Yup.string().required('Write how is the resident'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Other_Other_Inputs.Other_Information,
        label: 'Further information',
        placeholder: 'Please write any further information that will be helpful for the family to know ',
      },
      {
        type: UpdateInputsTypes.File,
        value: undefined,
        name: Other_Other_Inputs.Files,
        label: 'files',
      },
    ]
  }]
}

function getSocialSteps(): any {
  return !!residentsStore.getMultipleUpdateSelectedResidents() ? [{
    inputs: [
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Social_Social_Inputs.Describe_The_Update,
        label: 'Describe the update',
        placeholder: 'Write the update',
        validationSchema: Yup.string().required('Write the update'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Social_Social_Inputs.Other_Information,
        label: 'Further information',
        placeholder: 'Please write any further information that will be helpful for the family to know ',
      },
      {
        type: UpdateInputsTypes.File,
        value: undefined,
        name: Social_Social_Inputs.Files,
        label: 'files',
      },
    ]
  }] : [{
    inputs: [
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Social_Social_Inputs.Describe_The_Update,
        label: 'Describe the update',
        placeholder: 'Write the update',
        validationSchema: Yup.string().required('Write the update'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Social_Social_Inputs.How_Is_The_Resident,
        label: 'How is the resident',
        placeholder: 'Write how is the resident',
        subLabel: 'What have they done today (e.g. rested, participated in activities)?\nHave they left their room or not? Have they been eating / drinking?\nIn pain or not? Current emotions and mood?',
        validationSchema: Yup.string().required('Write how is the resident'),
        required: true,
      },
      {
        type: UpdateInputsTypes.TextInput,
        multiline: true,
        value: undefined,
        name: Social_Social_Inputs.Other_Information,
        label: 'Further information',
        placeholder: 'Please write any further information that will be helpful for the family to know ',
      },
      {
        type: UpdateInputsTypes.File,
        value: undefined,
        name: Social_Social_Inputs.Files,
        label: 'files',
      },
    ]
  }]
}

export function changeMultipleOtherInputs(schema: any) {
  schema.current[Sections.Other][Other_SubSections.Other].steps = getOtherSteps();
  schema.current[Sections.Social][Social_SubSections.Social].steps = getSocialSteps();
}

export function getUpdateSchema(section?: Sections, subSection?: SubSections, initialSchema?: IInitialSchema) {
  const cloneSchema = deepClone(UpdateSchema) as IUpdateSchema;

  if(section && subSection && initialSchema?.steps) {
    cloneSchema[section][subSection].steps = initialSchema.steps;
  } 

  return cloneSchema
}

